import type { Zone } from '@seek/audience-zones';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A string that corresponds to one of the company brands like seek, jora etc */
  Brand: any;
  /** A string that corresponds to a country code from the [alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) set of country codes defined in the [ISO 3166 standard](https://en.wikipedia.org/wiki/ISO_3166). Example: `AU`. */
  CountryCodeIso2: string;
  /** A string that corresponds to an alphabetic currency code defined in the [ISO 4217 standard](https://en.wikipedia.org/wiki/ISO_4217). Example: `AUD`. */
  CurrencyCodeIso: string;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A string representing an email address. Emails are validated against this [regex](https://github.com/SEEK-Jobs/validators-js/blob/master/src/validators/emailFormat/emailFormat.ts#L1). Example: `test@example.com`. */
  Email: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A string that corresponds to a job search query. */
  JobSearchQueryString: any;
  /** A string that corresponds to a language code defined in the [ISO 639-1 standard](https://en.wikipedia.org/wiki/ISO_639-1). Example: `en`. */
  LanguageCodeIso: string;
  /** ISO-639-1 language codes and ISO-3166-1-alpha-2 country codes, separated by '-' */
  Locale: any;
  /** The `PositiveInt` scalar type represents non-fractional unsigned whole numeric values with a value greater than 0. */
  PositiveInt: any;
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: any;
  /** Used to determine which smarter search cluster (URL) to use, valid values: default, ph-launch, end-state-launch */
  SmarterSearchCluster: any;
  /** A string that corresponds to an IANA timezone ID defined in the [IANA Time Zone Database](https://www.iana.org/time-zones). Example: `Australia/Melbourne`. */
  Timezone: any;
  /** A string representing a UUID. UUIDs are validated against this [regex](https://github.com/SEEK-Jobs/validators-js/blob/master/src/validators/uuid/isUuid.ts#L9). *Note:* The validation regex used does *not* conform to the UUID specification defined in [RFC 4122](https://tools.ietf.org/html/rfc4122), it is intentionally broader. Example: `f81d4fae-7dec-11d0-a765-00a0c91e6bf6`. */
  UUID: string;
  /** A string that corresponds to a SEEK zone defined in [RFC034](https://github.com/SEEK-Jobs/rfc/blob/master/RFC034-Audience-Zone-Identifiers.md). */
  Zone: Zone;
};

export type AccountBlockedError = I18nAccountError & {
  code: Scalars['String'];
  message: Scalars['String'];
  reason: Scalars['String'];
};


export type AccountBlockedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type AccountStatus = {
  candidate: AccountStatusType;
  hirer: AccountStatusType;
  realmHint: Scalars['String'];
};

export enum AccountStatusType {
  Found = 'found',
  NotFound = 'notFound'
}

export type AccountValidationError = I18nAccountError & {
  code: Scalars['String'];
  details: Array<I18nAccountFieldError>;
  message: Scalars['String'];
  reason: Scalars['String'];
};


export type AccountValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type Actor = {
  /** Email address of the actor. */
  email: Scalars['String'];
  /** The Auth0 user id of the actor, eg 'samlp|seek-okta-global|tkilvington@seek.com.au'. */
  id: Scalars['String'];
};

export type Advertiser = {
  id: Scalars['ID'];
  isVerified: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  registrationDate: Maybe<SeekDateTime>;
};


export type AdvertiserNameArgs = {
  locale?: Scalars['Locale'];
};

export enum AlertType {
  Info = 'Info',
  Promote = 'Promote'
}

export type AnswerForQuestionInput = {
  id: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  uri: InputMaybe<Scalars['String']>;
};

export type ApacSavedSearch = {
  /** Display count for saved search (max 99+) */
  countLabel: Scalars['String'];
  countryCode: Scalars['String'];
  createdDate: SeekDateTime;
  id: Scalars['ID'];
  lastExecutionDate: Maybe<SeekDateTime>;
  modifiedDate: Maybe<SeekDateTime>;
  name: Scalars['String'];
  newToYouCountLabel: Maybe<Scalars['String']>;
  query: SavedSearchApacQuery;
  subscribeToNewJobs: Scalars['Boolean'];
};


export type ApacSavedSearchCountLabelArgs = {
  cluster: InputMaybe<Scalars['SmarterSearchCluster']>;
};


export type ApacSavedSearchNameArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
};


export type ApacSavedSearchQueryArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
};

export type ApacSavedSearchConnection = {
  edges: Array<ApacSavedSearchEdge>;
  pageInfo: PageInfo;
};

export type ApacSavedSearchEdge = {
  cursor: Scalars['String'];
  node: ApacSavedSearch;
};

export type ApplicantCount = JobInsight & {
  count: Scalars['Int'];
  message: Scalars['String'];
};


export type ApplicantCountMessageArgs = {
  locale: Scalars['Locale'];
};

export type ApplicantsWithCoverLetterPercentage = JobInsight & {
  message: Scalars['String'];
  percentage: Scalars['Float'];
};


export type ApplicantsWithCoverLetterPercentageMessageArgs = {
  locale: Scalars['Locale'];
};

export type ApplicantsWithResumePercentage = JobInsight & {
  message: Scalars['String'];
  percentage: Scalars['Float'];
};


export type ApplicantsWithResumePercentageMessageArgs = {
  locale: Scalars['Locale'];
};

export type ApplicationChannel = {
  label: Maybe<Scalars['String']>;
};


export type ApplicationChannelLabelArgs = {
  locale: Scalars['Locale'];
};

export type ApplicationContextInput = {
  build: InputMaybe<Scalars['String']>;
  channel: InputMaybe<Platform>;
  /** client generated */
  key: Scalars['UUID'];
  /** application bundleId */
  namespace: InputMaybe<Scalars['String']>;
  version: InputMaybe<Scalars['String']>;
};

export type ApplicationDocuments = {
  lastAppliedResumeIdPrefill: Maybe<Scalars['String']>;
  lastWrittenCoverLetter: Maybe<LastWrittenCoverLetter>;
  selectionCriteriaRequired: Scalars['Boolean'];
};

export type ApplicationInsightsStatistic = {
  message: Scalars['String'];
};


export type ApplicationInsightsStatisticMessageArgs = {
  locale?: Scalars['Locale'];
};

export type ApplicationProfile = {
  name: Maybe<Scalars['String']>;
};

export type ApplicationRestricted = ApplicationChannel & {
  label: Scalars['String'];
};


export type ApplicationRestrictedLabelArgs = {
  locale: Scalars['Locale'];
};

export type AppliedForRoleCount = ApplicationInsightsStatistic & {
  count: Scalars['Int'];
  message: Scalars['String'];
};


export type AppliedForRoleCountMessageArgs = {
  locale?: Scalars['Locale'];
};

export type AppliedJob = {
  applicationInsights: Array<ApplicationInsightsStatistic>;
  appliedAt: SeekDateTime;
  createdAt: SeekDateTime;
  documents: Maybe<AppliedJobDocuments>;
  downloadLinks: Maybe<AppliedJobDownloadLinks>;
  events: Array<AppliedJobEvent>;
  hasAppliedWithCoverLetter: Scalars['Boolean'];
  hasAppliedWithResume: Scalars['Boolean'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  isExternal: Scalars['Boolean'];
  job: Job;
  notes: Maybe<Scalars['String']>;
};

export type AppliedJobConnection = {
  edges: Array<AppliedJobEdge>;
  pageInfo: PageInfo;
};

export type AppliedJobDocuments = {
  coverLetter: Maybe<CoverLetterAppliedJobDocument>;
  resume: Maybe<ResumeAppliedJobDocument>;
};

export type AppliedJobDownloadLinks = {
  coverLetter: Maybe<Scalars['String']>;
  resume: Maybe<Scalars['String']>;
};

export type AppliedJobEdge = {
  cursor: Scalars['String'];
  node: AppliedJob;
};

export type AppliedJobEvent = {
  status: AppliedJobStatus;
  timestamp: SeekDateTime;
};

export type AppliedJobSortByInput = {
  applicationDate: InputMaybe<Sort>;
  companyName: InputMaybe<Sort>;
  jobTitle: InputMaybe<Sort>;
};

export enum AppliedJobStatus {
  Applied = 'Applied',
  NotSuitable = 'NotSuitable',
  Viewed = 'Viewed'
}

export type AppliedWithCoverLetterPercentage = ApplicationInsightsStatistic & {
  message: Scalars['String'];
  percentage: Scalars['Float'];
};


export type AppliedWithCoverLetterPercentageMessageArgs = {
  locale?: Scalars['Locale'];
};

export type AppliedWithResumePercentage = ApplicationInsightsStatistic & {
  message: Scalars['String'];
  percentage: Scalars['Float'];
};


export type AppliedWithResumePercentageMessageArgs = {
  locale?: Scalars['Locale'];
};

export type Approachability = {
  approachable: Scalars['Boolean'];
};

export type AttachmentMetadata = {
  contentType: Maybe<Scalars['String']>;
  fileName: Maybe<Scalars['String']>;
  virusScanStatus: VirusScanStatus;
};

export enum AttachmentType {
  CoverLetter = 'CoverLetter',
  SelectionCriteria = 'SelectionCriteria'
}

export enum AttributionSource {
  AppliedJobs = 'APPLIED_JOBS',
  ApplySuccess = 'APPLY_SUCCESS',
  Home = 'HOME',
  JobDetails = 'JOB_DETAILS',
  LoggedOutHome = 'LOGGED_OUT_HOME',
  Recommendations = 'RECOMMENDATIONS'
}

export type Availability = {
  description: Scalars['String'];
  id: Scalars['Int'];
};

export type AvailabilityOption = {
  /** Human readable string used when the user is selecting an availability option. */
  description: Scalars['String'];
  /** Unique ID used to identify a specific availability option */
  id: Scalars['Int'];
};

export type Award = {
  description: Scalars['String'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  year: Scalars['Int'];
};

export type Banner = {
  analytics: Maybe<Scalars['JSON']>;
  id: Maybe<Scalars['String']>;
  template: Maybe<BannerTemplate>;
};

export type BannerHeading = {
  style: Maybe<BannerStyle>;
  text: Maybe<Scalars['String']>;
};

export type BannerImage = {
  url: Maybe<Scalars['String']>;
  urlDark: Maybe<Scalars['String']>;
};

export type BannerItems = {
  href: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
};

export type BannerLink = {
  style: Maybe<BannerStyle>;
  text: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export enum BannerPlacement {
  MobileHome = 'MOBILE_HOME',
  SerpFooterLinks = 'SERP_FOOTER_LINKS'
}

export type BannerStyle = {
  backgroundColor: Maybe<Scalars['String']>;
  backgroundColorDark: Maybe<Scalars['String']>;
  color: Maybe<Scalars['String']>;
  colorDark: Maybe<Scalars['String']>;
};

export type BannerTemplate = {
  heading: Maybe<BannerHeading>;
  id: Maybe<Scalars['String']>;
  image: Maybe<BannerImage>;
  items: Array<BannerItems>;
  link: Maybe<BannerLink>;
  style: Maybe<BannerStyle>;
};

export type BaseCredential = {
  credentialInfo: Array<CredentialInfo>;
  deleteVerificationUrl: Scalars['String'];
  expiryStatus: Maybe<CredentialExpiryStatus>;
  manageVerificationUrl: Scalars['String'];
  verification: CredentialVerification;
};

export type BaseVerifiableCredential = {
  label: Scalars['String'];
};

export type BasicBranding = {
  brandId: Maybe<Scalars['String']>;
  cover: Maybe<Scalars['String']>;
  logo: Maybe<Scalars['String']>;
};

export type Branding = {
  cover: Maybe<Cover>;
  logo: Maybe<Scalars['String']>;
};

export enum Company_Group {
  Industry = 'INDUSTRY'
}

export enum Company_Sort_By {
  ReviewsCount = 'REVIEWS_COUNT'
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Candidate = {
  /**
   * Unique candidate ID.
   * Note: This is a temporary field. We cannot change `id` to string format
   * right now because of dependency on long tail apps.
   */
  _id: Scalars['ID'];
  apacSavedSearches: Maybe<Array<ApacSavedSearch>>;
  appliedJob: Maybe<AppliedJob>;
  appliedJobs: AppliedJobConnection;
  /** @deprecated Candidates have received sufficeint notice of migration since Unification completed */
  appliedJobsMigrationMessage: Maybe<Scalars['String']>;
  /** Candidate's approachability */
  approachability: Approachability;
  attachmentMetadata: Maybe<AttachmentMetadata>;
  availability: Maybe<Availability>;
  /** Career Objectives for candidate */
  careerObjectives: Maybe<CareerObjectives>;
  /** Current location for this candidate */
  currentLocation2: Maybe<Location2>;
  /** Temporary document download link for a given resource id (Type could be a Resume, Cover Letter, or Selection Criteria) */
  documentDownloadLink: Maybe<DocumentDownloadLink>;
  /** Form data for clients to upload documents(documents type could be a Resume, Cover Letter, or Selection Criteria) */
  documentUploadFormData: Maybe<DocumentUploadFormData>;
  emailAddress: Scalars['Email'];
  /** @deprecated Use viewer.trackingId */
  emailCorrelationId: Scalars['String'];
  /**
   * External Id (candidate)
   * Note: This is a temporary field used to identify the candidate within APAC (Asia) Domain
   */
  externalId: Maybe<Scalars['ID']>;
  /** Unique candidate ID in numeric format */
  id: Scalars['Int'];
  /** Identity of the currently authenticated user. */
  identity: Identity;
  /** Determines whether an authenticated user is associated with a candidate record. */
  isAccountProvisioned: Maybe<Scalars['Boolean']>;
  /** Candidate's language proficiencies */
  languageProficiencies: Array<LanguageProficiency>;
  /** Licences */
  licences: Array<Licence>;
  /**
   * Candidate's work notice period length
   * @deprecated Use availability instead
   */
  noticePeriod: Maybe<NoticePeriod>;
  /** @deprecated Unstable. Not yet available for production use. DO NOT USE */
  notificationCTPPreferenceGroups: Maybe<Array<NotificationCtpPreferenceGroup>>;
  notificationPreferenceGroups: Maybe<Array<NotificationPreferenceGroup>>;
  onboardingComplete: Maybe<Scalars['Boolean']>;
  /**
   * *Note*: The default values for the parameters to this query are `"AU"`
   * and `"en"` respectively, *not* `false` as they in the playground.
   */
  personalDetails: PersonalDetails;
  /** Preferred classification for this candidate */
  preferredClassification: Maybe<Classification>;
  /** All preferred locations for this candidate */
  preferredLocations2: Array<Location2>;
  /** The insights of profile interactions for this candidate */
  profileInsights: Maybe<ProfileInsights>;
  profileSuggestions: Maybe<Array<ProfileSuggestion>>;
  /** The verified and verifiable data for this candidate */
  profileVerifications: Maybe<ProfileVerifications>;
  /** Profile Visibility for candidate */
  profileVisibility: Maybe<ProfileVisibility>;
  /** A specific qualification for this candidate */
  qualification: Maybe<Qualification>;
  /** All qualifications for this candidate */
  qualifications: Array<Qualification>;
  /** Group candidate recommendations under one type */
  recommendations: Maybe<Recommendations>;
  /** A specific resume for this candidate */
  resume: Maybe<Resume>;
  /** All resumes for this candidate */
  resumes: Array<Resume>;
  /** Rights to work for candidate */
  rightsToWork: Array<RightToWork>;
  /**
   * Rights to work alert type for candidate
   * @deprecated No longer required
   */
  rightsToWorkAlert: RightsToWorkAlert;
  /** Specific role for candidate */
  role: Maybe<Role>;
  /** All roles for this candidate */
  roles: Array<Role>;
  salaryNudge: Maybe<CandidateSalaryNudge>;
  /**
   * Salary preferences for candidate. Description fields will be returned in the language
   * specified via the `languageCode` parameter.
   */
  salaryPreferences2: Array<SalaryPreference2>;
  savedJobs: SavedJobConnection;
  /**
   * Profile completeness score. The `zone` parameter restricts the tips returned so they are only relevant to the
   * brand associated with the zone provided.
   */
  score: ProfileScore;
  searchAppliedJobs: Array<SearchAppliedJobPartial>;
  searchSavedJobs: Array<SearchSavedJobPartial>;
  /** Displays data that a candidate has chosen to share via a public url */
  shareableProfile: ShareableProfile;
  /** Shareable Profile Settings */
  shareableProfileSettings: ShareableProfileSettings;
  /**
   * All skills for this candidate
   * @deprecated Use `viewer.skills2` instead
   */
  skills: Array<Skill>;
  /** All skills for this candidate */
  skills2: Maybe<Array<Skill>>;
  /** All suggested skills for this candidate */
  suggestedSkills: Array<Skill>;
  /** Unique tracking (candidate) ID in UUID format */
  trackingId: Scalars['ID'];
  /** Unconfirmed data for given context */
  unconfirmedDataForContext: UnconfirmedData;
  /**
   * Candidate context that can be persisted in cookies
   * @deprecated This field will always return null
   */
  userCookie: Maybe<UserCookie>;
  verificationNudges: Array<VerificationNudge>;
  /** @deprecated Please use viewer.profileVerifications instead */
  verifications: Maybe<Verifications>;
  /** The verified identity data for this candidate */
  verifiedIdentity: Maybe<VerifiedIdentity>;
  /** Candidate's work types */
  workTypes: Array<WorkType>;
  /** Candidate's years of experience */
  yearsOfExperience: Maybe<YearsOfExperience>;
};


export type CandidateAppliedJobArgs = {
  jobId: Scalars['ID'];
};


export type CandidateAppliedJobsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['Locale']>;
  sortBy: InputMaybe<AppliedJobSortByInput>;
};


export type CandidateAppliedJobsMigrationMessageArgs = {
  locale: Scalars['Locale'];
  zone: Scalars['Zone'];
};


export type CandidateAttachmentMetadataArgs = {
  blobUrl: Scalars['String'];
};


export type CandidateAvailabilityArgs = {
  languageCode: Scalars['LanguageCodeIso'];
};


export type CandidateCurrentLocation2Args = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  zone: Scalars['Zone'];
};


export type CandidateDocumentDownloadLinkArgs = {
  resourceId: Scalars['ID'];
  resourceType: DocumentResourceType;
};


export type CandidateDocumentUploadFormDataArgs = {
  id: InputMaybe<Scalars['UUID']>;
};


export type CandidateLicencesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']>;
};


export type CandidateNotificationCtpPreferenceGroupsArgs = {
  onlyProductionOption?: Scalars['Boolean'];
  zone: Scalars['Zone'];
};


export type CandidateNotificationPreferenceGroupsArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};


export type CandidatePersonalDetailsArgs = {
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
};


export type CandidatePreferredClassificationArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
};


export type CandidatePreferredLocations2Args = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  zone: Scalars['Zone'];
};


export type CandidateProfileInsightsArgs = {
  zone: Scalars['Zone'];
};


export type CandidateProfileSuggestionsArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
};


export type CandidateProfileVerificationsArgs = {
  locale: Scalars['Locale'];
  zone: Scalars['Zone'];
};


export type CandidateProfileVisibilityArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
};


export type CandidateQualificationArgs = {
  id: Scalars['UUID'];
  isUnifiedSite?: InputMaybe<Scalars['Boolean']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  zone?: Scalars['Zone'];
};


export type CandidateQualificationsArgs = {
  includeVerified?: InputMaybe<Scalars['Boolean']>;
  isUnifiedSite?: InputMaybe<Scalars['Boolean']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  status: InputMaybe<ConfirmedStatus>;
  zone?: InputMaybe<Scalars['Zone']>;
};


export type CandidateResumeArgs = {
  id: Scalars['UUID'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
};


export type CandidateResumesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
};


export type CandidateRightsToWorkArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  isUnifiedSite?: InputMaybe<Scalars['Boolean']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']>;
};


export type CandidateRightsToWorkAlertArgs = {
  countryCode: Scalars['CountryCodeIso2'];
};


export type CandidateRoleArgs = {
  id: Scalars['UUID'];
};


export type CandidateRolesArgs = {
  status: InputMaybe<ConfirmedStatus>;
};


export type CandidateSalaryNudgeArgs = {
  zone: Scalars['String'];
};


export type CandidateSalaryPreferences2Args = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
};


export type CandidateSavedJobsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type CandidateScoreArgs = {
  isUnifiedSite: InputMaybe<Scalars['Boolean']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  zone?: InputMaybe<Scalars['Zone']>;
};


export type CandidateSearchAppliedJobsArgs = {
  jobIds: Array<Scalars['String']>;
};


export type CandidateSearchSavedJobsArgs = {
  jobIds: Array<Scalars['String']>;
};


export type CandidateShareableProfileArgs = {
  profileSlug: Scalars['String'];
};


export type CandidateShareableProfileSettingsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  zone?: InputMaybe<Scalars['Zone']>;
};


export type CandidateSuggestedSkillsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  zone?: InputMaybe<Scalars['Zone']>;
};


export type CandidateUnconfirmedDataForContextArgs = {
  contextId: Scalars['String'];
  contextType: InputMaybe<UnconfirmedContextType>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
};


export type CandidateVerificationNudgesArgs = {
  jobId: Scalars['ID'];
  platform: Platform;
  selectedAnswerUris: Array<Scalars['String']>;
  source: SourceExperience;
};


export type CandidateVerificationsArgs = {
  testGroup: InputMaybe<VerificationsTestVariant>;
};


export type CandidateVerifiedIdentityArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  platform: Platform;
  source: SourceExperience;
  zone: Scalars['Zone'];
};


export type CandidateWorkTypesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
};


export type CandidateYearsOfExperienceArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
};

export type CandidateSalaryNudge = {
  callToActions: Array<CandidateSalaryNudgeCallToAction>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  prompt: Scalars['String'];
  text: Scalars['String'];
};

export type CandidateSalaryNudgeCallToAction = {
  displayText: Scalars['String'];
  /** The call to action submission operation */
  operation: Scalars['String'];
};

export type CandidateSalaryNudgeFeedbackPayload = {
  nudgeId: Scalars['ID'];
};

export type CareerObjectives = {
  personalStatement: Scalars['String'];
};

export type CategoryInfo = {
  label: Scalars['String'];
};


export type CategoryInfoLabelArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
};

export type ChangeEmailAddressFailure = {
  error: I18nAccountError;
};

export type ChangeEmailAddressInput = {
  isBGroup: InputMaybe<Scalars['Boolean']>;
  newEmailAddress: Scalars['String'];
  password: InputMaybe<Scalars['String']>;
};

export type ChangeEmailAddressPayload = ChangeEmailAddressFailure | ChangeEmailAddressSuccess;

export type ChangeEmailAddressSuccess = {
  ref: Scalars['UUID'];
};

export type ChangePasswordFailure = {
  error: Maybe<I18nAccountError>;
};

export type ChangePasswordInput = {
  newPassword: Scalars['String'];
  password: Scalars['String'];
};

export type ChangePasswordPayload = ChangePasswordFailure | ChangePasswordSuccess;

export type ChangePasswordSuccess = {
  ref: Scalars['UUID'];
};

export type ChildClassification = {
  description: Scalars['String'];
  id: Scalars['Int'];
};


export type ChildClassificationDescriptionArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
};

export type Classification = {
  description: Scalars['String'];
  id: Scalars['Int'];
  subClassification: SubClassification;
};

export type ClassificationInfo = {
  label: Scalars['String'];
};


export type ClassificationInfoLabelArgs = {
  languageCode: Scalars['LanguageCodeIso'];
};

export type ClassificationInput = {
  id: Scalars['Int'];
  subClassification: SubClassificationInput;
};

export type ClassificationOptions = {
  description: Scalars['String'];
  id: Scalars['Int'];
  subClassifications: Array<SubClassification>;
};

export type CommunityGuideline = {
  url: Scalars['String'];
};


export type CommunityGuidelineUrlArgs = {
  locale?: Scalars['Locale'];
  zone?: Scalars['Zone'];
};

export type CompanyGroupByInput = {
  group: Company_Group;
  value: Array<InputMaybe<Scalars['String']>>;
};

export type CompanyNameSlug = {
  companySlug: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type CompanyProfile = {
  /** @deprecated All company pages should display reviews */
  areReviewsEnabled: Scalars['Boolean'];
  awards: Array<Award>;
  branding: Maybe<Branding>;
  companyNameSlug: Scalars['String'];
  cultureAndValues: Maybe<CultureAndValues>;
  customStatement: Maybe<CustomStatement>;
  featured: Maybe<Featured>;
  id: Scalars['ID'];
  /** @deprecated Beta badge is not needed anymore */
  isBeta: Maybe<Scalars['Boolean']>;
  /** @deprecated All company pages are company profiles now */
  isCompanyProfile: Scalars['Boolean'];
  missionStatement: Maybe<MissionStatement>;
  name: Scalars['String'];
  overview: Maybe<Overview>;
  perksAndBenefits: Array<PerkAndBenefit>;
  profileUrl: Maybe<Scalars['String']>;
  /** @deprecated Use CompanyReviews query instead */
  reviews: Reviews;
  reviewsSummary: Maybe<ReviewsSummary>;
  reviewsUrl: Maybe<Scalars['String']>;
  /** @deprecated All company pages should display reviews */
  shouldDisplayReviews: Scalars['Boolean'];
  tracking: CompanyProfileTracking;
};


export type CompanyProfileReviewsArgs = {
  page: InputMaybe<Scalars['Int']>;
  perPage: InputMaybe<Scalars['Int']>;
};

export type CompanyProfileOverview = {
  description: Maybe<Array<Scalars['String']>>;
  industry: Maybe<Scalars['String']>;
  primaryLocation: Maybe<Scalars['String']>;
  size: Maybe<Scalars['String']>;
  specialities: Maybe<Array<Scalars['String']>>;
  website: Maybe<CompanyProfileWebsite>;
};

export type CompanyProfileReviewsSummary = {
  count: Maybe<Scalars['Int']>;
  rating: Maybe<Scalars['Float']>;
};

export type CompanyProfileTracking = {
  isCompanyProfile: Scalars['Boolean'];
};

export type CompanyProfileWebsite = {
  displayName: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CompanyReviewReply = {
  createdAt: SeekDateTime;
  from: Scalars['String'];
  text: Scalars['String'];
  userId: Scalars['String'];
};

export type CompanyReviews = {
  fullName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  rating: Scalars['Float'];
  reviewCount: Scalars['Int'];
  reviewsUrl: Scalars['String'];
};

export type CompanySize = {
  description: Scalars['String'];
};


export type CompanySizeDescriptionArgs = {
  locale?: Scalars['Locale'];
};

export type CompanyTag = {
  key: Scalars['String'];
  value: Scalars['String'];
};


export type CompanyTagKeyArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
};

export type CompletionDate = MonthYear | Year;

export type ConfirmQualificationInput = {
  completed: Scalars['Boolean'];
  completionYear: InputMaybe<Scalars['Int']>;
  expectedCompletionDate: InputMaybe<MonthYearInput>;
  highlights: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  institute: OntologyStructuredDataInput;
  /** Required for JobsDB only */
  level2: InputMaybe<Scalars['String']>;
  name: OntologyStructuredDataInput;
  tracking: InputMaybe<TrackingInfoInput>;
};

export type ConfirmQualificationPayload = {
  /** @deprecated Use viewer.qualifications */
  ref: Maybe<Scalars['UUID']>;
  viewer: Maybe<Candidate>;
};

export type ConfirmRoleInput = {
  achievements: InputMaybe<Scalars['String']>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  /** Required for JobsDB only */
  function: InputMaybe<RoleFunctionInput>;
  id: Scalars['UUID'];
  /** Required for JobsDB only */
  industry: InputMaybe<RoleIndustryInput>;
  seniority: InputMaybe<OntologyStructuredDataInput>;
  title: OntologyStructuredDataInput;
  to: InputMaybe<MonthYearInput>;
  tracking: InputMaybe<TrackingInfoInput>;
};

export type ConfirmRolePayload = {
  /** @deprecated Use viewer.roles */
  role: Role;
  viewer: Maybe<Candidate>;
};

export enum ConfirmedStatus {
  Confirmed = 'confirmed',
  Unconfirmed = 'unconfirmed'
}

export type ConsentTransactionDetails = {
  /** The name of the hirer requesting consent */
  hirerName: Scalars['String'];
  /** The name of the partner requesting consent */
  partnerName: Scalars['String'];
  /** The partner redirectUri in the event of a consent rejection or error */
  redirectUri: Scalars['String'];
};

export type ConsentTransactionDetailsInput = {
  transactionId: Scalars['UUID'];
};

export type ContactMatches = {
  type: Scalars['String'];
  value: Scalars['String'];
};

export type Country = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export type CountryCallingCode = {
  /** Country calling code prefixed with a `+`, e.g. `+61` */
  countryCallingCode: Scalars['String'];
  /**
   * Human-readable description of the country calling code; contains the country
   * associated with the code as well as the code itself, e.g. `Australia (+61)`.
   */
  description: Scalars['String'];
  /** Unique ID used to identify a specific country calling code */
  id: Scalars['ID'];
};

export type CountryCallingCodeInput = {
  /** Unique ID corresponding to a `CountryCallingCode` */
  id: Scalars['ID'];
};

export enum CountryCode {
  Au = 'au',
  Nz = 'nz',
  Sg = 'sg'
}

export type CountryInformation = {
  /** The country's ISO 3166-1 alpha-2 country code */
  countryCode: Scalars['CountryCodeIso2'];
  /** The country's name */
  name: Scalars['String'];
};

export type Cover = {
  aspectRatio: Maybe<Scalars['Float']>;
  url: Scalars['String'];
};

export type CoverLetterAppliedJobDocument = {
  attachmentMetadata: AttachmentMetadata;
  blobUrl: Scalars['String'];
  downloadLink: Maybe<Scalars['String']>;
};

export type CoverLetterInput = {
  uri: Scalars['String'];
  writtenText: InputMaybe<Scalars['String']>;
};

export type CreateApacSavedSearchDuplicateError = CreateApacSavedSearchError & {
  message: Scalars['String'];
};


export type CreateApacSavedSearchDuplicateErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateApacSavedSearchError = {
  message: Scalars['String'];
};


export type CreateApacSavedSearchErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateApacSavedSearchErrorMaxExceeded = CreateApacSavedSearchError & {
  message: Scalars['String'];
  savedSearchLimit: Scalars['Int'];
};


export type CreateApacSavedSearchErrorMaxExceededMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateApacSavedSearchFailure = {
  error: CreateApacSavedSearchError;
};

export type CreateApacSavedSearchInput = {
  isUnified: InputMaybe<Scalars['Boolean']>;
  searchQueryString: Scalars['JobSearchQueryString'];
  zone: Scalars['Zone'];
};

export type CreateApacSavedSearchInvalidLocationError = CreateApacSavedSearchError & {
  message: Scalars['String'];
};


export type CreateApacSavedSearchInvalidLocationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateApacSavedSearchPayload = CreateApacSavedSearchFailure | CreateApacSavedSearchSuccess;

export type CreateApacSavedSearchSuccess = {
  savedSearch: ApacSavedSearch;
};

export type CreateConsentError = {
  message: Scalars['String'];
};


export type CreateConsentErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateConsentFailure = {
  errors: Array<CreateConsentError>;
};

export type CreateConsentInput = {
  transactionId: Scalars['UUID'];
};

export type CreateConsentPayload = CreateConsentFailure | CreateConsentSuccess;

export type CreateConsentSuccess = {
  redirectUri: Scalars['String'];
};

export type CreateConsentTransactionInvalidError = CreateConsentError & {
  message: Scalars['String'];
};


export type CreateConsentTransactionInvalidErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateSavedJobError = {
  message: Scalars['String'];
};


export type CreateSavedJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateSavedJobFailure = {
  errors: Array<CreateSavedJobError>;
};

export type CreateSavedJobInput = {
  eventCaptureData: InputMaybe<SavedJobEventCaptureDataInput>;
  id: Scalars['ID'];
  zone: InputMaybe<Scalars['Zone']>;
};

export type CreateSavedJobPayload = CreateSavedJobFailure | CreateSavedJobSuccess;

export type CreateSavedJobSuccess = {
  id: Scalars['ID'];
  zone: Maybe<Scalars['Zone']>;
};

export type CreateSavedJobValidationError = CreateSavedJobError & {
  message: Scalars['String'];
};


export type CreateSavedJobValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateSeekMaxCommentBlockedWordsError = CreateSeekMaxCommentError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxCommentBlockedWordsErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxCommentBlockedWordsErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxCommentError = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxCommentErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxCommentErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxCommentExceedRateLimitError = CreateSeekMaxCommentError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxCommentExceedRateLimitErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxCommentExceedRateLimitErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxCommentFailure = {
  errors: Array<CreateSeekMaxCommentError>;
};

export type CreateSeekMaxCommentInput = {
  content: Scalars['String'];
  /** @deprecated Use zone instead - https://myseek.atlassian.net/browse/CNC-4651 */
  locale: InputMaybe<Scalars['Locale']>;
  threadId: Scalars['ID'];
  zone: InputMaybe<Scalars['Zone']>;
};

export type CreateSeekMaxCommentPayload = CreateSeekMaxCommentFailure | CreateSeekMaxCommentSuccess;

export type CreateSeekMaxCommentSuccess = {
  id: Scalars['ID'];
};

export type CreateSeekMaxCommentUserIsBannedError = CreateSeekMaxCommentError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxCommentUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxCommentUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxModuleBookmarkError = {
  message: Scalars['String'];
};


export type CreateSeekMaxModuleBookmarkErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxModuleBookmarkFailure = {
  errors: Array<CreateSeekMaxModuleBookmarkError>;
};

export type CreateSeekMaxModuleBookmarkPayload = CreateSeekMaxModuleBookmarkFailure | CreateSeekMaxModuleBookmarkSuccess;

export type CreateSeekMaxModuleBookmarkSuccess = {
  id: Scalars['ID'];
};

export type CreateSeekMaxReplyBlockedWordsError = CreateSeekMaxReplyError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxReplyBlockedWordsErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxReplyBlockedWordsErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxReplyError = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxReplyErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxReplyErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxReplyExceedRateLimitError = CreateSeekMaxReplyError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxReplyExceedRateLimitErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxReplyExceedRateLimitErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxReplyFailure = {
  errors: Array<CreateSeekMaxReplyError>;
};

export type CreateSeekMaxReplyInput = {
  commentId: Scalars['ID'];
  content: Scalars['String'];
  /** @deprecated Use zone instead - https://myseek.atlassian.net/browse/CNC-4651 */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  threadId: Scalars['ID'];
  zone: InputMaybe<Scalars['Zone']>;
};

export type CreateSeekMaxReplyPayload = CreateSeekMaxReplyFailure | CreateSeekMaxReplySuccess;

export type CreateSeekMaxReplySuccess = {
  id: Scalars['ID'];
};

export type CreateSeekMaxReplyUserIsBannedError = CreateSeekMaxReplyError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxReplyUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxReplyUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxThreadAttachmentInput = {
  filename: Scalars['String'];
  type: SeekMaxAttachmentType;
};

export type CreateSeekMaxThreadBlockedWordsError = CreateSeekMaxThreadError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxThreadBlockedWordsErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxThreadBlockedWordsErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxThreadError = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxThreadErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxThreadErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxThreadExceedRateLimitError = CreateSeekMaxThreadError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxThreadExceedRateLimitErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxThreadExceedRateLimitErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxThreadFailure = {
  errors: Array<CreateSeekMaxThreadError>;
};

export type CreateSeekMaxThreadInput = {
  attachments: InputMaybe<Array<CreateSeekMaxThreadAttachmentInput>>;
  category: SeekMaxCategory;
  description: Scalars['String'];
  locale: Scalars['Locale'];
};

export type CreateSeekMaxThreadPayload = CreateSeekMaxThreadFailure | CreateSeekMaxThreadSuccess;

export type CreateSeekMaxThreadSuccess = {
  attachmentsToUpload: Maybe<Array<SeekMaxAttachmentUploadReady>>;
  thread: SeekMaxThread;
};

export type CreateSeekMaxThreadUserIsBannedError = CreateSeekMaxThreadError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type CreateSeekMaxThreadUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type CreateSeekMaxThreadUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type CreateSeekMaxThreadV2Input = {
  attachments: InputMaybe<Array<CreateSeekMaxThreadAttachmentInput>>;
  categoryId: Scalars['ID'];
  description: Scalars['String'];
  zone: Scalars['Zone'];
};

export type CreateShareableProfileSettingsError = {
  message: Scalars['String'];
};


export type CreateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateShareableProfileSettingsFailure = {
  error: CreateShareableProfileSettingsError;
};

export type CreateShareableProfileSettingsPayload = CreateShareableProfileSettingsFailure | CreateShareableProfileSettingsSuccess;

export type CreateShareableProfileSettingsSuccess = {
  viewer: Maybe<Candidate>;
};

export type CreateUnregisteredApacSavedSearchDuplicateError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String'];
};


export type CreateUnregisteredApacSavedSearchDuplicateErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateUnregisteredApacSavedSearchError = {
  message: Scalars['String'];
};


export type CreateUnregisteredApacSavedSearchErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateUnregisteredApacSavedSearchErrorMaxExceeded = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String'];
  savedSearchLimit: Scalars['Int'];
};


export type CreateUnregisteredApacSavedSearchErrorMaxExceededMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateUnregisteredApacSavedSearchInvalidChecksumError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String'];
};


export type CreateUnregisteredApacSavedSearchInvalidChecksumErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateUnregisteredApacSavedSearchInvalidEmailError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String'];
};


export type CreateUnregisteredApacSavedSearchInvalidEmailErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateUnregisteredApacSavedSearchInvalidLocationError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String'];
};


export type CreateUnregisteredApacSavedSearchInvalidLocationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type CreateUnregisteredApacSavedSearchWithChecksumFailure = {
  error: CreateUnregisteredApacSavedSearchError;
};

export type CreateUnregisteredApacSavedSearchWithChecksumInput = {
  checksum: Scalars['String'];
  emailAddress: Scalars['Email'];
  isUnified: InputMaybe<Scalars['Boolean']>;
  searchQueryString: Scalars['JobSearchQueryString'];
  zone: Scalars['Zone'];
};

export type CreateUnregisteredApacSavedSearchWithChecksumPayload = CreateUnregisteredApacSavedSearchWithChecksumFailure | CreateUnregisteredApacSavedSearchWithChecksumSuccess;

export type CreateUnregisteredApacSavedSearchWithChecksumSuccess = {
  id: Scalars['ID'];
};

export enum CredentialExpiryStatus {
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON'
}

export type CredentialInfo = {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export enum CredentialStatus {
  Expired = 'Expired',
  /** @deprecated No longer shown in UI */
  ExpiresSoon = 'ExpiresSoon',
  New = 'New'
}

export type CredentialVerification = {
  result: Scalars['String'];
};

export type CultureAndValues = {
  description: Scalars['String'];
  imageUrl: Scalars['String'];
  title: Scalars['String'];
  values: Array<CultureValue>;
};

export type CultureValue = {
  description: Scalars['String'];
  title: Scalars['String'];
};

export type CurrentLocation2Input = {
  id: Scalars['Int'];
};

export type CustomStatement = {
  description: Description;
  title: Scalars['String'];
};

export enum DateTimeContext {
  JobPosted = 'JOB_POSTED',
  SeekmaxPollDurationLeft = 'SEEKMAX_POLL_DURATION_LEFT'
}

export enum DateTimeLength {
  Long = 'LONG',
  Short = 'SHORT'
}

export type DefaultCurrency = {
  code: Scalars['String'];
};

export type DefaultGenerateCoverLetterError = GenerateCoverLetterError & {
  message: Scalars['String'];
};


export type DefaultGenerateCoverLetterErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type DefaultGenerateSelectionCriteriaError = GenerateSelectionCriteriaError & {
  message: Scalars['String'];
};


export type DefaultGenerateSelectionCriteriaErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type DeleteAccountFailure = {
  error: I18nAccountError;
};

export type DeleteAccountInput = {
  isBGroup: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
};

export type DeleteAccountPayload = DeleteAccountFailure | DeleteAccountSuccess;

export type DeleteAccountSuccess = {
  ref: Scalars['UUID'];
};

export type DeleteApacSavedSearchAbsentError = DeleteApacSavedSearchError & {
  message: Scalars['String'];
};


export type DeleteApacSavedSearchAbsentErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type DeleteApacSavedSearchError = {
  message: Scalars['String'];
};


export type DeleteApacSavedSearchErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type DeleteApacSavedSearchFailure = {
  errors: Array<DeleteApacSavedSearchError>;
};

export type DeleteApacSavedSearchInput = {
  id: Scalars['ID'];
};

export type DeleteApacSavedSearchPayload = DeleteApacSavedSearchFailure | DeleteApacSavedSearchSuccess;

export type DeleteApacSavedSearchSuccess = {
  id: Scalars['ID'];
};

export type DeleteAppliedJobError = {
  message: Scalars['String'];
};


export type DeleteAppliedJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type DeleteAppliedJobFailure = {
  errors: Array<DeleteAppliedJobError>;
};

export type DeleteAppliedJobInput = {
  id: Scalars['String'];
};

export type DeleteAppliedJobPayload = DeleteAppliedJobFailure | DeleteAppliedJobSuccess;

export type DeleteAppliedJobSuccess = {
  id: Scalars['String'];
};

export type DeleteAppliedJobValidationError = DeleteAppliedJobError & {
  message: Scalars['String'];
};


export type DeleteAppliedJobValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type DeleteLanguageProficiencyInput = {
  id: Scalars['UUID'];
};

export type DeleteLanguageProficiencyPayload = {
  viewer: Maybe<Candidate>;
};

export type DeleteLicenceInput = {
  id: Scalars['UUID'];
};

export type DeleteLicencePayload = {
  /** @deprecated Use viewer.licences */
  ref: Maybe<Scalars['String']>;
  viewer: Maybe<Candidate>;
};

export type DeleteQualificationInput = {
  id: Scalars['UUID'];
};

export type DeleteQualificationPayload = {
  /** @deprecated Use viewer.qualifications */
  id: Maybe<Scalars['UUID']>;
  viewer: Maybe<Candidate>;
};

export type DeleteResumeInput = {
  id: Scalars['UUID'];
};

export type DeleteResumePayload = {
  ref: Maybe<Scalars['UUID']>;
  viewer: Maybe<Candidate>;
};

export type DeleteRoleInput = {
  id: Scalars['UUID'];
};

export type DeleteRolePayload = {
  /** @deprecated Use viewer.roles */
  id: Scalars['UUID'];
  viewer: Maybe<Candidate>;
};

export type DeleteSavedJobError = {
  message: Scalars['String'];
};


export type DeleteSavedJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type DeleteSavedJobFailure = {
  errors: Array<DeleteSavedJobError>;
};

export type DeleteSavedJobInput = {
  eventCaptureData: InputMaybe<SavedJobEventCaptureDataInput>;
  id: Scalars['ID'];
};

export type DeleteSavedJobPayload = DeleteSavedJobFailure | DeleteSavedJobSuccess;

export type DeleteSavedJobSuccess = {
  id: Scalars['ID'];
};

export type DeleteSavedJobValidationError = DeleteSavedJobError & {
  message: Scalars['String'];
};


export type DeleteSavedJobValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type DeleteSeekMaxCommentAlreadyDeletedError = DeleteSeekMaxCommentError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxCommentAlreadyDeletedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxCommentAlreadyDeletedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxCommentError = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxCommentErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxCommentErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxCommentFailure = {
  errors: Array<DeleteSeekMaxCommentError>;
};

export type DeleteSeekMaxCommentInput = {
  id: Scalars['ID'];
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxCommentNotExistError = DeleteSeekMaxCommentError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxCommentNotExistErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxCommentNotExistErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxCommentPayload = DeleteSeekMaxCommentFailure | DeleteSeekMaxCommentSuccess;

export type DeleteSeekMaxCommentSuccess = {
  id: Scalars['ID'];
};

export type DeleteSeekMaxCommentUserIsBannedError = DeleteSeekMaxCommentError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxCommentUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxCommentUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxModuleBookmarkError = {
  message: Scalars['String'];
};


export type DeleteSeekMaxModuleBookmarkErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxModuleBookmarkFailure = {
  errors: Array<DeleteSeekMaxModuleBookmarkError>;
};

export type DeleteSeekMaxModuleBookmarkPayload = DeleteSeekMaxModuleBookmarkFailure | DeleteSeekMaxModuleBookmarkSuccess;

export type DeleteSeekMaxModuleBookmarkSuccess = {
  id: Scalars['ID'];
};

export type DeleteSeekMaxReplyAlreadyDeletedError = DeleteSeekMaxReplyError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxReplyAlreadyDeletedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxReplyAlreadyDeletedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxReplyError = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxReplyErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxReplyErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxReplyFailure = {
  errors: Array<DeleteSeekMaxReplyError>;
};

export type DeleteSeekMaxReplyInput = {
  countryCode: Scalars['CountryCodeIso2'];
  id: Scalars['ID'];
};

export type DeleteSeekMaxReplyNotExistError = DeleteSeekMaxReplyError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxReplyNotExistErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxReplyNotExistErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxReplyPayload = DeleteSeekMaxReplyFailure | DeleteSeekMaxReplySuccess;

export type DeleteSeekMaxReplySuccess = {
  id: Scalars['ID'];
};

export type DeleteSeekMaxReplyUserIsBannedError = DeleteSeekMaxReplyError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxReplyUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxReplyUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxThreadAlreadyDeletedError = DeleteSeekMaxThreadError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxThreadAlreadyDeletedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxThreadAlreadyDeletedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxThreadError = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxThreadErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxThreadErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxThreadFailure = {
  errors: Array<DeleteSeekMaxThreadError>;
};

export type DeleteSeekMaxThreadInput = {
  id: Scalars['ID'];
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxThreadNotExistError = DeleteSeekMaxThreadError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxThreadNotExistErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxThreadNotExistErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type DeleteSeekMaxThreadPayload = DeleteSeekMaxThreadFailure | DeleteSeekMaxThreadSuccess;

export type DeleteSeekMaxThreadSuccess = {
  id: Scalars['ID'];
};

export type DeleteSeekMaxThreadUserIsBannedError = DeleteSeekMaxThreadError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type DeleteSeekMaxThreadUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type DeleteSeekMaxThreadUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type Description = {
  full: Scalars['String'];
  paragraphs: Array<Scalars['String']>;
};

export type DeviceContextInput = {
  /** device country is different from brand country */
  country: InputMaybe<Scalars['String']>;
  /** client generated */
  key: Scalars['UUID'];
  /** IETF BCP 47 Language Tag */
  locale: InputMaybe<Scalars['String']>;
  manufacturer: InputMaybe<Scalars['String']>;
  model: InputMaybe<Scalars['String']>;
  os: InputMaybe<ExperimentDeviceOsInput>;
  type: InputMaybe<ExperimentDeviceType>;
};

export type DocumentDownloadLink = {
  link: Scalars['String'];
};

export enum DocumentResourceType {
  Resume = 'Resume'
}

export type DocumentUploadFormData = {
  formFields: Array<FormField>;
  key: Scalars['String'];
  link: Scalars['String'];
};

export type Duration = {
  label: Scalars['String'];
  lengthInSeconds: Scalars['Int'];
};

export type DurationLeft = {
  label: Scalars['String'];
};


export type DurationLeftLabelArgs = {
  locale: Scalars['Locale'];
};

export type EmployeeRecommendation = {
  description: Scalars['String'];
  rating: Scalars['String'];
  value: Scalars['Float'];
};


export type EmployeeRecommendationDescriptionArgs = {
  locale?: Scalars['Locale'];
};

export type Episodes = {
  /** @deprecated Client side will generate this localised text on their own */
  label: Scalars['String'];
};

export type ExactCommentSocialData = {
  likeCount: SocialMetric;
  replyCount: SocialMetric;
};

export type ExactModuleSocialData = {
  commentCount: SocialMetric;
  likeCount: SocialMetric;
  viewCount: Maybe<SocialMetric>;
};

export type ExactThreadSocialData = {
  commentAndReplyCount: SocialMetric;
  commentCount: SocialMetric;
  likeCount: SocialMetric;
};

export type ExperienceContextInput = {
  brand: InputMaybe<Scalars['Brand']>;
  country: InputMaybe<Scalars['CountryCodeIso2']>;
  /** client generated */
  key: Scalars['UUID'];
  /** IETF BCP 47 Language Tag */
  language: InputMaybe<Scalars['String']>;
};

export type ExperimentDeviceOsInput = {
  name: Scalars['String'];
  version: Scalars['String'];
};

export enum ExperimentDeviceType {
  Phone = 'PHONE',
  Tablet = 'TABLET'
}

export type FeatureFlag = {
  key: Scalars['String'];
  value: Maybe<Scalars['JSON']>;
};

export type FeatureFlagEvaluation = {
  error: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  reason: Scalars['String'];
  value: Maybe<Scalars['JSON']>;
  variation: Maybe<Scalars['String']>;
};

export type FeatureFlagInput = {
  advertiserId: InputMaybe<Scalars['String']>;
  companyId: InputMaybe<Scalars['String']>;
};

export type Featured = {
  description: Maybe<Description>;
  imageUrl: Maybe<Scalars['String']>;
  title: Scalars['String'];
  videoUrl: Maybe<Scalars['String']>;
};

export type FeedbackError = {
  message: Scalars['String'];
};


export type FeedbackErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type FeedbackFailure = {
  errors: Array<FeedbackError>;
};

export type FeedbackInput = {
  device: InputMaybe<Scalars['String']>;
  email: Scalars['Email'];
  message: Scalars['String'];
  zone: Scalars['Zone'];
};

export type FeedbackLoggedInInput = {
  device: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  zone: Scalars['Zone'];
};

export type FeedbackMessageMaxLengthError = FeedbackError & {
  message: Scalars['String'];
};


export type FeedbackMessageMaxLengthErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type FeedbackPayload = FeedbackFailure | FeedbackSuccess;

export type FeedbackSuccess = {
  ref: Scalars['UUID'];
};

export type FileMetadata = {
  name: Scalars['String'];
  sensitiveDataInfo: Maybe<SensitiveDataInfo>;
  size: Scalars['String'];
  /** @deprecated Use virusScanStatus. */
  status: FileMetadataStatus;
  uri: Scalars['String'];
  virusScanStatus: VirusScanStatus;
};

export enum FileMetadataStatus {
  HasVirus = 'HasVirus',
  Ok = 'OK',
  Pending = 'Pending',
  Unknown = 'Unknown'
}

export type FormField = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type FreeTextQuestion = Question & {
  id: Scalars['String'];
  text: Scalars['String'];
};

export type GfjInfo = {
  location: Maybe<GfjLocation>;
  workTypes: Maybe<GfjWorkTypes>;
};

export type GfjLocation = {
  country: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  postcode: Maybe<Scalars['String']>;
  region: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  suburb: Maybe<Scalars['String']>;
};


export type GfjLocationCountryArgs = {
  locale?: Scalars['Locale'];
};


export type GfjLocationRegionArgs = {
  locale?: Scalars['Locale'];
};


export type GfjLocationStateArgs = {
  locale?: Scalars['Locale'];
};


export type GfjLocationSuburbArgs = {
  locale?: Scalars['Locale'];
};

export type GfjWorkTypes = {
  label: Maybe<Array<Scalars['String']>>;
};

export type GenerateCoverLetterError = {
  message: Scalars['String'];
};


export type GenerateCoverLetterErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type GenerateCoverLetterFailure = {
  errors: Array<GenerateCoverLetterError>;
};

export type GenerateCoverLetterInput = {
  writtenText: Scalars['String'];
};

export type GenerateCoverLetterPayload = GenerateCoverLetterFailure | GenerateCoverLetterSuccess;

export type GenerateCoverLetterSuccess = {
  uri: Scalars['String'];
};

export type GenerateResumeFromProfileInput = {
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
};

export type GenerateResumeFromProfilePayload = {
  resume: Maybe<Resume>;
  viewer: Maybe<Candidate>;
};

export type GenerateSelectionCriteriaError = {
  message: Scalars['String'];
};


export type GenerateSelectionCriteriaErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type GenerateSelectionCriteriaFailure = {
  errors: Array<GenerateSelectionCriteriaError>;
};

export type GenerateSelectionCriteriaInput = {
  writtenText: Scalars['String'];
};

export type GenerateSelectionCriteriaPayload = GenerateSelectionCriteriaFailure | GenerateSelectionCriteriaSuccess;

export type GenerateSelectionCriteriaSuccess = {
  uri: Scalars['String'];
};

export type GroupedCompanies = {
  companies: Array<GroupedCompany>;
  groupName: Scalars['String'];
};

export type GroupedCompany = {
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type I18nAccountError = {
  code: Scalars['String'];
  message: Scalars['String'];
  reason: Scalars['String'];
};


export type I18nAccountErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type I18nAccountFieldError = I18nAccountError & {
  code: Scalars['String'];
  message: Scalars['String'];
  path: Maybe<I18nErrorPath>;
  reason: Scalars['String'];
};


export type I18nAccountFieldErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type I18nErrorPath = {
  field: Maybe<Scalars['String']>;
  path: Maybe<Scalars['String']>;
};

export type IJobProfileSalaryMatch = {
  label: Scalars['String'];
};


export type IJobProfileSalaryMatchLabelArgs = {
  locale: Scalars['Locale'];
};

export type IOntologyCountry = {
  id: Scalars['String'];
  isoCode: Scalars['String'];
  name: Scalars['String'];
};

export type IOntologyEducationProvider = {
  countries: Array<IOntologyCountry>;
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String'];
  matchedVariant: Scalars['String'];
  normalisedText: Scalars['String'];
};

export type IOntologyOrganisation = {
  countries: Array<IOntologyCountry>;
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String'];
  matchedVariant: Scalars['String'];
  normalisedText: Scalars['String'];
};

export type IOntologyQualification = {
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String'];
  matchedVariant: Scalars['String'];
  normalisedText: Scalars['String'];
  /** @deprecated Phasing out of UI */
  type: Array<QualificationLevel>;
};

export type IOntologyRoleTitleSeniority = {
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String'];
  matchedRoleTitleVariant: Scalars['String'];
  matchedSeniorityVariant: Maybe<Scalars['String']>;
  matchedVariant: Scalars['String'];
  normalisedText: Scalars['String'];
  seniorityId: Maybe<Scalars['String']>;
};

export type ISeekMaxAttachmentStatus = {
  id: Scalars['ID'];
};

export type ISeekMaxCategoryGroup = {
  groupId: Scalars['ID'];
};

export type ISeekMaxCertificateAttachmentStatus = {
  id: Scalars['ID'];
};

export type ISeekMaxKolGroup = {
  description: Scalars['String'];
};

export type ISeekMaxSearchContent = {
  id: Scalars['ID'];
};

export type ITrackSelected = {
  id: Scalars['String'];
  index: Scalars['Int'];
  session: Scalars['String'];
};

export type Identity = {
  /** Operator making requests on behalf of user. */
  actor: Maybe<Actor>;
  /**
   * Indicates that the user is CS operator, regardless of whether they're actively impersonating.
   * Either true or undefined.
   */
  allowImpersonation: Maybe<Scalars['Boolean']>;
  /** Indicates that the CS operator has enabled administrator mode. Either true or undefined. */
  showCustomerServiceView: Maybe<Scalars['Boolean']>;
  /** User requesting access to a resource. */
  subject: Subject;
};

export type IdentityVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String'];
  url: Scalars['String'];
};

export type Job = {
  abstract: Scalars['String'];
  advertiser: Advertiser;
  /** @deprecated Use classifications instead */
  categories: Maybe<CategoryInfo>;
  classifications: Array<ClassificationInfo>;
  contactMatches: Maybe<Array<ContactMatches>>;
  content: Scalars['String'];
  createdAt: SeekDateTime;
  expiredAt: Maybe<SeekDateTime>;
  expiresAt: SeekDateTime;
  id: Scalars['ID'];
  /** @deprecated Use job-details.isChatEligible instead. Will always return null. */
  isChatEligible: Scalars['Boolean'];
  isExpired: Scalars['Boolean'];
  /**
   * Used together with the Link-out system (Close the Loop system)
   * https://indie-jobapply-linkout-service.cloud.seek.com.au/job/<JOBID>
   * to retrieve the external link and record Candidate's action
   */
  isLinkOut: Scalars['Boolean'];
  isProfileApply: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  listedAt: Maybe<SeekDateTime>;
  location: LocationInfo;
  phoneNumber: Maybe<Scalars['String']>;
  products: Maybe<JobProducts>;
  salary: Maybe<JobSalary>;
  shareLink: Maybe<Scalars['String']>;
  source: Maybe<Scalars['String']>;
  sourceZone: Maybe<Scalars['String']>;
  status: Scalars['String'];
  title: Scalars['String'];
  tracking: Maybe<JobTracking>;
  updatedAt: SeekDateTime;
  workTypes: JobWorkTypes;
};


export type JobContentArgs = {
  platform: InputMaybe<Platform>;
};


export type JobShareLinkArgs = {
  locale: InputMaybe<Scalars['Locale']>;
  platform: Platform;
  zone: Scalars['Zone'];
};

export type JobApplicantsBadge = {
  label: Maybe<Scalars['String']>;
};

export type JobApplicationArea = {
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
};

export type JobApplicationClassification = {
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  subClassification: Maybe<JobApplicationSubClassification>;
};

export type JobApplicationInsights = {
  applicationTipsType: JobApplicationInsightsEnum;
  date: SeekDateTime;
  description: Scalars['String'];
  stats: Array<JobApplicationInsightsStat>;
  title: Scalars['String'];
};


export type JobApplicationInsightsDescriptionArgs = {
  locale?: Scalars['Locale'];
};


export type JobApplicationInsightsTitleArgs = {
  locale?: Scalars['Locale'];
};

export enum JobApplicationInsightsEnum {
  ActivityStatusNotSuitable = 'ACTIVITY_STATUS_NOT_SUITABLE',
  ActivityStatusViewed = 'ACTIVITY_STATUS_VIEWED'
}

export type JobApplicationInsightsStat = {
  stat: Scalars['String'];
  text: Scalars['String'];
};


export type JobApplicationInsightsStatTextArgs = {
  locale?: Scalars['Locale'];
};

export type JobApplicationLocation = {
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
};

export type JobApplicationProcess = {
  area: Maybe<JobApplicationArea>;
  classification: Maybe<JobApplicationClassification>;
  documents: ApplicationDocuments;
  extractedRoleTitles: Maybe<Array<Scalars['String']>>;
  /** Web apply url used by app legacy clients that may not be able to render the application requirements */
  fallbackUrl: Maybe<Scalars['String']>;
  job: Maybe<Job>;
  linkOut: Maybe<Scalars['Boolean']>;
  location: Maybe<JobApplicationLocation>;
  profile: Maybe<ApplicationProfile>;
  questionnaire: Maybe<Questionnaire>;
  state: Maybe<JobApplicationState>;
};


export type JobApplicationProcessFallbackUrlArgs = {
  zone: Scalars['Zone'];
};

export type JobApplicationState = {
  id: Maybe<Scalars['ID']>;
};

export type JobApplicationSubClassification = {
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
};

export type JobDetails = {
  /** Defines the type of application channel available to the candidate */
  applicationChannel: Maybe<ApplicationChannel>;
  companyProfile: Maybe<CompanyProfile>;
  companyReviews: Maybe<CompanyReviews>;
  companySearchUrl: Maybe<Scalars['String']>;
  companyTags: Array<CompanyTag>;
  /**
   * GFJInfo is used to provide information needed to show job postings on Google for Jobs.
   * This is strictly used for the above and should not be used for any other purpose.
   */
  gfjInfo: Maybe<GfjInfo>;
  /** The insights of job details */
  insights: Maybe<Array<Maybe<JobInsight>>>;
  /** isChatEligible is experimental and will be deprecated after the APEX chat POC is completed */
  isChatEligible: Maybe<Scalars['Boolean']>;
  job: Job;
  learningInsights: Maybe<LearningInsights>;
  personalised: Maybe<PersonalisedJobDetails>;
  /** Provides a message concerning whether a cadndidate may apply */
  restrictedApplication: JobDetailsRestrictedApplication;
  /**
   * SEOInfo is used to provide information for SEO initiatives within the JDV.
   * This is strictly used for the above and should not be used for any other purpose.
   */
  seoInfo: Maybe<SeoInfo>;
  /**
   * Sourcr is a Product used by Seek for matching recruiters email addresses and phone numbers
   * Note: it is not a misspelling
   * @deprecated Use sourcrRecruiter
   */
  sourcr: Maybe<JobDetailsSourcr>;
  sourcrRecruiter: Maybe<SourcrRecruiter>;
};


export type JobDetailsApplicationChannelArgs = {
  zone: Scalars['Zone'];
};


export type JobDetailsCompanyProfileArgs = {
  zone: Scalars['Zone'];
};


export type JobDetailsCompanyReviewsArgs = {
  zone: Scalars['Zone'];
};


export type JobDetailsCompanySearchUrlArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  zone: InputMaybe<Scalars['Zone']>;
};


export type JobDetailsLearningInsightsArgs = {
  locale?: Scalars['Locale'];
  platform: Platform;
  zone: Scalars['Zone'];
};


export type JobDetailsRestrictedApplicationArgs = {
  countryCode: Scalars['CountryCodeIso2'];
};

export type JobDetailsRestrictedApplication = {
  label: Maybe<Scalars['String']>;
};


export type JobDetailsRestrictedApplicationLabelArgs = {
  locale: Scalars['Locale'];
};

/**
 * Sourcr is a Product used by Seek for matching recruiters email addresses and phone numbers
 * Note: it is not a misspelling
 */
export type JobDetailsSourcr = {
  image: Scalars['String'];
  imageMobile: Scalars['String'];
  link: Scalars['String'];
};

export type JobDetailsTrackingInput = {
  channel: Scalars['String'];
  jobDetailsViewedCorrelationId: Scalars['String'];
  sessionId: Scalars['String'];
};

export type JobHistoryDateInput = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type JobHistoryInput = {
  from: JobHistoryDateInput;
  to: InputMaybe<JobHistoryDateInput>;
};

export type JobInput = {
  history: InputMaybe<JobHistoryInput>;
  isJobTitleAnonymised: InputMaybe<Scalars['Boolean']>;
  location: JobLocationEntityInput;
  roleTitleId: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
  workType: InputMaybe<Scalars['String']>;
};

export type JobInsight = {
  message: Scalars['String'];
};


export type JobInsightMessageArgs = {
  locale: Scalars['Locale'];
};

export type JobLocationEntityInput = {
  fullLocation: InputMaybe<Scalars['String']>;
  locationId: InputMaybe<Scalars['Int']>;
};

export type JobProductBranding = {
  cover: Maybe<JobProductBrandingImage>;
  id: Scalars['ID'];
  logo: JobProductBrandingImage;
};


export type JobProductBrandingCoverArgs = {
  isThumbnail?: InputMaybe<Scalars['Boolean']>;
};

export type JobProductBrandingImage = {
  aspectRatio: Maybe<Scalars['Float']>;
  url: Scalars['String'];
};

export type JobProducts = {
  branding: Maybe<JobProductBranding>;
  bullets: Maybe<Array<Scalars['String']>>;
  questionnaire: Maybe<JobQuestionnaire>;
  video: Maybe<VideoProduct>;
};

export type JobProfileMissingSalaryPreference = IJobProfileSalaryMatch & {
  label: Scalars['String'];
};


export type JobProfileMissingSalaryPreferenceLabelArgs = {
  locale: Scalars['Locale'];
};

export type JobProfileSalaryMatch = IJobProfileSalaryMatch & {
  label: Scalars['String'];
  salaryPreference: SalaryPreference2;
};


export type JobProfileSalaryMatchLabelArgs = {
  locale: Scalars['Locale'];
};


export type JobProfileSalaryMatchSalaryPreferenceArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  locale: Scalars['Locale'];
};

export type JobProfileSalaryNoMatch = IJobProfileSalaryMatch & {
  label: Scalars['String'];
};


export type JobProfileSalaryNoMatchLabelArgs = {
  locale: Scalars['Locale'];
};

/**
 * This is a simplified read-only questionnaire
 * which informs Candidates the questions they will
 * likely need to answer as part of the Application process
 */
export type JobQuestionnaire = {
  id: Scalars['ID'];
  questions: Array<Scalars['String']>;
};

export type JobSalary = {
  currencyLabel: Maybe<Scalars['String']>;
  label: Scalars['String'];
};


export type JobSalaryCurrencyLabelArgs = {
  zone: Scalars['Zone'];
};

export type JobTag = {
  label: Maybe<Scalars['String']>;
  type: Scalars['String'];
};


export type JobTagLabelArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type JobTracking = {
  adProductType: Maybe<Scalars['String']>;
  classificationInfo: Maybe<JobTrackingClassificationInfo>;
  hasRoleRequirements: Maybe<Scalars['Boolean']>;
  isPrivateAdvertiser: Maybe<Scalars['Boolean']>;
  isRightToWorkRequired: Maybe<Scalars['Boolean']>;
  isScreenAssigned: Maybe<Scalars['Boolean']>;
  locationInfo: Maybe<JobTrackingLocationInfo>;
  postedTime: Maybe<Scalars['String']>;
  workTypeIds: Maybe<Scalars['String']>;
};

export type JobTrackingClassificationInfo = {
  classification: Maybe<Scalars['String']>;
  classificationId: Maybe<Scalars['String']>;
  subClassification: Maybe<Scalars['String']>;
  subClassificationId: Maybe<Scalars['String']>;
};

export type JobTrackingLocationInfo = {
  area: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  locationIds: Maybe<Array<Scalars['String']>>;
};

export type JobWorkTypes = {
  label: Scalars['String'];
};


export type JobWorkTypesLabelArgs = {
  locale?: Scalars['Locale'];
};

export type KeyValue = {
  key: Scalars['String'];
  value: Scalars['JSON'];
};

export type KeyValueInput = {
  key: Scalars['String'];
  value: Scalars['JSON'];
};

export type KeywordSuggestion = {
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Array<SuggestionHighlight>;
  text: Scalars['String'];
};

/** KeywordSuggestionGroup is a collection of pre-defined suggestions e.g. Recent */
export type KeywordSuggestionGroup = {
  label: Scalars['String'];
  suggestions: Array<KeywordSuggestion>;
  type: SuggestionGroupType;
};

export type KeywordSuggestionType = KeywordSuggestion | KeywordSuggestionGroup;

export enum LanguageCode {
  En = 'en',
  Id = 'id',
  Ms = 'ms',
  Th = 'th',
  Tl = 'tl',
  Vi = 'vi'
}

export type LanguageProficiency = {
  id: Scalars['UUID'];
  name: OntologyStructuredData;
};

export type LastAnswer = {
  id: Scalars['String'];
  text: Scalars['String'];
  uri: Maybe<Scalars['String']>;
};

export type LastWrittenCoverLetter = {
  content: Scalars['String'];
  url: Scalars['String'];
};

export type LearningInsights = {
  action: Maybe<LearningInsightsAction>;
  analytics: Maybe<Scalars['JSON']>;
  content: Scalars['String'];
};

export type LearningInsightsAction = {
  label: Scalars['String'];
  url: Scalars['String'];
};

export type Licence = {
  credential: Maybe<BaseCredential>;
  credentialType: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  /** @deprecated No longer shown in UI. Use expiryStatus instead */
  expiryDate: Maybe<MonthYear>;
  formattedDate: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isVerified: Scalars['Boolean'];
  issueDate: Maybe<MonthYear>;
  issuingOrganisation: Maybe<Scalars['String']>;
  name: OntologyStructuredData;
  noExpiryDate: Scalars['Boolean'];
  status: Maybe<LicenceStatus>;
  verificationMessage: Maybe<Scalars['String']>;
  verificationUrl: Maybe<Scalars['String']>;
};

export enum LicenceStatus {
  Expired = 'Expired',
  /** @deprecated No longer shown in UI */
  ExpiresSoon = 'ExpiresSoon',
  New = 'New'
}

export type LicenceVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String'];
  /** String representing the entity type provided by Ontology for tracking purposes, e.g. 'Drivers Licence' */
  trackingEntityName: Maybe<Scalars['String']>;
  url: Scalars['String'];
  /** Translated string used to prompt verification of a licence, e.g. "Verify your Driver's Licence" */
  verificationMessage: Maybe<Scalars['String']>;
};

export type LinkoutChannel = ApplicationChannel & {
  label: Maybe<Scalars['String']>;
};


export type LinkoutChannelLabelArgs = {
  locale: Scalars['Locale'];
};

export type LiteProfileUpdateInput = {
  aboutYouEmail: Scalars['String'];
  aboutYouName: Scalars['String'];
  accountPrimaryContact: Scalars['String'];
  brandId: InputMaybe<Scalars['String']>;
  organisationName: Scalars['String'];
};

export type LiteProfileUpdateNotificationPayload = {
  success: Scalars['Boolean'];
};

export type Location2 = {
  countryCode: Scalars['CountryCodeIso2'];
  description: Scalars['String'];
  id: Scalars['Int'];
  isDeprecated: Maybe<Scalars['Boolean']>;
  kind: Scalars['String'];
  shortDescription: Scalars['String'];
};

export type LocationInfo = {
  label: Scalars['String'];
};


export type LocationInfoLabelArgs = {
  language: InputMaybe<Scalars['LanguageCodeIso']>;
  locale: InputMaybe<Scalars['Locale']>;
  type: InputMaybe<LocationLabelType>;
};

export enum LocationLabelType {
  Long = 'LONG',
  Short = 'SHORT'
}

export type LocationSuggestion = {
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String'];
  isGranular: Scalars['Boolean'];
  partnerId: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

/** LocationSuggestionGroup is a collection of pre-defined suggestions e.g. Recent or Suggested Area */
export type LocationSuggestionGroup = {
  label: Scalars['String'];
  suggestions: Array<LocationSuggestion>;
  type: SuggestionGroupType;
};

export type LocationSuggestionType = LocationSuggestion | LocationSuggestionGroup;

export type LoggedOutRecommendedGlobalJob = {
  job: Maybe<Job>;
  solMetadata: Scalars['JSON'];
};

export type LoggedOutRecommendedGlobalJobs = {
  globalJobs: Maybe<Array<Maybe<LoggedOutRecommendedGlobalJob>>>;
  solMetadata: Maybe<Scalars['JSON']>;
};

export type MkLocationSuggestion = {
  countryCode: Scalars['CountryCodeIso2'];
  id: Scalars['Int'];
  text: Scalars['String'];
};

export type MkLocationTrackSelectedResponse = {
  id: Scalars['Int'];
};

export type MarqueeCompanyProfile = {
  companyNameSlug: Maybe<Scalars['String']>;
  /** primary key: Company ID */
  id: Scalars['ID'];
  jobCount: Maybe<Scalars['Int']>;
  logo: Maybe<Scalars['String']>;
  /** foreign key: Ontology Organisation ID */
  organizationId: Maybe<Scalars['ID']>;
  reviews: Maybe<CompanyProfileReviewsSummary>;
  title: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type MatchedQualities = {
  inferred: Maybe<Array<Maybe<Skill>>>;
  matched: Maybe<Array<Maybe<Skill>>>;
  unmatched: Maybe<Array<Maybe<Skill>>>;
};

export type MatchedSkills = {
  inferred: Maybe<Array<Maybe<Quality>>>;
  matched: Maybe<Array<Maybe<Quality>>>;
  unmatched: Maybe<Array<Maybe<Quality>>>;
};

export type MissionStatement = {
  description: Description;
};

export type MobileNotiError = {
  message: Scalars['String'];
};


export type MobileNotiErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type MobileNotiFailure = {
  errors: Array<MobileNotiError>;
};

export type MobileNotiServiceUnavailableError = MobileNotiError & {
  message: Scalars['String'];
};


export type MobileNotiServiceUnavailableErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type MobileNotiUnknownError = MobileNotiError & {
  message: Scalars['String'];
};


export type MobileNotiUnknownErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type MobilePlatformNoti = {
  client: Scalars['String'];
  name: Scalars['String'];
  service: Scalars['String'];
};

export type MonthYear = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type MonthYearInput = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type MostRecentRoleInput = {
  company: Scalars['String'];
  finished: InputMaybe<MonthYearInput>;
  started: MonthYearInput;
  title: Scalars['String'];
};

export type MultipleChoiceQuestion = Question & {
  id: Scalars['String'];
  lastAnswers: Maybe<Array<LastAnswer>>;
  options: Array<QuestionOption>;
  text: Scalars['String'];
};

export type Mutation = {
  _empty: Maybe<Scalars['String']>;
  /** Add feedback for a salary nudge */
  addSalaryNudgeFeedback: CandidateSalaryNudgeFeedbackPayload;
  changeEmailAddress: Maybe<ChangeEmailAddressPayload>;
  changePassword: Maybe<ChangePasswordPayload>;
  confirmQualification: ConfirmQualificationPayload;
  confirmRole: Maybe<ConfirmRolePayload>;
  createApacSavedSearch: CreateApacSavedSearchPayload;
  /** Create a consent for a given transactionId */
  createConsent: CreateConsentPayload;
  createSavedJob2: CreateSavedJobPayload;
  createSeekMaxComment: CreateSeekMaxCommentPayload;
  createSeekMaxModuleBookmark: CreateSeekMaxModuleBookmarkPayload;
  createSeekMaxReply: CreateSeekMaxReplyPayload;
  /** @deprecated Client side will use createSeekMaxThreadV2 instead - https://myseek.atlassian.net/browse/CNC-4488 */
  createSeekMaxThread: CreateSeekMaxThreadPayload;
  createSeekMaxThreadV2: CreateSeekMaxThreadPayload;
  createShareableProfileSettings: CreateShareableProfileSettingsPayload;
  createUnregisteredApacSavedSearchWithChecksum: CreateUnregisteredApacSavedSearchWithChecksumPayload;
  deleteAccount: Maybe<DeleteAccountPayload>;
  deleteApacSavedSearch: DeleteApacSavedSearchPayload;
  deleteAppliedJob: DeleteAppliedJobPayload;
  deleteLanguageProficiency: DeleteLanguageProficiencyPayload;
  deleteLicence: DeleteLicencePayload;
  deleteQualification: Maybe<DeleteQualificationPayload>;
  /** Delete the specified from a candidates profile */
  deleteResume: Maybe<DeleteResumePayload>;
  deleteRole: Maybe<DeleteRolePayload>;
  deleteSavedJob2: DeleteSavedJobPayload;
  deleteSeekMaxComment: DeleteSeekMaxCommentPayload;
  deleteSeekMaxModuleBookmark: DeleteSeekMaxModuleBookmarkPayload;
  deleteSeekMaxReply: DeleteSeekMaxReplyPayload;
  deleteSeekMaxThread: DeleteSeekMaxThreadPayload;
  feedback: Maybe<FeedbackPayload>;
  feedbackLoggedIn: Maybe<FeedbackPayload>;
  generateCoverLetter: GenerateCoverLetterPayload;
  /**
   * This mutation will generate a resume from the candidates profile. The generated
   * resume will be stored in the profile.
   */
  generateResumeFromProfile: Maybe<GenerateResumeFromProfilePayload>;
  generateSelectionCriteria: GenerateSelectionCriteriaPayload;
  liteProfileUpdateNotification: Maybe<LiteProfileUpdateNotificationPayload>;
  mkTrackLocationSuggestionSelection: MkLocationTrackSelectedResponse;
  postCompanyProfileReviewFlag: Maybe<PostCompanyProfileReviewFlagPayload>;
  postCompanyProfileReviewUpvotes: Maybe<PostCompanyProfileReviewUpvotesPayload>;
  postCompanyReview: PostCompanyReviewPayload;
  /** This mutation is utilised to complete the uploading process. */
  processUploadedAttachment: Maybe<ProcessUploadedAttachmentPayload>;
  /**
   * This mutation is utilised to complete the uploading process. Plus, it also triggers the parsing for this resume
   * via the contextId passed by clients, and it is only used for uploading parsing.
   */
  processUploadedResume: Maybe<ProcessUploadedResumeResult>;
  provisionAccount: Maybe<ProvisionAccountPayload>;
  /** Reject consent for a given transactionId */
  rejectConsent: RejectConsentPayload;
  /** @deprecated Use rejectUnconfirmedData instead */
  rejectRole: Maybe<RejectRolePayload>;
  rejectUnconfirmedData: RejectUnconfirmedDataPayload;
  reportJob: ReportJobPayload;
  reportProfile: ReportProfilePayload;
  reportSeekMaxComment: ReportSeekMaxCommentPayload;
  reportSeekMaxReply: ReportSeekMaxReplyPayload;
  reportSeekMaxThread: ReportSeekMaxThreadPayload;
  /**
   * This mutation is only used for selected|scheduled resume parsing (selecting one of the previously uploaded resumes during
   * job apply process) and default resume parsing (making an uploaded resume the primary|default one on profile page),
   * the contextId set by clients is the key to this parsing.
   */
  requestResumeParsing: Maybe<MutationResult>;
  resubscribeApacSavedSearchByCode: ResubscribeApacSavedSearchByCodePayload;
  saveSeekMaxKeywordSearch: SaveSeekMaxKeywordSearchPayload;
  sendLoginCallbackEvent: Maybe<SendLoginCallbackEventPayload>;
  sendSeekMaxModuleClickedEvent: SendSeekMaxModuleClickedEventPayload;
  sendSeekMaxModuleClickedPersonalisationEvent: SeekMaxModuleClickedPersonalisationEventPayload;
  /** @deprecated Using deprecated resource API endpoint - https://myseek.atlassian.net/browse/CNC-3205 */
  sendSeekMaxModulePersonalisationEvent: SeekMaxModulePersonalisationEventPayload;
  sendSeekMaxModuleProgress: SeekMaxModuleProgressPayload;
  sendSeekMaxVideoViewedEvent: SeekMaxVideoViewedEventPayload;
  sendSeekMaxVideoViewedPersonalisationEvent: SeekMaxVideoViewedPersonalisationEventPayload;
  setAppliedJobNotes: SetAppliedJobNotesPayload;
  /** Set the default resume for a candidate. */
  setDefaultResume: Maybe<SetDefaultResumePayload>;
  setSavedJobNotes: SetSavedJobNotesPayload;
  setSeekMaxCategoryGroupFollowedStatus: SetSeekMaxCategoryGroupFollowedStatusPayload;
  setSeekMaxCommentLikedStatus: SetSeekMaxCommentLikedStatusPayload;
  setSeekMaxModuleLikedStatus: SetSeekMaxModuleLikedStatusPayload;
  setSeekMaxPreferredCategories: SetSeekMaxPreferredCategoriesPayload;
  setSeekMaxThreadLikedStatus: SetSeekMaxThreadLikedStatusPayload;
  setSeekMaxThreadPollStatus: SetSeekMaxThreadPollStatusPayload;
  submitApplication: SubmitApplicationPayload;
  subscribeApacSavedEmailAlert: SubscribeApacSavedEmailAlertPayload;
  subscribeMobileNotifications: SubscribeMobileNotiPayload;
  trackJobApplicationStarted: TrackJobApplicationStartedPayload;
  trackJobDetailsViewed: TrackJobDetailsViewedPayload;
  trackSearchResultSelected: TrackSearchResultSelectedPayload;
  unsubscribeApacSavedSearchByCode: UnsubscribeApacSavedSearchByCodePayload;
  unsubscribeMobileNotifications: UnsubscribeMobileNotiPayload;
  updateApproachability: UpdateApproachabilityPayload;
  updateAvailability: Maybe<UpdateNoticePeriodPayload>;
  updateCareerObjectives: Maybe<UpdateCareerObjectivesPayload>;
  updateCurrentLocation2: UpdateCurrentLocation2Payload;
  updateLanguageProficiency: UpdateLanguageProficiencyPayload;
  updateLicence: UpdateLicencePayload;
  /** @deprecated Use updateAvailability instead */
  updateNoticePeriod: Maybe<UpdateNoticePeriodPayload>;
  /** @deprecated Unstable. Not yet available for production use. DO NOT USE */
  updateNotificationCtpPreferences: Maybe<UpdateNotificationCtpPreferencesPayload>;
  /** @deprecated Unstable. Not yet available for production use. DO NOT USE */
  updateNotificationCtpSubscriptionWithToken: Maybe<UpdateNotificationCtpSubscriptionWithTokenPayload>;
  updateNotificationSubscription: Maybe<NotificationPreference>;
  updateNotificationSubscriptionWithToken: Maybe<NotificationPreference>;
  updatePersonalDetails: Maybe<UpdatePersonalDetailsPayload>;
  updatePreferredClassification: UpdatePreferredClassificationPayload;
  updatePreferredLocations2: UpdatePreferredLocations2Payload;
  updatePreferredWorkTypes: Maybe<UpdateWorkTypesPayload>;
  updateProfileVisibility: UpdateProfileVisibilityPayload;
  updateQualification: Maybe<UpdateQualificationPayload>;
  updateRightsToWork: UpdateRightsToWorkPayload;
  updateRole: Maybe<UpdateRolePayload>;
  updateSalaryPreferences: UpdateSalaryPreferencesPayload;
  updateSeekMaxMyThreadsLastViewed: Maybe<UpdateSeekMaxMyThreadsLastViewedPayload>;
  updateShareableProfileSettings: UpdateShareableProfileSettingsPayload;
  updateShareableProfileViews: UpdateShareableProfileViewsPayload;
  updateSkills: Maybe<UpdateSkillsPayload>;
  updateVerifiedLicence: UpdateVerifiedLicencePayload;
  updateVerifiedQualification: UpdateVerifiedQualificationPayload;
  updateYearsOfExperience: UpdateYearsOfExperiencePayload;
};


export type MutationAddSalaryNudgeFeedbackArgs = {
  nudgeId: Scalars['ID'];
  nudgeOption: Scalars['String'];
  zone: Scalars['String'];
};


export type MutationChangeEmailAddressArgs = {
  input: ChangeEmailAddressInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationConfirmQualificationArgs = {
  input: ConfirmQualificationInput;
};


export type MutationConfirmRoleArgs = {
  input: ConfirmRoleInput;
};


export type MutationCreateApacSavedSearchArgs = {
  input: CreateApacSavedSearchInput;
};


export type MutationCreateConsentArgs = {
  input: CreateConsentInput;
};


export type MutationCreateSavedJob2Args = {
  input: CreateSavedJobInput;
};


export type MutationCreateSeekMaxCommentArgs = {
  input: CreateSeekMaxCommentInput;
};


export type MutationCreateSeekMaxModuleBookmarkArgs = {
  input: SeekMaxModuleBookmarkInput;
};


export type MutationCreateSeekMaxReplyArgs = {
  input: CreateSeekMaxReplyInput;
};


export type MutationCreateSeekMaxThreadArgs = {
  input: CreateSeekMaxThreadInput;
};


export type MutationCreateSeekMaxThreadV2Args = {
  input: CreateSeekMaxThreadV2Input;
};


export type MutationCreateUnregisteredApacSavedSearchWithChecksumArgs = {
  input: CreateUnregisteredApacSavedSearchWithChecksumInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteApacSavedSearchArgs = {
  input: DeleteApacSavedSearchInput;
};


export type MutationDeleteAppliedJobArgs = {
  input: DeleteAppliedJobInput;
};


export type MutationDeleteLanguageProficiencyArgs = {
  input: DeleteLanguageProficiencyInput;
};


export type MutationDeleteLicenceArgs = {
  input: DeleteLicenceInput;
};


export type MutationDeleteQualificationArgs = {
  input: DeleteQualificationInput;
};


export type MutationDeleteResumeArgs = {
  input: DeleteResumeInput;
};


export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};


export type MutationDeleteSavedJob2Args = {
  input: DeleteSavedJobInput;
};


export type MutationDeleteSeekMaxCommentArgs = {
  input: DeleteSeekMaxCommentInput;
};


export type MutationDeleteSeekMaxModuleBookmarkArgs = {
  input: SeekMaxModuleBookmarkInput;
};


export type MutationDeleteSeekMaxReplyArgs = {
  input: DeleteSeekMaxReplyInput;
};


export type MutationDeleteSeekMaxThreadArgs = {
  input: DeleteSeekMaxThreadInput;
};


export type MutationFeedbackArgs = {
  input: FeedbackInput;
};


export type MutationFeedbackLoggedInArgs = {
  input: FeedbackLoggedInInput;
};


export type MutationGenerateCoverLetterArgs = {
  input: GenerateCoverLetterInput;
};


export type MutationGenerateResumeFromProfileArgs = {
  input?: InputMaybe<GenerateResumeFromProfileInput>;
};


export type MutationGenerateSelectionCriteriaArgs = {
  input: GenerateSelectionCriteriaInput;
};


export type MutationLiteProfileUpdateNotificationArgs = {
  input: LiteProfileUpdateInput;
};


export type MutationMkTrackLocationSuggestionSelectionArgs = {
  id: Scalars['Int'];
  session: Scalars['String'];
};


export type MutationPostCompanyProfileReviewFlagArgs = {
  input: PostCompanyProfileReviewFlagInput;
};


export type MutationPostCompanyProfileReviewUpvotesArgs = {
  input: PostCompanyProfileReviewUpvotesInput;
};


export type MutationPostCompanyReviewArgs = {
  input: PostCompanyReviewInput;
};


export type MutationProcessUploadedAttachmentArgs = {
  input: ProcessUploadedAttachmentInput;
};


export type MutationProcessUploadedResumeArgs = {
  input: ProcessUploadedResumeInput;
};


export type MutationProvisionAccountArgs = {
  zone: InputMaybe<Scalars['Zone']>;
};


export type MutationRejectConsentArgs = {
  input: RejectConsentInput;
};


export type MutationRejectRoleArgs = {
  input: RejectRoleInput;
};


export type MutationRejectUnconfirmedDataArgs = {
  input: RejectUnconfirmedDataInput;
};


export type MutationReportJobArgs = {
  input: ReportJobInput;
};


export type MutationReportProfileArgs = {
  input: ReportProfileInput;
};


export type MutationReportSeekMaxCommentArgs = {
  input: ReportSeekMaxCommentInput;
};


export type MutationReportSeekMaxReplyArgs = {
  input: ReportSeekMaxReplyInput;
};


export type MutationReportSeekMaxThreadArgs = {
  input: ReportSeekMaxThreadInput;
};


export type MutationRequestResumeParsingArgs = {
  input: RequestResumeParsingInput;
};


export type MutationResubscribeApacSavedSearchByCodeArgs = {
  input: ResubscribeApacSavedSearchByCodeInput;
};


export type MutationSaveSeekMaxKeywordSearchArgs = {
  input: SaveSeekMaxKeywordSearchInput;
};


export type MutationSendSeekMaxModuleClickedEventArgs = {
  input: SendSeekMaxModuleClickedEventInput;
};


export type MutationSendSeekMaxModuleClickedPersonalisationEventArgs = {
  input: SeekMaxModuleClickedPersonalisationEventInput;
};


export type MutationSendSeekMaxModulePersonalisationEventArgs = {
  input: SeekMaxModulePersonalisationEventInput;
};


export type MutationSendSeekMaxModuleProgressArgs = {
  input: SeekMaxModuleProgressInput;
};


export type MutationSendSeekMaxVideoViewedEventArgs = {
  input: SeekMaxVideoViewedEventInput;
};


export type MutationSendSeekMaxVideoViewedPersonalisationEventArgs = {
  input: SeekMaxVideoViewedPersonalisationEventInput;
};


export type MutationSetAppliedJobNotesArgs = {
  input: SetAppliedJobNotesInput;
};


export type MutationSetDefaultResumeArgs = {
  input: SetDefaultResumeInput;
};


export type MutationSetSavedJobNotesArgs = {
  input: SetSavedJobNotesInput;
};


export type MutationSetSeekMaxCategoryGroupFollowedStatusArgs = {
  input: SeekMaxCategoryGroupFollowInput;
};


export type MutationSetSeekMaxCommentLikedStatusArgs = {
  input: SeekMaxLikeInput;
};


export type MutationSetSeekMaxModuleLikedStatusArgs = {
  input: SeekMaxModuleLikeInput;
};


export type MutationSetSeekMaxPreferredCategoriesArgs = {
  input: SetSeekMaxPreferredCategoriesInput;
};


export type MutationSetSeekMaxThreadLikedStatusArgs = {
  input: SeekMaxLikeInput;
};


export type MutationSetSeekMaxThreadPollStatusArgs = {
  input: SeekMaxThreadPollInput;
};


export type MutationSubmitApplicationArgs = {
  input: SubmitApplicationInput;
};


export type MutationSubscribeApacSavedEmailAlertArgs = {
  input: SubscribeApacSavedEmailAlertInput;
};


export type MutationSubscribeMobileNotificationsArgs = {
  input: SubscribeMobileNoti;
};


export type MutationTrackJobApplicationStartedArgs = {
  input: TrackJobApplicationStartedInput;
};


export type MutationTrackJobDetailsViewedArgs = {
  input: TrackJobDetailsViewedInput;
};


export type MutationTrackSearchResultSelectedArgs = {
  input: TrackSearchResultSelectedInput;
};


export type MutationUnsubscribeApacSavedSearchByCodeArgs = {
  input: UnsubscribeApacSavedSearchByCodeInput;
};


export type MutationUnsubscribeMobileNotificationsArgs = {
  input: UnsubscribeMobileNoti;
};


export type MutationUpdateApproachabilityArgs = {
  input: UpdateApproachabilityInput;
};


export type MutationUpdateAvailabilityArgs = {
  input: UpdateAvailabilityInput;
};


export type MutationUpdateCareerObjectivesArgs = {
  input: UpdateCareerObjectivesInput;
};


export type MutationUpdateCurrentLocation2Args = {
  input: UpdateCurrentLocation2Input;
};


export type MutationUpdateLanguageProficiencyArgs = {
  input: UpdateLanguageProficiencyInput;
};


export type MutationUpdateLicenceArgs = {
  input: UpdateLicenceInput;
};


export type MutationUpdateNoticePeriodArgs = {
  input: UpdateNoticePeriodInput;
};


export type MutationUpdateNotificationCtpPreferencesArgs = {
  input: UpdateNotificationCtpPreferenceInput;
};


export type MutationUpdateNotificationCtpSubscriptionWithTokenArgs = {
  input: NotificationCtpSubscriptionWithTokenInput;
};


export type MutationUpdateNotificationSubscriptionArgs = {
  input: NotificationPreferenceInput;
};


export type MutationUpdateNotificationSubscriptionWithTokenArgs = {
  input: NotificationPreferenceWithTokenInput;
};


export type MutationUpdatePersonalDetailsArgs = {
  input: UpdatePersonalDetailsInput;
};


export type MutationUpdatePreferredClassificationArgs = {
  input: UpdateClassificationInput;
};


export type MutationUpdatePreferredLocations2Args = {
  input: UpdatePreferredLocations2Input;
};


export type MutationUpdatePreferredWorkTypesArgs = {
  input: UpdatePreferredWorkTypesInput;
};


export type MutationUpdateProfileVisibilityArgs = {
  input: UpdateProfileVisibilityInput;
};


export type MutationUpdateQualificationArgs = {
  input: UpdateQualificationInput;
};


export type MutationUpdateRightsToWorkArgs = {
  input: UpdateRightsToWorkInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateSalaryPreferencesArgs = {
  input: UpdateSalaryPreferencesInput;
};


export type MutationUpdateSeekMaxMyThreadsLastViewedArgs = {
  input: UpdateSeekMaxMyThreadsLastViewedInput;
};


export type MutationUpdateShareableProfileSettingsArgs = {
  input: UpdateShareableProfileSettingsInput;
};


export type MutationUpdateShareableProfileViewsArgs = {
  input: UpdateShareableProfileViewsInput;
};


export type MutationUpdateSkillsArgs = {
  input: UpdateSkillsInput;
};


export type MutationUpdateVerifiedLicenceArgs = {
  input: UpdateVerifiedLicenceInput;
};


export type MutationUpdateVerifiedQualificationArgs = {
  input: UpdateVerifiedQualificationInput;
};


export type MutationUpdateYearsOfExperienceArgs = {
  input: UpdateYearsOfExperienceInput;
};

export type MutationResult = {
  ref: Maybe<Scalars['UUID']>;
};

export type Nationality = {
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type NationalityInput = {
  id: Scalars['ID'];
};

export type NextRolePreferredLocation = {
  country: Maybe<Country>;
  description: Scalars['String'];
  id: Scalars['String'];
  parent: Maybe<NextRolePreferredLocation>;
  type: PreferredLocationType;
};

export type NoticePeriod = {
  weeks: Scalars['Int'];
};

export type NotificationCtpCategory = {
  description: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
};


export type NotificationCtpCategoryDescriptionArgs = {
  locale: Scalars['Locale'];
};


export type NotificationCtpCategoryLabelArgs = {
  locale: Scalars['Locale'];
  zone: Scalars['Zone'];
};

export type NotificationCtpChannel = {
  id: Scalars['String'];
  label: Scalars['String'];
};


export type NotificationCtpChannelLabelArgs = {
  locale: Scalars['Locale'];
};

export type NotificationCtpFrequency = {
  options: Array<NotificationCtpFrequencyOptions>;
  value: Scalars['String'];
};

export type NotificationCtpFrequencyOptions = {
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};


export type NotificationCtpFrequencyOptionsDescriptionArgs = {
  locale: Scalars['Locale'];
};


export type NotificationCtpFrequencyOptionsLabelArgs = {
  locale: Scalars['Locale'];
};

export type NotificationCtpPreference = {
  product: NotificationCtpProduct;
  subscriptions: Array<NotificationCtpSubscription>;
};

export type NotificationCtpPreferenceGroup = {
  category: NotificationCtpCategory;
  preferences: Array<NotificationCtpPreference>;
};

export type NotificationCtpProduct = {
  action: Maybe<NotificationCtpProductAction>;
  description: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
};


export type NotificationCtpProductDescriptionArgs = {
  locale: Scalars['Locale'];
  zone: Scalars['Zone'];
};


export type NotificationCtpProductLabelArgs = {
  locale: Scalars['Locale'];
};

export type NotificationCtpProductAction = {
  label: Scalars['String'];
  path: Scalars['String'];
};


export type NotificationCtpProductActionLabelArgs = {
  locale: Scalars['Locale'];
  zone: Scalars['Zone'];
};

export type NotificationCtpSubscription = {
  channel: NotificationCtpChannel;
  frequency: Maybe<NotificationCtpFrequency>;
  id: Scalars['ID'];
  subscribed: Scalars['Boolean'];
  token: Maybe<Scalars['String']>;
};

export type NotificationCategory = {
  code: Scalars['String'];
  description: Scalars['String'];
};

export type NotificationChannel = {
  code: Scalars['String'];
  label: Scalars['String'];
};

export type NotificationChannelInput = {
  channel: NotificationCtpChannelType;
  frequency: InputMaybe<NotificationCtpFrequencyType>;
  reason: NotificationCtpUpdateReasonType;
  subscribe: Scalars['Boolean'];
};

export enum NotificationCtpChannelType {
  Email = 'email',
  Push = 'push'
}

export enum NotificationCtpFrequencyType {
  Daily = 'daily',
  Dynamic = 'dynamic',
  Weekly = 'weekly'
}

export type NotificationCtpPreferenceError = {
  errorCode: Maybe<Scalars['Int']>;
  message: Scalars['String'];
};


export type NotificationCtpPreferenceErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export enum NotificationCtpPreferenceProductType {
  AppAdExpired = 'AppAdExpired',
  AppConfirmed = 'AppConfirmed',
  AppNotSuitable = 'AppNotSuitable',
  AppViewed = 'AppViewed',
  AppliedJobsActivity = 'AppliedJobsActivity',
  CareerHubReengageExplore = 'CareerHubReengageExplore',
  CareerHubThreadReply = 'CareerHubThreadReply',
  MarketingAdviceTips = 'MarketingAdviceTips',
  MarketingNewsletter = 'MarketingNewsletter',
  MarketingPartnerUpdates = 'MarketingPartnerUpdates',
  MarketingProductUpdates = 'MarketingProductUpdates',
  MarketingProfileUpdate = 'MarketingProfileUpdate',
  MarketingSurveyResearch = 'MarketingSurveyResearch',
  NewJob = 'NewJob',
  ReminderToApply = 'ReminderToApply',
  SavedSearch = 'SavedSearch',
  SearchesToSave = 'SearchesToSave',
  TopApplicant = 'TopApplicant',
  Wru = 'WRU'
}

export type NotificationCtpPreferencesInput = {
  id: NotificationCtpPreferenceProductType;
  notificationsChannel: Array<NotificationChannelInput>;
};

export type NotificationCtpSubscriptionWithTokenInput = {
  locale: InputMaybe<Scalars['Locale']>;
  subscribe: Scalars['Boolean'];
  token: Scalars['String'];
};

export enum NotificationCtpUpdateReasonType {
  ClickOps = 'clickOps',
  Customer = 'customer',
  ImportOld = 'importOld',
  LegalRequirement = 'legalRequirement',
  PreferenceUi = 'preferenceUI',
  Sunrise = 'sunrise',
  Sunset = 'sunset',
  Tcpd = 'tcpd',
  UnificationHistorical = 'unificationHistorical',
  UnificationLiveSync = 'unificationLiveSync',
  Unknown = 'unknown',
  UpdateWithToken = 'updateWithToken'
}

export type NotificationFrequency = {
  options: Array<NotificationFrequencyOptions>;
  value: Scalars['String'];
};

export type NotificationFrequencyOptions = {
  code: Scalars['String'];
  description: Maybe<Scalars['String']>;
  label: Scalars['String'];
};

export type NotificationPreference = {
  category: NotificationCategory;
  product: NotificationProduct;
  subscriptions: Array<NotificationSubscription>;
};

export type NotificationPreferenceGroup = {
  category: NotificationCategory;
  notificationPreferences: Array<NotificationPreference>;
};

export type NotificationPreferenceInput = {
  channelCode: Scalars['String'];
  frequency: InputMaybe<Scalars['String']>;
  locale: InputMaybe<Scalars['Locale']>;
  productCode: Scalars['String'];
  subscribe: Scalars['Boolean'];
};

export type NotificationPreferenceWithTokenInput = {
  locale: InputMaybe<Scalars['Locale']>;
  subscribe: Scalars['Boolean'];
  token: Scalars['String'];
};

export type NotificationProduct = {
  code: Scalars['String'];
  description: Maybe<Scalars['String']>;
  label: Scalars['String'];
};

export type NotificationSubscription = {
  channel: NotificationChannel;
  frequency: Maybe<NotificationFrequency>;
  id: Scalars['ID'];
  subscribed: Scalars['Boolean'];
};

export type NumberOfReviews = {
  description: Scalars['String'];
  value: Scalars['Int'];
};


export type NumberOfReviewsDescriptionArgs = {
  locale: Scalars['Locale'];
};

export type OntologySpecReq = {
  collectExpiry: Scalars['Boolean'];
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String'];
  matchedVariant: Scalars['String'];
  normalisedText: Scalars['String'];
  verificationUrl: Maybe<Scalars['String']>;
};


export type OntologySpecReqVerificationUrlArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']>;
};

export type OntologyStructuredData = {
  ontologyId: Maybe<Scalars['ID']>;
  text: Scalars['String'];
};

export type OntologyStructuredDataInput = {
  ontologyId: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
};

export enum OntologyType {
  EducationProviders = 'EDUCATION_PROVIDERS',
  Organisations = 'ORGANISATIONS',
  Qualifications = 'QUALIFICATIONS',
  RoletitlesSeniority = 'ROLETITLES_SENIORITY',
  Specreqs = 'SPECREQS'
}

export enum Option {
  All = 'all',
  Common = 'common'
}

export type OverallRating = {
  numberOfReviews: NumberOfReviews;
  value: Scalars['Float'];
};

export type Overview = {
  description: Maybe<Description>;
  industry: Maybe<Scalars['String']>;
  primaryLocation: Maybe<Scalars['String']>;
  size: Maybe<CompanySize>;
  specialities: Maybe<Scalars['String']>;
  website: Maybe<Website>;
};

export type PageInfo = {
  endCursor: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  startCursor: Maybe<Scalars['String']>;
};

export type ParentClassification = {
  description: Scalars['String'];
  id: Scalars['Int'];
  subClassifications: Array<ChildClassification>;
};


export type ParentClassificationDescriptionArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
};

export type PendingCredentialGroup = {
  count: Scalars['Int'];
  label: Scalars['String'];
};

export type PerkAndBenefit = {
  description: Scalars['String'];
  title: Scalars['String'];
};

export type PersonalDetails = {
  /**
   * The candidate's country calling code. The `description` field will be returned in the
   * language specified by the `languageCode` parameter passed to the `personalDetails`
   * field. If this field is `null` then the `defaultCountryCallingCode` value must be
   * used instead. Otherwise, this field must always be used.
   */
  countryCallingCode: Maybe<CountryCallingCode>;
  /**
   * A default country calling code based on the `countryCode` parameter passed to the
   * `personalDetails` field. The `description` field will be returned in the language
   * specified by the `languageCode` parameter passed to the `personalDetails` field.
   * If the `countryCallingCode` field is `null`, then this  field must always be used.
   * Otherwise, the `countryCallingCode` must be used instead.
   */
  defaultCountryCallingCode: CountryCallingCode;
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  /** @deprecated Being phased out as part of unification */
  nationality: Maybe<Nationality>;
  phoneNumber: Maybe<Scalars['String']>;
};

export type PersonalisedJobDetails = {
  applicationInsights: Maybe<JobApplicationInsights>;
  appliedDateTime: Maybe<SeekDateTime>;
  isSaved: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer shown in UI */
  jobApplicantsBadge: Maybe<JobApplicantsBadge>;
  /**
   * CAUTION!! This field uses a resolver that does not meet the SPREAD requirements
   * for a Seek Resource API.  Please query separately from the other fields in the
   * PersonaliseJobDetails object.
   */
  matchedSkills: Maybe<MatchedSkills>;
  qualities: Maybe<MatchedQualities>;
  salaryMatch: Maybe<IJobProfileSalaryMatch>;
  /** Top Applicant Badge uses Brand, Locale/translatable text */
  topApplicantBadge: Maybe<TopApplicantBadge>;
};

export type PersonalisedSeekMaxCategoryGroup = {
  followed: Maybe<Scalars['Boolean']>;
};

export type PersonalisedSeekMaxComment = {
  /** @deprecated Use likedV3 instead - https://myseek.atlassian.net/browse/CNC-4642 */
  liked: Scalars['Boolean'];
  likedV3: Maybe<Scalars['Boolean']>;
};


export type PersonalisedSeekMaxCommentLikedV3Args = {
  zone: Scalars['Zone'];
};

export type PersonalisedSeekMaxModule = {
  bookmark: Maybe<SeekMaxModuleBookmark>;
  liked: Scalars['Boolean'];
};


export type PersonalisedSeekMaxModuleBookmarkArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  zone: InputMaybe<Scalars['Zone']>;
};

export type PersonalisedSeekMaxModuleProgress = {
  completed: Scalars['Boolean'];
  nextVideoProgress: Maybe<SeekMaxNextVideoProgress>;
};

export type PersonalisedSeekMaxPollOption = {
  voted: Scalars['Boolean'];
};

export type PersonalisedSeekMaxThread = {
  liked: Scalars['Boolean'];
};

export type PersonalisedSeekMaxThreadSearchContent = {
  liked: Maybe<Scalars['Boolean']>;
};

export type PersonalisedSeekMaxVideo = {
  progress: SeekMaxVideoProgress;
};


export type PersonalisedSeekMaxVideoProgressArgs = {
  locale: Scalars['Locale'];
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PostCompanyProfileReviewFlagInput = {
  companyId: Scalars['String'];
  details: Scalars['String'];
  reason: Scalars['String'];
  reviewId: Scalars['String'];
};

export type PostCompanyProfileReviewFlagPayload = {
  success: Scalars['Boolean'];
};

export type PostCompanyProfileReviewUpvotesInput = {
  companyId: Scalars['String'];
  reviewId: Scalars['String'];
};

export type PostCompanyProfileReviewUpvotesPayload = {
  success: Scalars['Boolean'];
};

export type PostCompanyReviewError = {
  message: Scalars['String'];
};


export type PostCompanyReviewErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type PostCompanyReviewFailure = {
  errors: Array<PostCompanyReviewError>;
};

export type PostCompanyReviewInput = {
  careerOpportunity: InputMaybe<RatingInput>;
  companyId: Scalars['String'];
  companyName: Scalars['String'];
  details: ReviewDetailsInput;
  diversity: InputMaybe<RatingInput>;
  executiveManagement: InputMaybe<RatingInput>;
  job: JobInput;
  languageISO: Scalars['String'];
  organisationId: InputMaybe<Scalars['String']>;
  perksAndBenefits: InputMaybe<RatingInput>;
  salary: InputMaybe<SalaryInput>;
  workEnvironment: InputMaybe<RatingInput>;
  workLifeBalance: InputMaybe<RatingInput>;
};

export type PostCompanyReviewPayload = PostCompanyReviewFailure | PostCompanyReviewSuccess;

export type PostCompanyReviewSuccess = {
  reviewId: Scalars['String'];
};

export type PreferredLocation2Input = {
  id: Scalars['Int'];
};

export enum PreferredLocationType {
  Area = 'Area',
  Location = 'Location'
}

export type Privacy = {
  education: Scalars['Boolean'];
  languages: Scalars['Boolean'];
  licences: Scalars['Boolean'];
  personalDetails: Scalars['Boolean'];
  skills: Scalars['Boolean'];
  summary: Scalars['Boolean'];
  workHistory: Scalars['Boolean'];
};

export type PrivacyInput = {
  education: Scalars['Boolean'];
  languages: Scalars['Boolean'];
  licences: Scalars['Boolean'];
  personalDetails: Scalars['Boolean'];
  skills: Scalars['Boolean'];
  summary: Scalars['Boolean'];
  workHistory: Scalars['Boolean'];
};

export type PrivacyPolicyQuestion = Question & {
  id: Scalars['String'];
  options: Array<QuestionOption>;
  text: Scalars['String'];
  url: Scalars['String'];
};

export type ProcessUploadedAttachmentInput = {
  attachmentType: AttachmentType;
  id: Scalars['UUID'];
};

export type ProcessUploadedAttachmentPayload = {
  uri: Scalars['String'];
};

export type ProcessUploadedResumeInput = {
  /** @deprecated Only the zone parameter should be passed after all unification releases */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  id: Scalars['UUID'];
  isDefault: InputMaybe<Scalars['Boolean']>;
  origin: InputMaybe<ResumeOriginType>;
  parsingContext: InputMaybe<RequestResumeParsingContext>;
  zone: InputMaybe<Scalars['Zone']>;
};

export type ProcessUploadedResumeResult = {
  /** @deprecated Please use the resume type with more resume metadata */
  id: Scalars['UUID'];
  resume: Resume;
  viewer: Maybe<Candidate>;
};

export type ProfileInsights = {
  activities: Array<ProfileInsightsActivity>;
  searchImpressionCount: Scalars['Int'];
  viewCount: Scalars['Int'];
};

export type ProfileInsightsActivity = {
  /** The relative day(s) since the activity, or date of the activity if more than 29 days ago */
  date: Scalars['String'];
  /** Display label for the source of the activity e.g. Found from an employer search */
  sourceLabel: Scalars['String'];
};


export type ProfileInsightsActivityDateArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  timezone: InputMaybe<Scalars['Timezone']>;
  zone: Scalars['Zone'];
};


export type ProfileInsightsActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso'];
};

export type ProfileInsightsAdvertiser = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProfileInsightsJob = {
  id: Scalars['ID'];
  title: Scalars['String'];
  /** Job URL built with brand based on candidate's zone and selected language */
  url: Scalars['String'];
};


export type ProfileInsightsJobUrlArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
};

export type ProfileInsightsJobSentActivity = ProfileInsightsActivity & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  date: Scalars['String'];
  /** Job sent from the advertiser to the candidate */
  job: ProfileInsightsJob;
  sourceLabel: Scalars['String'];
};


export type ProfileInsightsJobSentActivityDateArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  timezone: InputMaybe<Scalars['Timezone']>;
  zone: Scalars['Zone'];
};


export type ProfileInsightsJobSentActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso'];
};

export type ProfileInsightsMessageSentActivity = ProfileInsightsActivity & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  date: Scalars['String'];
  sourceLabel: Scalars['String'];
};


export type ProfileInsightsMessageSentActivityDateArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  timezone: InputMaybe<Scalars['Timezone']>;
  zone: Scalars['Zone'];
};


export type ProfileInsightsMessageSentActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso'];
};

export type ProfileInsightsResumeDownloadedActivity = ProfileInsightsActivity & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  date: Scalars['String'];
  sourceLabel: Scalars['String'];
};


export type ProfileInsightsResumeDownloadedActivityDateArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  timezone: InputMaybe<Scalars['Timezone']>;
  zone: Scalars['Zone'];
};


export type ProfileInsightsResumeDownloadedActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso'];
};

export type ProfileLocationTrackSelectedResponse = {
  id: Scalars['Int'];
};

export enum ProfileLocationType {
  Home = 'Home',
  Preferred = 'Preferred'
}

export type ProfileScore = {
  /** Overall progress/completeness, value from 0 to 1. */
  progress: Scalars['Float'];
  /** The sum of all score values from each individual scorer. */
  score: Scalars['Float'];
  /** A list of all tips the candidate can action on their profile. */
  tips: Array<ProfileScoreTip>;
};

export type ProfileScoreTip = {
  /** Parameters used by the profile app to customise the tip action. */
  action: ProfileScoreTipAction;
  /** A description of the value the candidate could get by actioning this tip. */
  description: Scalars['String'];
  /** The action button label for this tip. */
  label: Scalars['String'];
  /** The score amount that can be gained from actioning this tip. */
  score: Scalars['Float'];
};

export type ProfileScoreTipAction = {
  /**
   * The specific card to scroll to when the tip is actioned. Valid values are
   * strings from [this array](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/master/src/components/Router/index.ts#L29).
   */
  card: Scalars['String'];
  /**
   * A specific field to focus on within the `card` specified. The field must
   * have a focus ref attached it. Reference the `field-name` associated with
   * the ref. [Example](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/494f567314685156cc3c40bfa212746d14845efa/src/components/Profile/PersonalDetails/EditPersonalDetails/EditPersonalDetails.tsx#L144).
   */
  field: Maybe<Scalars['String']>;
  /**
   * The id of a specific profile item. Can be used if you want an action to
   * target a specific item, e.g. a candidate's most recent career history.
   */
  item: Maybe<Scalars['String']>;
  /**
   * The mode to set the card to when the tip is actioned. Valid values are
   * `read` or `edit`.
   */
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestLocation = {
  contextualName: Scalars['String'];
  countryCode: Scalars['CountryCodeIso2'];
  highlights: Array<SuggestionHighlight>;
  id: Scalars['Int'];
  kind: Scalars['String'];
  shortName: Scalars['String'];
};

export type ProfileSuggestLocationGroup = {
  label: Scalars['String'];
  suggestions: Array<ProfileSuggestLocation>;
};

export type ProfileSuggestLocationType = ProfileSuggestLocation | ProfileSuggestLocationGroup;

export type ProfileSuggestion = {
  /** Action that candidate could take on for this particular suggestion. */
  action: Maybe<ProfileSuggestionAction>;
  /** A suggestion message the candidate can improve or action on their profile. */
  message: Scalars['String'];
  /** Event name passed to the tracking system when the suggestion is displayed. */
  trackingNudgeType: Scalars['String'];
};

export type ProfileSuggestionAction = {
  /** The context of the action on what is the next step to take after button click. */
  context: Maybe<ProfileSuggestionActionContext>;
  /** The action button label for this suggestion action. */
  label: Scalars['String'];
  /** Event name passed to the tracking system when the action is clicked. */
  trackingCallToAction: Scalars['String'];
};

export type ProfileSuggestionActionContext = {
  /**
   * The specific card to scroll to when the tip is actioned. Valid values are
   * strings from [this array](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/master/src/components/Router/index.ts#L29).
   */
  card: Maybe<Scalars['String']>;
  /**
   * A specific field to focus on within the `section` specified. The field must have a focus ref attached it. Reference the `field-name` associated with
   * the ref. [Example](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/494f567314685156cc3c40bfa212746d14845efa/src/components/Profile/PersonalDetails/EditPersonalDetails/EditPersonalDetails.tsx#L144).
   * (Mainly used by web)
   */
  field: Maybe<Scalars['String']>;
  /** The mode to set the section/card to when the suggestion is actioned. Valid values are `read` or `edit`. (Mainly used by web) */
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionAvailabilityActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionCareerHistoryActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  /**
   * The id of a specific profile item. Can be used if you want an action to
   * target a specific item, e.g. a candidate's most recent career history.
   */
  itemId: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionClassificationActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionEducationActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionLanguagesActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionLicencesActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionPersonalDetailsActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionPersonalSummaryActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionProfileVisibilityActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionResumeActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionRightToWorkActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionSalaryActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionSkillsActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileSuggestionWorkTypeActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']>;
  field: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};

export type ProfileVerifications = {
  nudge: Maybe<VerificationsNudge2>;
  verifiable: Maybe<Array<VerifiableCredentialCategory>>;
  verified: Maybe<Array<VerifiedCredentialCategory>>;
};


export type ProfileVerificationsNudgeArgs = {
  platform: Platform;
  source: SourceExperience;
  testGroup: InputMaybe<VerificationsTestVariant>;
};


export type ProfileVerificationsVerifiableArgs = {
  platform: Platform;
  source: SourceExperience;
};

export type ProfileVisibility = {
  /** Human readable string used when showing the candidate's profile visibility in a read-only context */
  description: Scalars['String'];
  /** Visibility level of the candidate's profile */
  level: VisibilityLevel;
};

export type ProvisionAccountError = {
  message: Scalars['String'];
};


export type ProvisionAccountErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type ProvisionAccountErrorAlreadyProvisioned = ProvisionAccountError & {
  message: Scalars['String'];
};


export type ProvisionAccountErrorAlreadyProvisionedMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type ProvisionAccountErrorAlreadyProvisionedDuplicateGuid = ProvisionAccountError & {
  message: Scalars['String'];
};


export type ProvisionAccountErrorAlreadyProvisionedDuplicateGuidMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type ProvisionAccountFailure = {
  error: ProvisionAccountError;
};

export type ProvisionAccountPayload = ProvisionAccountFailure | ProvisionAccountSuccess;

export type ProvisionAccountSuccess = {
  id: Scalars['ID'];
  isTokenRefreshRequired: Scalars['Boolean'];
};

export type Qualification = {
  completed: Scalars['Boolean'];
  completionDate: Maybe<CompletionDate>;
  credential: Maybe<BaseCredential>;
  /** This field returns a description of the completion for the qualification eg. "In progress", "Finished 2018" */
  formattedCompletion: Scalars['String'];
  highlights: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  institute: OntologyStructuredData;
  isVerified: Scalars['Boolean'];
  /** Required for JobsDB only */
  level2: Maybe<Scalars['String']>;
  name: OntologyStructuredData;
  status: Maybe<QualificationStatus>;
  tracking: Maybe<TrackingInfo>;
  verificationUrl: Maybe<Scalars['String']>;
};

export enum QualificationLevel {
  AdvancedDiploma = 'AdvancedDiploma',
  AssociateDegree = 'AssociateDegree',
  BachelorDegree = 'BachelorDegree',
  BachelorDegreeHonours = 'BachelorDegreeHonours',
  CertificateI = 'CertificateI',
  CertificateIi = 'CertificateII',
  CertificateIii = 'CertificateIII',
  CertificateIv = 'CertificateIV',
  CompletedHighSchool = 'CompletedHighSchool',
  CompletedYear9To11 = 'CompletedYear9To11',
  Diploma = 'Diploma',
  DoctoralDegree = 'DoctoralDegree',
  GraduateCertificate = 'GraduateCertificate',
  GraduateDiploma = 'GraduateDiploma',
  IosLongtailFallback = 'IosLongtailFallback',
  MastersDegree = 'MastersDegree'
}

export enum QualificationStatus {
  New = 'New'
}

export type Quality = {
  displayLabel: Scalars['String'];
  ontologyId: Scalars['ID'];
  shortId: Scalars['UUID'];
};


export type QualityDisplayLabelArgs = {
  locale: Scalars['Locale'];
};

export type Query = {
  _empty: Maybe<Scalars['String']>;
  accountExists: AccountStatus;
  availabilityOptions: Array<AvailabilityOption>;
  banner: Maybe<Banner>;
  bookmarkedSeekMaxModules: SeekMaxModuleBookmarkResults;
  categorySeekMaxModules: Maybe<SeekMaxModuleConnectionResults>;
  categorySeekMaxThreads: Maybe<SeekMaxThreadConnectionResults>;
  classifications: Array<ParentClassification>;
  companyNameSlug: CompanyNameSlug;
  companyProfile: CompanyProfile;
  companyProfileReviewUpvotes: Maybe<ReviewUpvotes>;
  companyProfilesFeatureFlags: Array<FeatureFlag>;
  companyReviews: Maybe<Reviews>;
  /** The details of a consent transaction for a given transactionId */
  consentTransactionDetails: Maybe<ConsentTransactionDetails>;
  /**
   * A list of country codes filtered based on the `option` parameter. The `description`
   * of each list item will be returned in the language specified via the `languageCode`
   * parameter. *Note*: The default value for the `languageCode` parameter is `en`, *not*
   * `false` as it appears in the playground.
   */
  countryCallingCodeOptions: Array<CountryCallingCode>;
  defaultCurrency: DefaultCurrency;
  dummy: Maybe<Scalars['String']>;
  featureFlags: Maybe<Array<FeatureFlagEvaluation>>;
  featuredSeekMaxCollection: Maybe<SeekMaxCollection>;
  /** @deprecated Use featuredSeekMaxThreadsV2 instead */
  featuredSeekMaxThreads: Array<SeekMaxThread>;
  featuredSeekMaxThreadsV2: Maybe<Array<Maybe<SeekMaxThread>>>;
  groupedCompanies: Maybe<Array<Maybe<GroupedCompanies>>>;
  jobApplicationProcess: Maybe<JobApplicationProcess>;
  jobDetails: Maybe<JobDetails>;
  loggedOutRecommendedJobs: Maybe<LoggedOutRecommendedGlobalJobs>;
  marqueeCompanies: Array<MarqueeCompanyProfile>;
  mkLocationSuggestions: Array<MkLocationSuggestion>;
  /** @deprecated Use moreSeekMaxThreadsV2 instead */
  moreSeekMaxThreads: Maybe<SeekMaxThreadConnectionResults>;
  moreSeekMaxThreadsV2: Maybe<SeekMaxThreadConnectionResults>;
  ontologyEducationProviders: Array<IOntologyEducationProvider>;
  ontologyOrganisations: Array<IOntologyOrganisation>;
  ontologyQualifications: Array<IOntologyQualification>;
  ontologyRoleTitlesSeniority: Array<IOntologyRoleTitleSeniority>;
  ontologySpecReqs: Array<OntologySpecReq>;
  ontologyTrackSelected: Maybe<ITrackSelected>;
  /** @deprecated Use pinnedSeekMaxThreadsV2 instead */
  pinnedSeekMaxThreads: Array<SeekMaxThread>;
  pinnedSeekMaxThreadsV2: Maybe<Array<Maybe<SeekMaxThread>>>;
  preferredClassificationOptions: Array<ClassificationOptions>;
  profileLocationSuggest: Array<ProfileSuggestLocationType>;
  profileLocationTrackSelected: ProfileLocationTrackSelectedResponse;
  recentlyAddedSeekMaxModules: Array<SeekMaxModule>;
  recommendedSeekMaxModules: Array<SeekMaxModule>;
  relatedSeekMaxModules: Array<SeekMaxModule>;
  resumePrivacyDisclaimers: ResumePrivacyDisclaimers;
  review: Maybe<Review>;
  /** A list of right to work options for all countries we collect right to work information in */
  rightToWorkOptions: Array<RightToWorkCountryOptions>;
  roleFunctionOptions: Array<RoleFunctionOption>;
  salaryOptions: Array<SalaryOption>;
  searchCompanyProfilesByName: Array<SearchCompanyProfileResultItem>;
  searchFilterData: SearchFilterData;
  searchKeywordsSuggest: SearchKeywordSuggestions;
  searchLocationsSuggest: SearchLocationSuggestions;
  searchSalaryRanges: Maybe<Array<SearchSalaryRange>>;
  /** @deprecated Use searchSeekMaxContentsV2 instead */
  searchSeekMaxContents: SeekMaxContentSearchResults;
  searchSeekMaxContentsV2: Maybe<SeekMaxContentSearchResults>;
  /** @deprecated Use searchSeekMaxContentsV2 instead - https://myseek.atlassian.net/browse/CNC-3509 */
  searchSeekMaxModules: SeekMaxModuleSearchResults;
  /** @deprecated Use searchSeekMaxContentsV2 instead - https://myseek.atlassian.net/browse/CNC-3509 */
  searchSeekMaxThreads: SeekMaxThreadSearchResults;
  seekMaxCategoriesHome: Array<Array<SeekMaxCategory>>;
  seekMaxCategoriesThreadCreate: Array<SeekMaxCategory>;
  seekMaxCategoryGroup: Maybe<ISeekMaxCategoryGroup>;
  seekMaxCategoryGroups: Maybe<SeekMaxCategoryGroupConnectionResults>;
  seekMaxCertificateAttachmentStatus: Maybe<ISeekMaxCertificateAttachmentStatus>;
  seekMaxCertificates: Maybe<SeekMaxCertificateConnectionResults>;
  seekMaxCollections: Array<SeekMaxCollection>;
  seekMaxComments: SeekMaxCommentResults;
  seekMaxFeedModules: Maybe<SeekMaxModuleFeedResults>;
  seekMaxFeedThreads: Maybe<SeekMaxThreadFeedResults>;
  seekMaxLandingInfo: SeekMaxLandingInfo;
  seekMaxModule: Maybe<SeekMaxModule>;
  /** @deprecated Use categorySeekMaxModules instead - https://myseek.atlassian.net/browse/CNC-4488 */
  seekMaxModules: SeekMaxModuleResults;
  seekMaxModulesInProgress: SeekMaxModulesInProgressResults;
  /** @deprecated Use seekMaxMyThreadsV2 instead */
  seekMaxMyThreads: SeekMaxThreadResults;
  seekMaxMyThreadsV2: Maybe<SeekMaxThreadConnectionResults>;
  seekMaxMyUnreadThreadsCount: Maybe<SeekMaxUnreadThreadsCountResponse>;
  seekMaxProfile: SeekMaxProfile;
  seekMaxReplies: SeekMaxReplyResults;
  seekMaxThread: Maybe<SeekMaxThread>;
  seekMaxThreadAttachmentStatus: Maybe<ISeekMaxAttachmentStatus>;
  /** @deprecated Use categorySeekMaxThreads instead - https://myseek.atlassian.net/browse/CNC-4488 */
  seekMaxThreads: SeekMaxThreadResults;
  /** Displays data that a candidate has chosen to share via a public url */
  shareableProfile: ShareableProfile;
  supportedCountries: Array<CountryInformation>;
  trendingSeekMaxModules: Array<SeekMaxModule>;
  /** The version of the schema */
  version: Scalars['String'];
  viewer: Maybe<Candidate>;
  workTypeOptions: Array<WorkTypeTaxonomyOption>;
};


export type QueryAccountExistsArgs = {
  email: Scalars['String'];
};


export type QueryAvailabilityOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso'];
};


export type QueryBannerArgs = {
  candidateId: InputMaybe<Scalars['String']>;
  classification: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  keywords: InputMaybe<Scalars['String']>;
  locale?: Scalars['Locale'];
  loggedIn: InputMaybe<Scalars['String']>;
  placement: BannerPlacement;
  roleId: InputMaybe<Scalars['String']>;
  salaryRange: InputMaybe<Scalars['String']>;
  salaryType: InputMaybe<Scalars['String']>;
  subclassification: InputMaybe<Scalars['String']>;
  visitorId: InputMaybe<Scalars['UUID']>;
  where: InputMaybe<Scalars['String']>;
  workType: InputMaybe<Scalars['String']>;
  zone: InputMaybe<Scalars['Zone']>;
};


export type QueryBookmarkedSeekMaxModulesArgs = {
  countryCode: Scalars['CountryCodeIso2'];
  pageSize: Scalars['Int'];
  pageToken: InputMaybe<Scalars['String']>;
};


export type QueryCategorySeekMaxModulesArgs = {
  categoryCode: Scalars['String'];
  cursor: Scalars['Int'];
  pageSize: Scalars['Int'];
  zone: Scalars['Zone'];
};


export type QueryCategorySeekMaxThreadsArgs = {
  categoryId: Scalars['ID'];
  cursor: Scalars['Int'];
  pageSize: Scalars['Int'];
  zone: Scalars['Zone'];
};


export type QueryClassificationsArgs = {
  zone: Scalars['Zone'];
};


export type QueryCompanyNameSlugArgs = {
  companySlug: Scalars['String'];
  isLegacyUrl?: Scalars['Boolean'];
  zone?: Scalars['Zone'];
};


export type QueryCompanyProfileArgs = {
  id: Scalars['ID'];
  useCachedProfile?: Scalars['Boolean'];
  zone: Scalars['Zone'];
};


export type QueryCompanyProfileReviewUpvotesArgs = {
  id: Scalars['ID'];
  zone: Scalars['Zone'];
};


export type QueryCompanyProfilesFeatureFlagsArgs = {
  input: InputMaybe<FeatureFlagInput>;
};


export type QueryCompanyReviewsArgs = {
  companyId: Scalars['ID'];
  locationId: InputMaybe<Scalars['ID']>;
  page: InputMaybe<Scalars['Int']>;
  perPage: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<Scalars['String']>;
  zone: Scalars['Zone'];
};


export type QueryConsentTransactionDetailsArgs = {
  input: ConsentTransactionDetailsInput;
};


export type QueryCountryCallingCodeOptionsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  option?: InputMaybe<Option>;
};


export type QueryDefaultCurrencyArgs = {
  zone: Scalars['Zone'];
};


export type QueryFeatureFlagsArgs = {
  applicationContext: InputMaybe<ApplicationContextInput>;
  deviceContext: InputMaybe<DeviceContextInput>;
  experienceContext: InputMaybe<ExperienceContextInput>;
  flags: Array<Scalars['String']>;
  visitorContext: InputMaybe<VisitorContextInput>;
};


export type QueryFeaturedSeekMaxCollectionArgs = {
  locale: InputMaybe<Scalars['Locale']>;
  maxCollectionSize: Scalars['Int'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QueryFeaturedSeekMaxThreadsArgs = {
  locale: InputMaybe<Scalars['Locale']>;
  maxSize?: Scalars['Int'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QueryFeaturedSeekMaxThreadsV2Args = {
  maxSize: Scalars['PositiveInt'];
  zone: Scalars['Zone'];
};


export type QueryGroupedCompaniesArgs = {
  excludedCompanyIds: InputMaybe<Array<Scalars['ID']>>;
  groupBy: CompanyGroupByInput;
  perPage: InputMaybe<Scalars['Int']>;
  randomSeed: InputMaybe<Scalars['String']>;
  sortBy: InputMaybe<Company_Sort_By>;
  zone: Scalars['Zone'];
};


export type QueryJobApplicationProcessArgs = {
  jobId: Scalars['ID'];
};


export type QueryJobDetailsArgs = {
  id: Scalars['ID'];
  tracking: InputMaybe<JobDetailsTrackingInput>;
};


export type QueryLoggedOutRecommendedJobsArgs = {
  cluster: InputMaybe<Scalars['SmarterSearchCluster']>;
  jobId: Scalars['ID'];
  limit?: Scalars['Int'];
  platform: Platform;
  source: AttributionSource;
  visitorId: Scalars['UUID'];
  zone: Scalars['Zone'];
};


export type QueryMarqueeCompaniesArgs = {
  hideJobs: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  zone?: Scalars['Zone'];
};


export type QueryMkLocationSuggestionsArgs = {
  count: InputMaybe<Scalars['Int']>;
  kind: Array<Scalars['String']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  searchText: Scalars['String'];
  session: Scalars['String'];
  zone: Scalars['Zone'];
};


export type QueryMoreSeekMaxThreadsArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  cursor: Scalars['Int'];
  pageSize: Scalars['PositiveInt'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QueryMoreSeekMaxThreadsV2Args = {
  cursor: Scalars['Int'];
  pageSize: Scalars['PositiveInt'];
  zone: Scalars['Zone'];
};


export type QueryOntologyEducationProvidersArgs = {
  count: Scalars['Int'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  query: Scalars['String'];
  session: Scalars['String'];
};


export type QueryOntologyOrganisationsArgs = {
  count: Scalars['Int'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  query: Scalars['String'];
  session: Scalars['String'];
};


export type QueryOntologyQualificationsArgs = {
  count: Scalars['Int'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  query: Scalars['String'];
  session: Scalars['String'];
};


export type QueryOntologyRoleTitlesSeniorityArgs = {
  count: Scalars['Int'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  query: Scalars['String'];
  session: Scalars['String'];
};


export type QueryOntologySpecReqsArgs = {
  count: Scalars['Int'];
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  profileField: InputMaybe<SpecReqProfileField>;
  query: Scalars['String'];
  session: Scalars['String'];
};


export type QueryOntologyTrackSelectedArgs = {
  id: Scalars['String'];
  index: Scalars['Int'];
  ontologyType: OntologyType;
  session: Scalars['String'];
};


export type QueryPinnedSeekMaxThreadsArgs = {
  maxSize: Scalars['Int'];
  zone: Scalars['Zone'];
};


export type QueryPinnedSeekMaxThreadsV2Args = {
  maxSize: Scalars['PositiveInt'];
  zone: Scalars['Zone'];
};


export type QueryPreferredClassificationOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
};


export type QueryProfileLocationSuggestArgs = {
  count: Scalars['Int'];
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  locationType: ProfileLocationType;
  query: Scalars['String'];
  session: Scalars['String'];
  zone: Scalars['Zone'];
};


export type QueryProfileLocationTrackSelectedArgs = {
  id: Scalars['Int'];
  session: Scalars['String'];
};


export type QueryRecentlyAddedSeekMaxModulesArgs = {
  locale: Scalars['Locale'];
};


export type QueryRecommendedSeekMaxModulesArgs = {
  countryCode: Scalars['CountryCodeIso2'];
  model: InputMaybe<Scalars['String']>;
};


export type QueryRelatedSeekMaxModulesArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  moduleId: Scalars['ID'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QueryResumePrivacyDisclaimersArgs = {
  isUnifiedSite: InputMaybe<Scalars['Boolean']>;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
};


export type QueryReviewArgs = {
  reviewId: Scalars['ID'];
  zone: Scalars['Zone'];
};


export type QueryRightToWorkOptionsArgs = {
  filter: InputMaybe<RightToWorkFilterInput>;
  isUnified?: InputMaybe<Scalars['Boolean']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  locale: InputMaybe<Scalars['Locale']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']>;
};


export type QueryRoleFunctionOptionsArgs = {
  countryCode: Scalars['CountryCodeIso2'];
  languageCode: LanguageCode;
};


export type QuerySearchCompanyProfilesByNameArgs = {
  includeBranding: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type QuerySearchKeywordsSuggestArgs = {
  count: Scalars['Int'];
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']>;
  query: Scalars['String'];
  visitorId: InputMaybe<Scalars['UUID']>;
};


export type QuerySearchLocationsSuggestArgs = {
  count: Scalars['Int'];
  country: InputMaybe<Scalars['CountryCodeIso2']>;
  countryCode: InputMaybe<CountryCode>;
  isRemoteEnabled: InputMaybe<Scalars['Boolean']>;
  isUnified: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['Locale']>;
  query: Scalars['String'];
  recentLocation: InputMaybe<Scalars['String']>;
  visitorId: InputMaybe<Scalars['UUID']>;
};


export type QuerySearchSalaryRangesArgs = {
  zone: Scalars['Zone'];
};


export type QuerySearchSeekMaxContentsArgs = {
  contentType: InputMaybe<Scalars['String']>;
  countryCode: Scalars['CountryCodeIso2'];
  cursor: Scalars['Int'];
  pageSize: Scalars['Int'];
  query: InputMaybe<Scalars['String']>;
};


export type QuerySearchSeekMaxContentsV2Args = {
  contentType: InputMaybe<Scalars['String']>;
  cursor: Scalars['Int'];
  pageSize: Scalars['PositiveInt'];
  query: InputMaybe<Scalars['String']>;
  zone: Scalars['Zone'];
};


export type QuerySearchSeekMaxModulesArgs = {
  cursor?: Scalars['Int'];
  locale: Scalars['Locale'];
  pageSize: Scalars['Int'];
  query: Scalars['String'];
};


export type QuerySearchSeekMaxThreadsArgs = {
  cursor: Scalars['Int'];
  locale: Scalars['Locale'];
  pageSize: Scalars['Int'];
  query: Scalars['String'];
};


export type QuerySeekMaxCategoryGroupArgs = {
  groupId: Scalars['UUID'];
  zone: Scalars['Zone'];
};


export type QuerySeekMaxCategoryGroupsArgs = {
  cursor: Scalars['Int'];
  pageSize: Scalars['Int'];
  zone: Scalars['Zone'];
};


export type QuerySeekMaxCertificateAttachmentStatusArgs = {
  id: Scalars['ID'];
};


export type QuerySeekMaxCertificatesArgs = {
  cursor: InputMaybe<Scalars['String']>;
  pageSize: Scalars['PositiveInt'];
};


export type QuerySeekMaxCollectionsArgs = {
  locale: InputMaybe<Scalars['Locale']>;
  maxCollectionSize: Scalars['Int'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QuerySeekMaxCommentsArgs = {
  cursor?: Scalars['Int'];
  locale: InputMaybe<Scalars['Locale']>;
  pageSize: Scalars['Int'];
  threadId: Scalars['ID'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QuerySeekMaxFeedModulesArgs = {
  cursor: Scalars['Int'];
  pageSize: Scalars['PositiveInt'];
  zone: Scalars['Zone'];
};


export type QuerySeekMaxFeedThreadsArgs = {
  cursor: Scalars['Int'];
  pageSize: Scalars['PositiveInt'];
  zone: Scalars['Zone'];
};


export type QuerySeekMaxLandingInfoArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};


export type QuerySeekMaxModuleArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  id: InputMaybe<Scalars['ID']>;
  zone: InputMaybe<Scalars['Zone']>;
};


export type QuerySeekMaxModulesArgs = {
  category: SeekMaxCategory;
  cursor?: Scalars['Int'];
  locale: InputMaybe<Scalars['Locale']>;
  pageSize: Scalars['Int'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QuerySeekMaxModulesInProgressArgs = {
  locale: Scalars['Locale'];
  pageSize: InputMaybe<Scalars['Int']>;
  pageToken: InputMaybe<Scalars['String']>;
};


export type QuerySeekMaxMyThreadsArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  cursor?: Scalars['Int'];
  pageSize: Scalars['Int'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QuerySeekMaxMyThreadsV2Args = {
  cursor: Scalars['Int'];
  pageSize: Scalars['PositiveInt'];
  zone: Scalars['Zone'];
};


export type QuerySeekMaxMyUnreadThreadsCountArgs = {
  zone: Scalars['Zone'];
};


export type QuerySeekMaxRepliesArgs = {
  commentId: Scalars['ID'];
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  cursor?: Scalars['Int'];
  pageSize: Scalars['Int'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QuerySeekMaxThreadArgs = {
  id: Scalars['ID'];
  locale: InputMaybe<Scalars['Locale']>;
  zone: InputMaybe<Scalars['Zone']>;
};


export type QuerySeekMaxThreadAttachmentStatusArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
  id: Scalars['ID'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QuerySeekMaxThreadsArgs = {
  category: SeekMaxCategory;
  cursor?: Scalars['Int'];
  locale: InputMaybe<Scalars['Locale']>;
  pageSize: Scalars['Int'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type QueryShareableProfileArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  profileSlug: Scalars['String'];
  zone: Scalars['Zone'];
};


export type QuerySupportedCountriesArgs = {
  languageCode: Scalars['LanguageCodeIso'];
};


export type QueryTrendingSeekMaxModulesArgs = {
  locale: Scalars['Locale'];
  maxSize: Scalars['Int'];
};


export type QueryWorkTypeOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso'];
};

export type Question = {
  id: Scalars['String'];
  text: Scalars['String'];
};

export type QuestionOption = {
  id: Scalars['String'];
  text: Scalars['String'];
  uri: Maybe<Scalars['String']>;
};

export type Questionnaire = {
  questions: Array<Question>;
};

export type QuestionnaireAnswerInput = {
  answers: Array<AnswerForQuestionInput>;
  questionId: Scalars['String'];
};

export type RatingInput = {
  rating: InputMaybe<Scalars['Int']>;
};

export type RatingItem = {
  description: Scalars['String'];
  /** @deprecated Use value instead */
  rating: Scalars['Float'];
  value: Scalars['Float'];
};


export type RatingItemDescriptionArgs = {
  locale?: Scalars['Locale'];
};

export type Recommendations = {
  recommendedGlobalJobs: Maybe<RecommendedGlobalJobs>;
  similarJobsGlobal: Maybe<RecommendedGlobalJobs>;
};


export type RecommendationsRecommendedGlobalJobsArgs = {
  cluster: InputMaybe<Scalars['SmarterSearchCluster']>;
  includeSavedJobs: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  platform: Platform;
  source: AttributionSource;
  visitorId: Scalars['UUID'];
  zone: Scalars['Zone'];
};


export type RecommendationsSimilarJobsGlobalArgs = {
  cluster: InputMaybe<Scalars['SmarterSearchCluster']>;
  includeSavedJobs: InputMaybe<Scalars['Boolean']>;
  jobId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  platform: Platform;
  source: AttributionSource;
  visitorId: Scalars['UUID'];
  zone: Scalars['Zone'];
};

export type RecommendedGlobalJob = {
  id: Scalars['ID'];
  isNew: Scalars['Boolean'];
  isSaved: Scalars['Boolean'];
  job: Job;
  solMetadata: Scalars['JSON'];
  tags: Maybe<Array<JobTag>>;
};

export type RecommendedGlobalJobs = {
  globalJobs: Array<RecommendedGlobalJob>;
  solMetadata: Maybe<Scalars['JSON']>;
  totalCount: Maybe<Scalars['Int']>;
};

export type RejectConsentError = {
  message: Scalars['String'];
};


export type RejectConsentErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type RejectConsentFailure = {
  errors: Array<RejectConsentError>;
};

export type RejectConsentInput = {
  transactionId: Scalars['UUID'];
};

export type RejectConsentPayload = RejectConsentFailure | RejectConsentSuccess;

export type RejectConsentSuccess = {
  redirectUri: Scalars['String'];
};

export type RejectConsentTransactionInvalidError = RejectConsentError & {
  message: Scalars['String'];
};


export type RejectConsentTransactionInvalidErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type RejectRoleInput = {
  achievements: InputMaybe<Scalars['String']>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  id: Scalars['UUID'];
  seniority: InputMaybe<OntologyStructuredDataInput>;
  title: OntologyStructuredDataInput;
  to: InputMaybe<MonthYearInput>;
  tracking: InputMaybe<TrackingInfoInput>;
};

export type RejectRolePayload = {
  /** @deprecated Use viewer.roles */
  id: Scalars['UUID'];
  viewer: Maybe<Candidate>;
};

export type RejectUnconfirmedDataInput = {
  dataType: UnconfirmedDataType;
  id: Scalars['UUID'];
  tracking: InputMaybe<TrackingInfoInput>;
};

export type RejectUnconfirmedDataPayload = {
  /** @deprecated Use viewer.qualifications or viewer.roles */
  ref: Maybe<Scalars['UUID']>;
  viewer: Maybe<Candidate>;
};

export enum ReportJobCountryCode {
  /** @deprecated Use CountryCodeIso2 */
  Au = 'AU',
  /** @deprecated Use CountryCodeIso2 */
  Nz = 'NZ'
}

export type ReportJobInput = {
  comment: InputMaybe<Scalars['String']>;
  country: InputMaybe<Scalars['CountryCodeIso2']>;
  /** @deprecated Use country */
  countryCode: InputMaybe<ReportJobCountryCode>;
  email: Scalars['Email'];
  jobId: Scalars['Int'];
  reason: Scalars['String'];
};

export type ReportJobPayload = {
  success: Scalars['Boolean'];
};

export type ReportProfileError = {
  message: Scalars['String'];
};


export type ReportProfileErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type ReportProfileFailure = {
  error: ReportProfileError;
};

export type ReportProfileInput = {
  comment: Scalars['String'];
  email: Scalars['Email'];
  profileSlug: Scalars['String'];
  reason: Scalars['String'];
  zone: Scalars['Zone'];
};

export type ReportProfilePayload = ReportProfileFailure | ReportProfileSuccess;

export type ReportProfileSuccess = {
  ref: Scalars['UUID'];
};

export type ReportSeekMaxCommentAlreadyReportedError = ReportSeekMaxCommentError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxCommentAlreadyReportedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxCommentAlreadyReportedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxCommentError = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxCommentErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxCommentErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxCommentFailure = {
  errors: Array<ReportSeekMaxCommentError>;
};

export type ReportSeekMaxCommentInput = {
  id: Scalars['ID'];
  locale: Scalars['Locale'];
  reason: Scalars['String'];
};

export type ReportSeekMaxCommentPayload = ReportSeekMaxCommentFailure | ReportSeekMaxCommentSuccess;

export type ReportSeekMaxCommentPrivilegeError = ReportSeekMaxCommentError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxCommentPrivilegeErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxCommentPrivilegeErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxCommentSuccess = {
  id: Scalars['ID'];
};

export type ReportSeekMaxCommentUserIsBannedError = ReportSeekMaxCommentError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxCommentUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxCommentUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxReplyAlreadyReportedError = ReportSeekMaxReplyError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxReplyAlreadyReportedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxReplyAlreadyReportedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxReplyError = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxReplyErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxReplyErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxReplyFailure = {
  errors: Array<ReportSeekMaxReplyError>;
};

export type ReportSeekMaxReplyInput = {
  countryCode: Scalars['CountryCodeIso2'];
  id: Scalars['ID'];
  reason: Scalars['String'];
};

export type ReportSeekMaxReplyPayload = ReportSeekMaxReplyFailure | ReportSeekMaxReplySuccess;

export type ReportSeekMaxReplyPrivilegeError = ReportSeekMaxReplyError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxReplyPrivilegeErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxReplyPrivilegeErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxReplySuccess = {
  id: Scalars['ID'];
};

export type ReportSeekMaxReplyUserIsBannedError = ReportSeekMaxReplyError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxReplyUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxReplyUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxThreadAlreadyReportedError = ReportSeekMaxThreadError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxThreadAlreadyReportedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxThreadAlreadyReportedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxThreadError = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxThreadErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxThreadErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxThreadFailure = {
  errors: Array<ReportSeekMaxThreadError>;
};

export type ReportSeekMaxThreadInput = {
  id: Scalars['ID'];
  locale: Scalars['Locale'];
  reason: Scalars['String'];
};

export type ReportSeekMaxThreadPayload = ReportSeekMaxThreadFailure | ReportSeekMaxThreadSuccess;

export type ReportSeekMaxThreadPrivilegeError = ReportSeekMaxThreadError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxThreadPrivilegeErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxThreadPrivilegeErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type ReportSeekMaxThreadSuccess = {
  id: Scalars['ID'];
};

export type ReportSeekMaxThreadUserIsBannedError = ReportSeekMaxThreadError & {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type ReportSeekMaxThreadUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type ReportSeekMaxThreadUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type RequestResumeParsingContext = {
  id: Scalars['UUID'];
};

export type RequestResumeParsingInput = {
  id: Scalars['UUID'];
  parsingContext: RequestResumeParsingContext;
  zone: InputMaybe<Scalars['Zone']>;
};

export type ResubscribeApacSavedSearchByCodeError = {
  message: Scalars['String'];
};


export type ResubscribeApacSavedSearchByCodeErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type ResubscribeApacSavedSearchByCodeFailure = {
  error: ResubscribeApacSavedSearchByCodeError;
};

export type ResubscribeApacSavedSearchByCodeInput = {
  code: Scalars['String'];
};

export type ResubscribeApacSavedSearchByCodePayload = ResubscribeApacSavedSearchByCodeFailure | ResubscribeApacSavedSearchByCodeSuccess;

export type ResubscribeApacSavedSearchByCodeSuccess = {
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type Resume = {
  createdDateRelative: Scalars['String'];
  createdDateUtc: Scalars['DateTime'];
  fileMetadata: FileMetadata;
  id: Scalars['UUID'];
  isDefault: Scalars['Boolean'];
  origin: ResumeOrigin;
};

export type ResumeAppliedJobDocument = {
  attachmentMetadata: AttachmentMetadata;
  blobUrl: Scalars['String'];
  downloadLink: Maybe<Scalars['String']>;
};

export type ResumeInput = {
  id: InputMaybe<Scalars['ID']>;
  idFromResumeResource: InputMaybe<Scalars['Int']>;
  uri: Scalars['String'];
};

export type ResumeOrigin = {
  type: Maybe<ResumeOriginType>;
};

export enum ResumeOriginType {
  Generated = 'Generated',
  Uploaded = 'Uploaded'
}

export type ResumePrivacyDisclaimer = {
  isEmphasized: Scalars['Boolean'];
  value: Scalars['String'];
};

export type ResumePrivacyDisclaimers = {
  longParagraphs: Array<ResumePrivacyDisclaimer>;
  shortParagraphs: Array<ResumePrivacyDisclaimer>;
};

export type Review = {
  companyId: Scalars['String'];
  cons: Scalars['String'];
  createdAt: SeekDateTime;
  employmentStatus: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobTitle: Maybe<Scalars['String']>;
  overallRating: Scalars['Float'];
  pros: Scalars['String'];
  ratings: Array<RatingItem>;
  recommended: ReviewRecommended;
  reply: Maybe<CompanyReviewReply>;
  salarySummary: Scalars['String'];
  title: Maybe<Scalars['String']>;
  upvotes: Maybe<Upvotes>;
  workLocation: Maybe<Scalars['String']>;
};


export type ReviewEmploymentStatusArgs = {
  locale?: Scalars['Locale'];
};


export type ReviewSalarySummaryArgs = {
  locale?: Scalars['Locale'];
};

export type ReviewDetailsInput = {
  cons: InputMaybe<Scalars['String']>;
  isCompanyRecommended: InputMaybe<Scalars['Boolean']>;
  overallExperience: InputMaybe<Scalars['String']>;
  overallRating: Scalars['Int'];
  pros: InputMaybe<Scalars['String']>;
};

export type ReviewRecommended = {
  description: Scalars['String'];
  value: Scalars['Boolean'];
};


export type ReviewRecommendedDescriptionArgs = {
  locale?: Scalars['Locale'];
};

export type ReviewUpvotes = {
  upvotes: Array<Scalars['String']>;
};

export type Reviews = {
  data: Array<Review>;
  paging: ReviewsPaging;
};

export type ReviewsPaging = {
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type ReviewsSummary = {
  communityGuideline: CommunityGuideline;
  employeeRecommendation: EmployeeRecommendation;
  overallRating: OverallRating;
  ratings: Array<RatingItem>;
  salaryRating: SalaryRating;
};

export type RightToWork = {
  /** Information about the country associated with the right to work */
  country: CountryInformation;
  credential: Maybe<RightToWorkCredential>;
  /** Unique ID that identifies a specific right to work */
  id: Scalars['UUID'];
  /** Will be true if it doesn't have ontology data */
  isDeprecated: Maybe<Scalars['Boolean']>;
  /** Will be `null` if the user has not selected a right to work option. */
  type2: Maybe<RightToWorkType2>;
  /** Will only hold a value if the verification URL should be shown, will be `null` otherwise. */
  verificationUrl: Maybe<Scalars['String']>;
};

export type RightToWorkCountryOptions = {
  /** Information about the country associated with the right to work options */
  country: CountryInformation;
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Maybe<Array<SuggestionHighlight>>;
  /** A list of right to work options for the associated country code */
  options: Array<RightToWorkOption>;
};

export type RightToWorkCredential = {
  expiryFormatted: Scalars['String'];
  fullName: Maybe<Scalars['String']>;
  manageVerificationUrl: Scalars['String'];
  status: Maybe<CredentialStatus>;
  verification: CredentialVerification;
  visa: Maybe<RightToWorkVisa>;
};

export type RightToWorkFilterInput = {
  /** A partial country name to be searched */
  countryNameQuery: InputMaybe<Scalars['String']>;
};

export type RightToWorkOption = {
  /** Human readable string used when the user is selecting a right to work option. E.g. `Yes`. */
  description: Scalars['String'];
  /** Human readable string used when showing a right to work option in a read-only context. E.g. `Yes, I have the right to work in Australia`. */
  formattedDescription: Scalars['String'];
  /** Unique ID used to identify a specific right to work option */
  id: Scalars['ID'];
  /** Certsy verification URL for this right to work option. Will be `null` if selecting this option indicates that you do not have the right to work */
  verificationUrl: Maybe<Scalars['String']>;
};

export type RightToWorkType2 = {
  /** Human readable string used when the user is selecting a right to work option. E.g. `Yes`. */
  description: Scalars['String'];
  /** Human readable string used when showing a right to work option in a read-only context. E.g. `Yes, I have the right to work in Australia`. */
  formattedDescription: Scalars['String'];
  /** Unique ID associated with a  `RightToWorkOption` */
  id: Scalars['String'];
};

export type RightToWorkType2Input = {
  /** ID corresponding to a `RightToWorkOption` */
  id: Scalars['ID'];
};

export type RightToWorkVisa = {
  detailUrl: Maybe<Scalars['String']>;
  holderType: Maybe<Scalars['String']>;
  subclass: Maybe<Scalars['String']>;
};

export type RightsToWorkAlert = {
  alert: Maybe<AlertType>;
};

export type Role = {
  achievements: Maybe<Scalars['String']>;
  company: OntologyStructuredData;
  from: MonthYear;
  /** Required for JobsDB only */
  function: Maybe<RoleFunction>;
  id: Scalars['UUID'];
  /** Required for JobsDB only */
  industry: Maybe<RoleIndustry>;
  seniority: Maybe<OntologyStructuredData>;
  title: OntologyStructuredData;
  to: Maybe<MonthYear>;
  tracking: Maybe<TrackingInfo>;
};

export type RoleFunction = {
  id: Scalars['ID'];
  subFunction: RoleSubFunction;
};

export type RoleFunctionInput = {
  id: Scalars['ID'];
  subFunction: RoleSubFunctionInput;
};

export type RoleFunctionOption = {
  description: Scalars['String'];
  id: Scalars['ID'];
  roleSubFunctions: Array<RoleSubFunctionOption>;
};

export type RoleIndustry = {
  id: Scalars['ID'];
};

export type RoleIndustryInput = {
  id: Scalars['ID'];
};

export type RoleSubFunction = {
  id: Scalars['ID'];
};

export type RoleSubFunctionInput = {
  id: Scalars['ID'];
};

export type RoleSubFunctionOption = {
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type SeoInfo = {
  classification: Maybe<Array<Scalars['String']>>;
  normalisedRoleTitle: Maybe<Scalars['String']>;
  subClassification: Maybe<Array<Scalars['String']>>;
  where: Maybe<Scalars['String']>;
  workType: Maybe<Scalars['String']>;
};


export type SeoInfoWhereArgs = {
  locale?: Scalars['Locale'];
  zone: Scalars['Zone'];
};

export type SalaryFrequency = {
  isDefault: Scalars['Boolean'];
  label: Scalars['String'];
  type: Scalars['String'];
};


export type SalaryFrequencyLabelArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
};

export type SalaryInput = {
  currency: InputMaybe<Scalars['String']>;
  includeBonus: InputMaybe<Scalars['Boolean']>;
  maximum: InputMaybe<Scalars['Int']>;
  minimum: InputMaybe<Scalars['Int']>;
  rating: InputMaybe<Scalars['String']>;
  type: InputMaybe<Scalars['String']>;
};

export type SalaryOption = {
  annually: Array<SalaryRangeOption>;
  country: Scalars['String'];
  hourly: Array<SalaryRangeOption>;
};

export type SalaryPreference2 = {
  /** Candidate's preferred minimum salary amount for a specific country and salary type */
  amount: Maybe<Scalars['SafeInt']>;
  /** Information about the country associated with the salary preference */
  country: CountryInformation;
  /** Currency associated with the minimum salary amount */
  currencyCode: Scalars['CurrencyCodeIso'];
  /**
   * Formatted string to be shown to the user in read-mode. Formatted as:
   * {currency code} {amount} {salary type}. Will be `null` if the
   * preference has no `amount` value.
   */
  description: Maybe<Scalars['String']>;
  /** Unique ID that identifies a specific salary preference */
  id: Scalars['UUID'];
  /** Salary type corresponding to the minimum salary amount */
  salaryType: SalaryType2;
};

export type SalaryPreference2Input = {
  /** Candidate's preferred minimum salary amount for a specific country and salary type */
  amount: InputMaybe<Scalars['SafeInt']>;
  /** Country associated with the minimum salary amount */
  countryCode: Scalars['CountryCodeIso2'];
  /** Unique ID that identifies a specific salary preference */
  id: Scalars['UUID'];
  /** Salary type corresponding to the minimum salary amount */
  salaryType: SalaryType2;
};

export type SalaryRangeOption = {
  label: Scalars['String'];
  value: Scalars['SafeInt'];
};

export type SalaryRating = {
  description: Scalars['String'];
  rating: Scalars['String'];
  value: Scalars['Float'];
};


export type SalaryRatingDescriptionArgs = {
  locale?: Scalars['Locale'];
};

export enum SalaryType2 {
  Annual = 'Annual',
  Hourly = 'Hourly',
  Monthly = 'Monthly'
}

export type SaveSeekMaxKeywordSearchError = {
  message: Scalars['String'];
};


export type SaveSeekMaxKeywordSearchErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type SaveSeekMaxKeywordSearchFailure = {
  errors: Array<SaveSeekMaxKeywordSearchError>;
};

export type SaveSeekMaxKeywordSearchInput = {
  searchedKeyword: Scalars['String'];
};

export type SaveSeekMaxKeywordSearchPayload = SaveSeekMaxKeywordSearchFailure | SaveSeekMaxKeywordSearchSuccess;

export type SaveSeekMaxKeywordSearchSuccess = {
  searchedKeyword: Scalars['String'];
};

export type SavedJob = {
  createdAt: SeekDateTime;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isExternal: Scalars['Boolean'];
  job: Job;
  notes: Maybe<Scalars['String']>;
  zone: Maybe<Scalars['Zone']>;
};

export type SavedJobConnection = {
  edges: Array<SavedJobEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type SavedJobEdge = {
  cursor: Scalars['String'];
  node: SavedJob;
};

export type SavedJobEventCaptureDataInput = {
  channel: Scalars['String'];
  eventCaptureSessionId: Scalars['String'];
  serpTracking: InputMaybe<Scalars['String']>;
  view: Scalars['String'];
};

export type SavedSearchApacQuery = {
  parameters: Array<SavedSearchParameters>;
  searchQueryString: Maybe<Scalars['JobSearchQueryString']>;
};

export type SavedSearchParameters = {
  type: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type SearchAppliedJobPartial = {
  jobId: Scalars['String'];
};

export type SearchCompanyProfileData = {
  branding: Maybe<BasicBranding>;
  name: Scalars['String'];
  overview: Maybe<CompanyProfileOverview>;
};

export type SearchCompanyProfileResultItem = {
  companyId: Scalars['String'];
  data: SearchCompanyProfileData;
  organisationId: Scalars['String'];
  zone: Scalars['String'];
};

export type SearchFilterData = {
  workArrangementOptions: Array<WorkArrangementOption>;
};

export type SearchKeywordSuggestions = {
  metadata: Maybe<SearchSuggestionsMetadata>;
  suggestions: Array<KeywordSuggestionType>;
};

export type SearchLocationSuggestions = {
  suggestions: Array<LocationSuggestionType>;
};

export type SearchPageInfo = {
  endCursor: Maybe<Scalars['Int']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  startCursor: Maybe<Scalars['Int']>;
};

export type SearchSalaryRange = {
  frequency: SalaryFrequency;
  range: Array<SearchSalaryRangeItem>;
};

export type SearchSalaryRangeItem = {
  label: Scalars['String'];
  value: Scalars['String'];
};


export type SearchSalaryRangeItemLabelArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
  type: InputMaybe<SearchSalaryRangeLabelType>;
};

export enum SearchSalaryRangeLabelType {
  Long = 'LONG',
  Short = 'SHORT'
}

export type SearchSavedJobPartial = {
  jobId: Scalars['String'];
  zone: Maybe<Scalars['Zone']>;
};

export type SearchSuggestionsMetadata = {
  flightId: Maybe<Scalars['String']>;
  requestToken: Maybe<Scalars['UUID']>;
};

export type SeekDateTime = {
  dateTime: Scalars['String'];
  dateTimeUtc: Scalars['DateTime'];
  /** Contextual label for the date. E.g. for job posted, 15 mins ago, but for seekmax poll, 15 mins left */
  label: Scalars['String'];
  longAbsoluteLabel: Scalars['String'];
  longLabel: Scalars['String'];
  /** @deprecated Use label with context SEEKMAX_POLL_DURATION_LEFT */
  seekMaxPollLabel: Scalars['String'];
  /** Generic string representation of the absolute date. E.g. 9 Nov 2021 */
  shortAbsoluteLabel: Scalars['String'];
  /** Generic string representation of the date relative to now. E.g. 6 hours ago */
  shortLabel: Scalars['String'];
};


export type SeekDateTimeDateTimeArgs = {
  locale: InputMaybe<Scalars['Locale']>;
  timezone: InputMaybe<Scalars['Timezone']>;
};


export type SeekDateTimeLabelArgs = {
  context: DateTimeContext;
  length: DateTimeLength;
  locale: Scalars['Locale'];
  timezone: Scalars['Timezone'];
};


export type SeekDateTimeLongAbsoluteLabelArgs = {
  locale: InputMaybe<Scalars['Locale']>;
  timezone: InputMaybe<Scalars['Timezone']>;
};


export type SeekDateTimeLongLabelArgs = {
  locale: InputMaybe<Scalars['Locale']>;
  timezone: InputMaybe<Scalars['Timezone']>;
};


export type SeekDateTimeSeekMaxPollLabelArgs = {
  locale: Scalars['Locale'];
  timezone: Scalars['Timezone'];
};


export type SeekDateTimeShortAbsoluteLabelArgs = {
  locale: InputMaybe<Scalars['Locale']>;
  timezone: InputMaybe<Scalars['Timezone']>;
};


export type SeekDateTimeShortLabelArgs = {
  locale: InputMaybe<Scalars['Locale']>;
  timezone: InputMaybe<Scalars['Timezone']>;
};

export type SeekMaxAttachment = {
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type SeekMaxAttachmentFailed = ISeekMaxAttachmentStatus & {
  failureReason: Scalars['String'];
  id: Scalars['ID'];
};

export type SeekMaxAttachmentPending = ISeekMaxAttachmentStatus & {
  id: Scalars['ID'];
};

export type SeekMaxAttachmentPublished = ISeekMaxAttachmentStatus & {
  id: Scalars['ID'];
  url: Scalars['String'];
};

export enum SeekMaxAttachmentType {
  Image = 'IMAGE'
}

export type SeekMaxAttachmentUploadReady = ISeekMaxAttachmentStatus & {
  id: Scalars['ID'];
  uploadUrl: Scalars['String'];
};

export enum SeekMaxCategory {
  BusinessAndFinance = 'BUSINESS_AND_FINANCE',
  CareerAdvice = 'CAREER_ADVICE',
  IndustryTrends = 'INDUSTRY_TRENDS',
  JobSearchAdvice = 'JOB_SEARCH_ADVICE',
  LanguageLearning = 'LANGUAGE_LEARNING',
  LeadershipAndManagement = 'LEADERSHIP_AND_MANAGEMENT',
  SalaryAdvice = 'SALARY_ADVICE',
  SalesAndMarketing = 'SALES_AND_MARKETING',
  SelfDevelopment = 'SELF_DEVELOPMENT',
  TechnologyAndDesign = 'TECHNOLOGY_AND_DESIGN'
}

export type SeekMaxCategoryGroupConnectionResults = {
  edges: Maybe<Array<Maybe<SeekMaxCategoryGroupEdge>>>;
  pageInfo: SeekMaxPageInfo;
};

export type SeekMaxCategoryGroupEdge = {
  cursor: Scalars['Int'];
  node: ISeekMaxCategoryGroup;
};

export type SeekMaxCategoryGroupFollowInput = {
  followed: Scalars['Boolean'];
  groupId: Scalars['ID'];
};

export type SeekMaxCategoryGroupLocal = ISeekMaxCategoryGroup & {
  categoryId: Scalars['ID'];
  description: Scalars['String'];
  groupId: Scalars['ID'];
  memberCount: SocialMetric;
  name: Scalars['String'];
  personalisedDetails: Maybe<PersonalisedSeekMaxCategoryGroup>;
};

export type SeekMaxCategoryGroupTopic = ISeekMaxCategoryGroup & {
  categoryCode: Scalars['String'];
  categoryId: Scalars['ID'];
  groupId: Scalars['ID'];
  memberCount: SocialMetric;
  name: Scalars['String'];
  personalisedDetails: Maybe<PersonalisedSeekMaxCategoryGroup>;
};

export type SeekMaxCertificate = {
  achievedAt: SeekDateTime;
  author: Scalars['String'];
  badgeUrl: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type SeekMaxCertificateAttachmentFailed = ISeekMaxCertificateAttachmentStatus & {
  failureReason: Scalars['String'];
  id: Scalars['ID'];
};

export type SeekMaxCertificateAttachmentPending = ISeekMaxCertificateAttachmentStatus & {
  id: Scalars['ID'];
};

export type SeekMaxCertificateAttachmentPublished = ISeekMaxCertificateAttachmentStatus & {
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type SeekMaxCertificateConnectionResults = {
  edges: Maybe<Array<Maybe<SeekMaxCertificateEdge>>>;
  pageInfo: PageInfo;
};

export type SeekMaxCertificateEdge = {
  node: SeekMaxCertificate;
};

export type SeekMaxCollection = {
  modules: Array<SeekMaxModule>;
  title: Scalars['String'];
};

export type SeekMaxComment = {
  author: SeekMaxPublicUser;
  content: Scalars['String'];
  creationDate: SeekDateTime;
  exactSocialData: ExactCommentSocialData;
  id: Scalars['ID'];
  personalisedDetails: Maybe<PersonalisedSeekMaxComment>;
};

export type SeekMaxCommentLikedStatusFailure = {
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxCommentLikedStatusSuccess = {
  id: Scalars['ID'];
  likeCount: SocialMetric;
  liked: Scalars['Boolean'];
};

export type SeekMaxCommentResults = {
  comments: Array<SeekMaxComment>;
  lastCursor: Scalars['Int'];
  resultCount: Scalars['Int'];
};

export type SeekMaxContentSearchResults = {
  edges: Array<SeekMaxSearchContentEdge>;
  pageInfo: SearchPageInfo;
};

export type SeekMaxImageAttachment = SeekMaxAttachment & {
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type SeekMaxKolExpert = ISeekMaxKolGroup & {
  description: Scalars['String'];
};

export type SeekMaxLandingInfo = {
  learningProfileId: Scalars['String'];
};

export type SeekMaxLikeInput = {
  id: Scalars['ID'];
  liked: Scalars['Boolean'];
  locale: Scalars['Locale'];
};

export type SeekMaxLikedStatusError = {
  message: Scalars['String'];
};


export type SeekMaxLikedStatusErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type SeekMaxModule = {
  author: Scalars['String'];
  brightcoveId: Scalars['ID'];
  categories: Maybe<Array<SeekMaxCategory>>;
  description: Maybe<Scalars['String']>;
  exactSocialData: ExactModuleSocialData;
  id: Scalars['ID'];
  keywordTags: Maybe<Array<Scalars['String']>>;
  personalisedDetails: Maybe<PersonalisedSeekMaxModule>;
  personalisedProgress: Maybe<PersonalisedSeekMaxModuleProgress>;
  previewImageSrc: Maybe<Scalars['String']>;
  shareLink: Scalars['String'];
  skillLevel: SeekMaxSkillLevel;
  tags: Maybe<Array<SeekMaxTags>>;
  threadId: Maybe<Scalars['ID']>;
  thumbnailImageSrc: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalDuration: Duration;
  /** @deprecated Client side will generate this localised text by using '${videos.length} Episodes' - https://myseek.atlassian.net/browse/CNC-2307 */
  totalEpisodes: Maybe<Episodes>;
  videos: Maybe<Array<SeekMaxVideo>>;
};


export type SeekMaxModulePersonalisedProgressArgs = {
  countryCode: Scalars['CountryCodeIso2'];
};


export type SeekMaxModuleShareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  platform: Platform;
  zone: Scalars['Zone'];
};


export type SeekMaxModuleTotalEpisodesArgs = {
  locale: Scalars['Locale'];
};

export type SeekMaxModuleBookmark = {
  bookmarkDate: SeekDateTime;
};

export type SeekMaxModuleBookmarkInput = {
  countryCode: Scalars['CountryCodeIso2'];
  id: Scalars['ID'];
};

export type SeekMaxModuleBookmarkResults = {
  modules: Array<SeekMaxModule>;
  nextPageToken: Maybe<Scalars['String']>;
  resultCount: Scalars['Int'];
};

export type SeekMaxModuleClickedPersonalisationEventError = {
  message: Scalars['String'];
};


export type SeekMaxModuleClickedPersonalisationEventErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type SeekMaxModuleClickedPersonalisationEventFailure = {
  errors: Array<SeekMaxModuleClickedPersonalisationEventError>;
};

export type SeekMaxModuleClickedPersonalisationEventInput = {
  moduleId: Scalars['ID'];
  session: Scalars['UUID'];
  zone: Scalars['Zone'];
};

export type SeekMaxModuleClickedPersonalisationEventPayload = SeekMaxModuleClickedPersonalisationEventFailure | SeekMaxModuleClickedPersonalisationEventSuccess;

export type SeekMaxModuleClickedPersonalisationEventSuccess = {
  moduleId: Scalars['ID'];
};

export type SeekMaxModuleConnectionResults = {
  edges: Array<SeekMaxModuleEdge>;
  pageInfo: SeekMaxPageInfo;
  totalCount: Scalars['Int'];
};

export type SeekMaxModuleEdge = {
  cursor: Scalars['Int'];
  node: SeekMaxModule;
};

export type SeekMaxModuleFeed = {
  content: SeekMaxModule;
  metaData: Maybe<SeekMaxModuleMetaData>;
};

export type SeekMaxModuleFeedEdge = {
  node: SeekMaxModuleFeed;
};

export type SeekMaxModuleFeedResults = {
  edges: Maybe<Array<Maybe<SeekMaxModuleFeedEdge>>>;
};

export type SeekMaxModuleLikeInput = {
  countryCode: Scalars['CountryCodeIso2'];
  liked: Scalars['Boolean'];
  moduleThreadId: Scalars['ID'];
};

export type SeekMaxModuleLikedStatusFailure = {
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxModuleLikedStatusSuccess = {
  likeCount: SocialMetric;
  liked: Scalars['Boolean'];
  moduleThreadId: Scalars['ID'];
};

export type SeekMaxModuleMetaData = {
  source: Maybe<Scalars['String']>;
};

export type SeekMaxModulePersonalisationEventError = {
  message: Scalars['String'];
};


export type SeekMaxModulePersonalisationEventErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type SeekMaxModulePersonalisationEventFailure = {
  errors: Array<SeekMaxModulePersonalisationEventError>;
};

export type SeekMaxModulePersonalisationEventInput = {
  countryCode: Scalars['CountryCodeIso2'];
  moduleId: Scalars['ID'];
  session: Scalars['UUID'];
};

export type SeekMaxModulePersonalisationEventPayload = SeekMaxModulePersonalisationEventFailure | SeekMaxModulePersonalisationEventSuccess;

export type SeekMaxModulePersonalisationEventSuccess = {
  moduleId: Scalars['ID'];
};

export type SeekMaxModuleProgressError = {
  message: Scalars['String'];
};


export type SeekMaxModuleProgressErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type SeekMaxModuleProgressFailure = {
  errors: Array<SeekMaxModuleProgressError>;
};

export type SeekMaxModuleProgressInput = {
  countryCode: Scalars['CountryCodeIso2'];
  id: Scalars['ID'];
  resumeFromSeconds: Scalars['Float'];
  videoId: Scalars['ID'];
};

export type SeekMaxModuleProgressPayload = SeekMaxModuleProgressFailure | SeekMaxModuleProgressSuccess;

export type SeekMaxModuleProgressSuccess = {
  id: Scalars['ID'];
  videoId: Scalars['ID'];
};

/** SeekMaxModuleResults has been deprecated. Please use SeekMaxModuleConnectionResults instead. */
export type SeekMaxModuleResults = {
  lastCursor: Scalars['Int'];
  modules: Array<SeekMaxModule>;
  resultCount: Scalars['Int'];
};

export type SeekMaxModuleSearchContent = ISeekMaxSearchContent & {
  author: Scalars['String'];
  exactSocialData: ExactModuleSocialData;
  id: Scalars['ID'];
  previewImageSrc: Maybe<Scalars['String']>;
  thumbnailImageSrc: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalDuration: Duration;
  videoCount: Scalars['Int'];
};

/** SeekMaxModuleSearchResults has been deprecated. Please use SeekMaxModuleConnectionResults instead. */
export type SeekMaxModuleSearchResults = {
  lastCursor: Scalars['Int'];
  modules: Array<SeekMaxSearchModule>;
  resultCount: Scalars['Int'];
};

export type SeekMaxModulesInProgressResults = {
  modules: Array<SeekMaxModule>;
  nextPageToken: Maybe<Scalars['String']>;
  resultCount: Scalars['Int'];
};

export type SeekMaxNextVideoProgress = {
  durationLeft: Maybe<DurationLeft>;
  id: Scalars['ID'];
  percentageCompleted: Scalars['Float'];
  previewImageSrc: Maybe<Scalars['String']>;
  resumeFromSeconds: Scalars['Float'];
  state: SeekMaxVideoState;
  thumbnailImageSrc: Maybe<Scalars['String']>;
};

export type SeekMaxPageInfo = {
  endCursor: Maybe<Scalars['Int']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  startCursor: Maybe<Scalars['Int']>;
};

export type SeekMaxPoll = {
  endDate: SeekDateTime;
  ended: Scalars['Boolean'];
  id: Scalars['ID'];
  maxVotes: Scalars['Int'];
  options: Array<SeekMaxPollOption>;
  voteCount: SocialMetric;
};

export type SeekMaxPollOption = {
  count: Scalars['Int'];
  id: Scalars['ID'];
  percentage: Scalars['Int'];
  personalisedDetails: Maybe<PersonalisedSeekMaxPollOption>;
  title: Scalars['String'];
};

export type SeekMaxProfile = {
  groups: Array<ISeekMaxKolGroup>;
  learningProfileHashCode: Scalars['Int'];
  learningProfileId: Scalars['ID'];
};


export type SeekMaxProfileGroupsArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']>;
};

export type SeekMaxPublicLearningProfile = {
  firstName: Maybe<Scalars['String']>;
  jobTitle: Maybe<Scalars['String']>;
};

export type SeekMaxPublicUser = {
  /** @deprecated Use learningProfile.firstName instead */
  firstName: Scalars['String'];
  groups: Array<ISeekMaxKolGroup>;
  id: Scalars['ID'];
  /** @deprecated Use learningProfile.jobTitle instead */
  jobTitle: Maybe<Scalars['String']>;
  learningProfile: Maybe<SeekMaxPublicLearningProfile>;
  learningProfileHashCode: Scalars['Int'];
};

export type SeekMaxReply = {
  author: SeekMaxPublicUser;
  content: Scalars['String'];
  creationDate: SeekDateTime;
  id: Scalars['ID'];
};

export type SeekMaxReplyResults = {
  lastCursor: Scalars['Int'];
  replies: Array<SeekMaxReply>;
  resultCount: Scalars['Int'];
};

export type SeekMaxSearchContentEdge = {
  cursor: Scalars['Int'];
  node: ISeekMaxSearchContent;
};

export type SeekMaxSearchModule = {
  author: Scalars['String'];
  exactSocialData: ExactModuleSocialData;
  id: Scalars['ID'];
  previewImageSrc: Maybe<Scalars['String']>;
  thumbnailImageSrc: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalDuration: Duration;
  /** @deprecated Client side will generate this localised text by using '${videoCount} Episodes' */
  totalEpisodes: Maybe<Episodes>;
  videoCount: Scalars['Int'];
};


export type SeekMaxSearchModuleTotalEpisodesArgs = {
  locale: Scalars['Locale'];
};

export enum SeekMaxSkillLevel {
  Basic = 'BASIC',
  Expert = 'EXPERT',
  Intermediate = 'INTERMEDIATE',
  Unknown = 'UNKNOWN'
}

export type SeekMaxTags = {
  color: Scalars['String'];
  tag: Scalars['String'];
};

export type SeekMaxThread = {
  attachments: Maybe<Array<SeekMaxImageAttachment>>;
  author: SeekMaxPublicUser;
  /** @deprecated Use categoryV3 instead - https://myseek.atlassian.net/browse/CNC-3672 */
  category: SeekMaxCategory;
  categoryGroup: Maybe<ISeekMaxCategoryGroup>;
  /** @deprecated Use categoryGroup instead - https://myseek.atlassian.net/browse/CNC-4488 */
  categoryV3: Maybe<SeekMaxCategory>;
  /** @deprecated Use commentsV3 instead */
  comments: Array<SeekMaxComment>;
  commentsV3: Maybe<Array<Maybe<SeekMaxComment>>>;
  creationDate: SeekDateTime;
  description: Scalars['String'];
  exactSocialData: ExactThreadSocialData;
  hasUnreadPosts: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isPinned: Scalars['Boolean'];
  personalisedDetails: Maybe<PersonalisedSeekMaxThread>;
  /** @deprecated use pollV3 instead - https://myseek.atlassian.net/browse/CNC-3602 */
  poll: Maybe<SeekMaxPoll>;
  pollV3: Maybe<SeekMaxPoll>;
  shareLink: Scalars['String'];
};


export type SeekMaxThreadCategoryArgs = {
  locale: Scalars['Locale'];
};


export type SeekMaxThreadCategoryGroupArgs = {
  zone: Scalars['Zone'];
};


export type SeekMaxThreadCategoryV3Args = {
  zone: Scalars['Zone'];
};


export type SeekMaxThreadCommentsV3Args = {
  zone: Scalars['Zone'];
};


export type SeekMaxThreadPollV3Args = {
  zone: Scalars['Zone'];
};


export type SeekMaxThreadShareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso'];
  platform: Platform;
  zone: Scalars['Zone'];
};

export type SeekMaxThreadConnectionResults = {
  edges: Array<SeekMaxThreadEdge>;
  pageInfo: SeekMaxPageInfo;
  totalCount: Scalars['Int'];
};

export type SeekMaxThreadEdge = {
  cursor: Scalars['Int'];
  node: SeekMaxThread;
};

export type SeekMaxThreadFeed = {
  content: SeekMaxThread;
  metaData: Maybe<SeekMaxThreadMetaData>;
};

export type SeekMaxThreadFeedEdge = {
  node: SeekMaxThreadFeed;
};

export type SeekMaxThreadFeedResults = {
  edges: Maybe<Array<Maybe<SeekMaxThreadFeedEdge>>>;
};

export type SeekMaxThreadLikedStatusFailure = {
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxThreadLikedStatusSuccess = {
  id: Scalars['ID'];
  likeCount: SocialMetric;
  liked: Scalars['Boolean'];
};

export type SeekMaxThreadMetaData = {
  source: Maybe<Scalars['String']>;
};

export type SeekMaxThreadPollInput = {
  optionId: Scalars['ID'];
  pollId: Scalars['ID'];
  voted: Scalars['Boolean'];
};

export type SeekMaxThreadPollStatusError = {
  message: Scalars['String'];
};


export type SeekMaxThreadPollStatusErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type SeekMaxThreadPollStatusFailure = {
  errors: Array<SeekMaxThreadPollStatusError>;
};

export type SeekMaxThreadPollStatusSuccess = {
  optionId: Scalars['ID'];
  pollId: Scalars['ID'];
  voted: Scalars['Boolean'];
};

/** SeekMaxThreadResults has been deprecated. Please use SeekMaxThreadConnectionResults instead. */
export type SeekMaxThreadResults = {
  lastCursor: Scalars['Int'];
  resultCount: Scalars['Int'];
  threads: Array<SeekMaxThread>;
};

export type SeekMaxThreadSearchContent = ISeekMaxSearchContent & {
  attachments: Maybe<Array<SeekMaxImageAttachment>>;
  author: SeekMaxPublicUser;
  /** @deprecated Use categoryV3 instead - https://myseek.atlassian.net/browse/CNC-3672 */
  category: SeekMaxCategory;
  categoryGroup: Maybe<ISeekMaxCategoryGroup>;
  /** @deprecated Use categoryGroup instead - https://myseek.atlassian.net/browse/CNC-4488 */
  categoryV3: Maybe<SeekMaxCategory>;
  /** @deprecated Use commentsV3 instead - https://myseek.atlassian.net/browse/CNC-3518 */
  comments: Array<SeekMaxComment>;
  commentsV3: Maybe<Array<Maybe<SeekMaxComment>>>;
  creationDate: SeekDateTime;
  description: Scalars['String'];
  exactSocialData: ExactThreadSocialData;
  id: Scalars['ID'];
  isPinned: Scalars['Boolean'];
  personalisedDetails: Maybe<PersonalisedSeekMaxThreadSearchContent>;
};


export type SeekMaxThreadSearchContentCategoryArgs = {
  countryCode: Scalars['CountryCodeIso2'];
};


export type SeekMaxThreadSearchContentCategoryGroupArgs = {
  zone: Scalars['Zone'];
};


export type SeekMaxThreadSearchContentCategoryV3Args = {
  zone: Scalars['Zone'];
};


export type SeekMaxThreadSearchContentCommentsV3Args = {
  zone: Scalars['Zone'];
};

/** SeekMaxThreadSearchResults has been deprecated. Please use SeekMaxThreadConnectionResults instead. */
export type SeekMaxThreadSearchResults = {
  isLastPage: Scalars['Boolean'];
  lastCursor: Scalars['Int'];
  threads: Array<SeekMaxThread>;
};

export type SeekMaxUnreadThreadsCountResponse = {
  count: Scalars['Int'];
};

export type SeekMaxVideo = {
  description: Maybe<Scalars['String']>;
  drmEnabled: Scalars['Boolean'];
  duration: Duration;
  id: Scalars['ID'];
  personalisedDetails: Maybe<PersonalisedSeekMaxVideo>;
  previewImageSrc: Scalars['String'];
  /** @deprecated Client side will retrieve the video url from the BC playback API - https://myseek.atlassian.net/browse/CNC-3509 */
  src: Scalars['String'];
  thumbnailImageSrc: Scalars['String'];
  title: Scalars['String'];
};

export type SeekMaxVideoProgress = {
  durationLeft: Maybe<DurationLeft>;
  percentageCompleted: Scalars['Float'];
  resumeFromSeconds: Scalars['Float'];
  state: SeekMaxVideoState;
};

export enum SeekMaxVideoState {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type SeekMaxVideoViewedEventError = {
  message: Scalars['String'];
};


export type SeekMaxVideoViewedEventErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type SeekMaxVideoViewedEventFailure = {
  errors: Array<SeekMaxVideoViewedEventError>;
};

export type SeekMaxVideoViewedEventInput = {
  locale: Scalars['Locale'];
  moduleId: Scalars['ID'];
  session: Scalars['UUID'];
  videoId: Scalars['ID'];
};

export type SeekMaxVideoViewedEventPayload = SeekMaxVideoViewedEventFailure | SeekMaxVideoViewedEventSuccess;

export type SeekMaxVideoViewedEventSuccess = {
  moduleId: Scalars['ID'];
  videoId: Scalars['ID'];
};

export type SeekMaxVideoViewedPersonalisationEventError = {
  message: Scalars['String'];
};


export type SeekMaxVideoViewedPersonalisationEventErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type SeekMaxVideoViewedPersonalisationEventFailure = {
  errors: Array<SeekMaxVideoViewedPersonalisationEventError>;
};

export type SeekMaxVideoViewedPersonalisationEventInput = {
  moduleId: Scalars['ID'];
  session: Scalars['UUID'];
  videoId: Scalars['ID'];
  zone: Scalars['Zone'];
};

export type SeekMaxVideoViewedPersonalisationEventPayload = SeekMaxVideoViewedPersonalisationEventFailure | SeekMaxVideoViewedPersonalisationEventSuccess;

export type SeekMaxVideoViewedPersonalisationEventSuccess = {
  moduleId: Scalars['ID'];
  videoId: Scalars['ID'];
};

export type SelectionCriteriaInput = {
  uri: Scalars['String'];
  writtenText: InputMaybe<Scalars['String']>;
};

export type SendLoginCallbackEventFailure = {
  error: I18nAccountError;
};

export type SendLoginCallbackEventPayload = SendLoginCallbackEventFailure | SendLoginCallbackEventSuccess;

export type SendLoginCallbackEventSuccess = {
  loginType: Scalars['String'];
};

export type SendSeekMaxModuleClickedEventError = {
  message: Scalars['String'];
};


export type SendSeekMaxModuleClickedEventErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type SendSeekMaxModuleClickedEventFailure = {
  errors: Array<SendSeekMaxModuleClickedEventError>;
};

export type SendSeekMaxModuleClickedEventInput = {
  countryCode: Scalars['CountryCodeIso2'];
  moduleId: Scalars['ID'];
  session: Scalars['UUID'];
};

export type SendSeekMaxModuleClickedEventPayload = SendSeekMaxModuleClickedEventFailure | SendSeekMaxModuleClickedEventSuccess;

export type SendSeekMaxModuleClickedEventSuccess = {
  moduleId: Scalars['ID'];
};

export type SensitiveDataInfo = {
  isDetected: Scalars['Boolean'];
};

export type SetAppliedJobNotesError = {
  message: Scalars['String'];
};


export type SetAppliedJobNotesErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type SetAppliedJobNotesFailure = {
  errors: Array<SetAppliedJobNotesError>;
};

export type SetAppliedJobNotesInput = {
  id: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
};

export type SetAppliedJobNotesPayload = SetAppliedJobNotesFailure | SetAppliedJobNotesSuccess;

export type SetAppliedJobNotesSuccess = {
  id: Maybe<Scalars['String']>;
};

export type SetAppliedJobNotesValidationError = SetAppliedJobNotesError & {
  message: Scalars['String'];
};


export type SetAppliedJobNotesValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type SetDefaultResumeInput = {
  id: Scalars['UUID'];
};

export type SetDefaultResumePayload = {
  ref: Maybe<Scalars['UUID']>;
  viewer: Maybe<Candidate>;
};

export type SetSavedJobNotesError = {
  message: Scalars['String'];
};


export type SetSavedJobNotesErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type SetSavedJobNotesFailure = {
  errors: Array<SetSavedJobNotesError>;
};

export type SetSavedJobNotesInput = {
  id: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
};

export type SetSavedJobNotesPayload = SetSavedJobNotesFailure | SetSavedJobNotesSuccess;

export type SetSavedJobNotesSuccess = {
  id: Scalars['ID'];
};

export type SetSavedJobNotesValidationError = SetSavedJobNotesError & {
  message: Scalars['String'];
};


export type SetSavedJobNotesValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type SetSeekMaxCategoryGroupFollowedStatusError = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type SetSeekMaxCategoryGroupFollowedStatusErrorMessageArgs = {
  locale: Scalars['Locale'];
};


export type SetSeekMaxCategoryGroupFollowedStatusErrorTitleArgs = {
  locale: Scalars['Locale'];
};

export type SetSeekMaxCategoryGroupFollowedStatusFailure = {
  errors: Array<SetSeekMaxCategoryGroupFollowedStatusError>;
};

export type SetSeekMaxCategoryGroupFollowedStatusPayload = SetSeekMaxCategoryGroupFollowedStatusFailure | SetSeekMaxCategoryGroupFollowedStatusSuccess;

export type SetSeekMaxCategoryGroupFollowedStatusSuccess = {
  categoryId: Scalars['ID'];
  followed: Scalars['Boolean'];
  groupId: Scalars['ID'];
};

export type SetSeekMaxCommentLikedStatusPayload = SeekMaxCommentLikedStatusFailure | SeekMaxCommentLikedStatusSuccess;

export type SetSeekMaxModuleLikedStatusPayload = SeekMaxModuleLikedStatusFailure | SeekMaxModuleLikedStatusSuccess;

export type SetSeekMaxPreferredCategoriesError = {
  message: Scalars['String'];
};


export type SetSeekMaxPreferredCategoriesErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type SetSeekMaxPreferredCategoriesFailure = {
  errors: Array<SetSeekMaxPreferredCategoriesError>;
};

export type SetSeekMaxPreferredCategoriesInput = {
  categories: Array<SeekMaxCategory>;
};

export type SetSeekMaxPreferredCategoriesPayload = SetSeekMaxPreferredCategoriesFailure | SetSeekMaxPreferredCategoriesSuccess;

export type SetSeekMaxPreferredCategoriesSuccess = {
  categories: Array<SeekMaxCategory>;
};

export type SetSeekMaxThreadLikedStatusPayload = SeekMaxThreadLikedStatusFailure | SeekMaxThreadLikedStatusSuccess;

export type SetSeekMaxThreadPollStatusPayload = SeekMaxThreadPollStatusFailure | SeekMaxThreadPollStatusSuccess;

export type ShareableProfile = {
  active: Scalars['Boolean'];
  id: Maybe<Scalars['ID']>;
  languageProficiencies: Array<LanguageProficiency>;
  licences: Array<Licence>;
  personalDetails: PersonalDetails;
  qualifications: Array<Qualification>;
  roles: Array<Role>;
  skills: Array<Skill>;
  summary: Maybe<Scalars['String']>;
  verifiedIdentity: Maybe<VerifiedIdentity>;
};

export type ShareableProfileSettings = {
  active: Maybe<Scalars['Boolean']>;
  displayUrl: Maybe<Scalars['String']>;
  privacy: Maybe<Privacy>;
  profileSlug: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  views: Maybe<Scalars['Int']>;
};

export type SingleChoiceQuestion = Question & {
  id: Scalars['String'];
  lastAnswer: Maybe<LastAnswer>;
  options: Array<QuestionOption>;
  text: Scalars['String'];
};

export type Skill = {
  keyword: OntologyStructuredData;
};

export type SkillInput = {
  keyword: OntologyStructuredDataInput;
};

export type SocialMetric = {
  count: Scalars['Int'];
  label: Scalars['String'];
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SourceExperience {
  Apply = 'APPLY',
  Jas = 'JAS',
  Profile = 'PROFILE'
}

export type SourcrRecruiter = {
  agencyImageUrl: Maybe<Scalars['String']>;
  agencyName: Maybe<Scalars['String']>;
  avatarImageUrl: Maybe<Scalars['String']>;
  contactUrl: Scalars['String'];
  jobTitle: Maybe<Scalars['String']>;
  name: Scalars['String'];
  overallRating: Scalars['Float'];
  reviewCount: Scalars['Int'];
};

export enum SpecReqProfileField {
  LanguageProficiency = 'LanguageProficiency',
  LicencesCertifications = 'LicencesCertifications',
  PreferredLocation = 'PreferredLocation',
  PreferredWorkTypes = 'PreferredWorkTypes',
  RightToWork = 'RightToWork',
  Skills = 'Skills'
}

export type StandardChannel = ApplicationChannel & {
  label: Maybe<Scalars['String']>;
};


export type StandardChannelLabelArgs = {
  locale: Scalars['Locale'];
};

export type SubClassification = {
  description: Scalars['String'];
  id: Scalars['Int'];
};

export type SubClassificationInput = {
  id: Scalars['Int'];
};

export type Subject = {
  /** The Auth0 user id of the subject, eg 'auth0|12eb841a02c489d1'. */
  id: Scalars['String'];
  /**
   * The associated jobseeker id, derived from the "http://seek/claims/user_id" claim.
   * This is optional, as the user in Auth0 may not be associated with a jobseeker record.
   */
  userId: Maybe<Scalars['String']>;
};

export type SubmitApplicationError = {
  message: Scalars['String'];
};


export type SubmitApplicationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type SubmitApplicationFailure = {
  errors: Array<SubmitApplicationError>;
};

export type SubmitApplicationInput = {
  correlationId: Scalars['ID'];
  coverLetter: InputMaybe<CoverLetterInput>;
  jobId: Scalars['ID'];
  mostRecentRole: InputMaybe<MostRecentRoleInput>;
  personalDetails: InputMaybe<SubmitApplicationPersonalDetailsInput>;
  profilePrivacyLevel: InputMaybe<Scalars['String']>;
  questionnaireAnswers: InputMaybe<Array<QuestionnaireAnswerInput>>;
  resume: InputMaybe<ResumeInput>;
  selectionCriteria: InputMaybe<SelectionCriteriaInput>;
  zone: InputMaybe<Scalars['Zone']>;
};

export type SubmitApplicationPayload = SubmitApplicationFailure | SubmitApplicationSuccess;

export type SubmitApplicationPersonalDetailsInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type SubmitApplicationSuccess = {
  applicationId: Scalars['String'];
  /** @deprecated Use applicationId instead */
  viewer: Maybe<Candidate>;
};

export type SubmitApplicationValidationError = SubmitApplicationError & {
  message: Scalars['String'];
};


export type SubmitApplicationValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type SubscribeApacSavedEmailAlertError = {
  message: Scalars['String'];
};


export type SubscribeApacSavedEmailAlertErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type SubscribeApacSavedEmailAlertFailedError = SubscribeApacSavedEmailAlertError & {
  message: Scalars['String'];
};


export type SubscribeApacSavedEmailAlertFailedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type SubscribeApacSavedEmailAlertFailure = {
  errors: Maybe<Array<SubscribeApacSavedEmailAlertError>>;
};

export type SubscribeApacSavedEmailAlertInput = {
  id: Scalars['ID'];
  subscribe: Scalars['Boolean'];
};

export type SubscribeApacSavedEmailAlertPayload = SubscribeApacSavedEmailAlertFailure | SubscribeApacSavedEmailAlertSuccess;

export type SubscribeApacSavedEmailAlertSuccess = {
  savedSearch: ApacSavedSearch;
  subscribed: Scalars['Boolean'];
};

export type SubscribeMobileNoti = {
  appVersion: Scalars['String'];
  deviceToken: Scalars['String'];
  platform: MobilePlatformNoti;
  zone: Scalars['Zone'];
};

export type SubscribeMobileNotiPayload = MobileNotiFailure | SubscribeMobileNotiSuccess;

export type SubscribeMobileNotiSuccess = {
  deviceToken: Scalars['String'];
  platformName: Scalars['String'];
};

export enum SuggestionGroupType {
  International = 'International',
  Recent = 'Recent',
  Remote = 'Remote',
  Suggestions = 'Suggestions'
}

export type SuggestionHighlight = {
  end: Scalars['Int'];
  start: Scalars['Int'];
};

export type TestTagsInput = {
  testRecord: InputMaybe<Scalars['Boolean']>;
  testScope: InputMaybe<Scalars['String']>;
};

export type TopApplicantBadge = {
  description: Scalars['String'];
  label: Scalars['String'];
};


export type TopApplicantBadgeDescriptionArgs = {
  locale?: Scalars['Locale'];
  zone: InputMaybe<Scalars['Zone']>;
};


export type TopApplicantBadgeLabelArgs = {
  locale?: Scalars['Locale'];
};

export type TrackJobApplicationStartedInput = {
  applicationCorrelationId: Scalars['ID'];
  isProfileApply: InputMaybe<Scalars['Boolean']>;
  jobId: Scalars['ID'];
  sessionId: Scalars['ID'];
};

export type TrackJobApplicationStartedPayload = {
  eventId: Maybe<Scalars['ID']>;
};

export type TrackJobDetailsViewedError = {
  message: Scalars['String'];
};


export type TrackJobDetailsViewedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type TrackJobDetailsViewedFailure = {
  error: TrackJobDetailsViewedError;
};

export type TrackJobDetailsViewedInput = {
  candidateId: InputMaybe<Scalars['Int']>;
  /** @deprecated Deprecated in favour of a more descriptive field name. Use testTags instead. */
  jobDetailsViewedCorrelationId: InputMaybe<Scalars['String']>;
  jobId: Scalars['Int'];
  jobseekerSessionId: Scalars['String'];
  omnitureTracking: InputMaybe<Scalars['String']>;
  tags: InputMaybe<TestTagsInput>;
  testTags: InputMaybe<TestTagsInput>;
};

export type TrackJobDetailsViewedPayload = TrackJobDetailsViewedFailure | TrackJobDetailsViewedSuccess;

export type TrackJobDetailsViewedSuccess = {
  eventId: Maybe<Scalars['String']>;
};

export type TrackSearchResultSelectedError = {
  message: Scalars['String'];
};


export type TrackSearchResultSelectedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type TrackSearchResultSelectedFailure = {
  error: TrackSearchResultSelectedError;
};

export type TrackSearchResultSelectedInput = {
  adDisplayType: Scalars['String'];
  isFeatured: InputMaybe<Scalars['Boolean']>;
  jobId: Scalars['Int'];
  jobseekerSessionId: Scalars['String'];
  tags: InputMaybe<TestTagsInput>;
  testTags: InputMaybe<TestTagsInput>;
  /** @deprecated Deprecated in favour of a more descriptive field name. Use testTags instead. */
  userQueryId: InputMaybe<Scalars['String']>;
};

export type TrackSearchResultSelectedPayload = TrackSearchResultSelectedFailure | TrackSearchResultSelectedSuccess;

export type TrackSearchResultSelectedSuccess = {
  eventId: Maybe<Scalars['String']>;
};

export type TrackingInfo = {
  events: Maybe<Array<KeyValue>>;
};

export type TrackingInfoInput = {
  events: InputMaybe<Array<KeyValueInput>>;
};

export enum UnconfirmedContextType {
  Application = 'Application',
  PrimaryResume = 'PrimaryResume'
}

export type UnconfirmedData = UnconfirmedDataCompleted | UnconfirmedDataPending;

export type UnconfirmedDataCompleted = {
  completed: Scalars['Boolean'];
  qualifications: Array<Qualification>;
  roles: Array<Role>;
};

export type UnconfirmedDataPending = {
  completed: Scalars['Boolean'];
};

export enum UnconfirmedDataType {
  CareerHistory = 'CareerHistory',
  Education = 'Education'
}

export type UnknownCreateShareableProfileSettingsError = CreateShareableProfileSettingsError & {
  message: Scalars['String'];
};


export type UnknownCreateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UnknownReportProfileError = ReportProfileError & {
  message: Scalars['String'];
};


export type UnknownReportProfileErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UnknownUpdateCurrentLocation2Error = UpdateCurrentLocation2Error & {
  message: Scalars['String'];
};


export type UnknownUpdateCurrentLocation2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UnknownUpdatePreferredLocations2Error = UpdatePreferredLocations2Error & {
  message: Scalars['String'];
};


export type UnknownUpdatePreferredLocations2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UnknownUpdateShareableProfileSettingsError = UpdateShareableProfileSettingsError & {
  message: Scalars['String'];
};


export type UnknownUpdateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UnknownUpdateShareableProfileViewsError = UpdateShareableProfileViewsError & {
  message: Scalars['String'];
};


export type UnknownUpdateShareableProfileViewsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UnsubscribeApacSavedSearchByCodeError = {
  message: Scalars['String'];
};


export type UnsubscribeApacSavedSearchByCodeErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UnsubscribeApacSavedSearchByCodeFailure = {
  error: UnsubscribeApacSavedSearchByCodeError;
};

export type UnsubscribeApacSavedSearchByCodeInput = {
  code: Scalars['String'];
};

export type UnsubscribeApacSavedSearchByCodePayload = UnsubscribeApacSavedSearchByCodeFailure | UnsubscribeApacSavedSearchByCodeSuccess;

export type UnsubscribeApacSavedSearchByCodeSuccess = {
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type UnsubscribeMobileNoti = {
  deviceToken: Scalars['String'];
  zone: Scalars['Zone'];
};

export type UnsubscribeMobileNotiPayload = MobileNotiFailure | UnsubscribeMobileNotiSuccess;

export type UnsubscribeMobileNotiSuccess = {
  deviceToken: Scalars['String'];
};

export type UpdateApproachabilityInput = {
  approachable: Scalars['Boolean'];
};

export type UpdateApproachabilityPayload = {
  /** @deprecated Please use viewer.approachability */
  ref: Maybe<Scalars['UUID']>;
  viewer: Maybe<Candidate>;
};

export type UpdateAvailabilityInput = {
  id: Scalars['Int'];
};

export type UpdateCareerObjectivesInput = {
  personalStatement: Scalars['String'];
};

export type UpdateCareerObjectivesPayload = {
  /** @deprecated Please use `viewer.careerObjectives.personalStatement` instead */
  personalStatement: Scalars['String'];
  viewer: Maybe<Candidate>;
};

export type UpdateClassificationInput = {
  classification: ClassificationInput;
};

export type UpdateCurrentLocation2Error = {
  message: Scalars['String'];
};


export type UpdateCurrentLocation2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UpdateCurrentLocation2Failure = {
  error: UpdateCurrentLocation2Error;
};

export type UpdateCurrentLocation2Input = {
  currentLocation: CurrentLocation2Input;
};

export type UpdateCurrentLocation2Payload = UpdateCurrentLocation2Failure | UpdateCurrentLocation2Success;

export type UpdateCurrentLocation2Success = {
  viewer: Maybe<Candidate>;
};

export type UpdateLanguageProficiencyInput = {
  id: Scalars['UUID'];
  name: OntologyStructuredDataInput;
};

export type UpdateLanguageProficiencyPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateLicenceInput = {
  description: InputMaybe<Scalars['String']>;
  expiryDate: InputMaybe<MonthYearInput>;
  id: Scalars['UUID'];
  issueDate: InputMaybe<MonthYearInput>;
  issuingOrganisation: InputMaybe<Scalars['String']>;
  name: OntologyStructuredDataInput;
  noExpiryDate: Scalars['Boolean'];
};

export type UpdateLicencePayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateNoticePeriodInput = {
  weeks: Scalars['Int'];
};

export type UpdateNoticePeriodPayload = {
  /** @deprecated Use viewer.noticePeriod */
  ref: Maybe<Scalars['UUID']>;
  viewer: Maybe<Candidate>;
};

export type UpdateNotificationCtpPreferenceError = NotificationCtpPreferenceError & {
  errorCode: Maybe<Scalars['Int']>;
  message: Scalars['String'];
};


export type UpdateNotificationCtpPreferenceErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UpdateNotificationCtpPreferenceFailure = {
  error: NotificationCtpPreferenceError;
};

export type UpdateNotificationCtpPreferenceInput = {
  onlyProductionOption: Scalars['Boolean'];
  preferences: Array<NotificationCtpPreferencesInput>;
  zone: Scalars['Zone'];
};

export type UpdateNotificationCtpPreferencesPayload = UpdateNotificationCtpPreferenceFailure | UpdateNotificationCtpPreferencesSuccess;

export type UpdateNotificationCtpPreferencesSuccess = {
  success: Array<NotificationCtpPreferenceGroup>;
};

export type UpdateNotificationCtpSubscriptionWithTokenPayload = UpdateNotificationCtpPreferenceFailure | UpdateNotificationCtpSubscriptionWithTokenSuccess;

export type UpdateNotificationCtpSubscriptionWithTokenSuccess = {
  product: NotificationCtpProduct;
  subscribed: Scalars['Boolean'];
  subscriptionChannel: NotificationCtpChannel;
};

export type UpdatePersonalDetailsInput = {
  countryCallingCode: InputMaybe<CountryCallingCodeInput>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  /** *Note*: Nationality will be phased out as part of unification. Currently kept to support functionalies in SEEK Asia platforms. */
  nationality: InputMaybe<NationalityInput>;
  phoneNumber: InputMaybe<Scalars['String']>;
};

export type UpdatePersonalDetailsPayload = {
  /** @deprecated use viewer.personalDetails instead */
  personalDetails: PersonalDetails;
  viewer: Maybe<Candidate>;
};

export type UpdatePreferredClassificationPayload = {
  /** @deprecated Use viewer.preferredClassification */
  ref: Maybe<Scalars['UUID']>;
  viewer: Maybe<Candidate>;
};

export type UpdatePreferredLocations2Error = {
  message: Scalars['String'];
};


export type UpdatePreferredLocations2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UpdatePreferredLocations2Failure = {
  error: UpdatePreferredLocations2Error;
};

export type UpdatePreferredLocations2Input = {
  preferredLocations: Array<PreferredLocation2Input>;
};

export type UpdatePreferredLocations2Payload = UpdatePreferredLocations2Failure | UpdatePreferredLocations2Success;

export type UpdatePreferredLocations2Success = {
  viewer: Maybe<Candidate>;
};

export type UpdatePreferredWorkTypesInput = {
  ids: Array<Scalars['Int']>;
};

export type UpdateProfileVisibilityInput = {
  level: VisibilityLevel;
};

export type UpdateProfileVisibilityPayload = {
  /** @deprecated Use viewer.profileVisibility */
  ref: Maybe<Scalars['String']>;
  viewer: Maybe<Candidate>;
};

export type UpdateQualificationInput = {
  completed: Scalars['Boolean'];
  completionYear: InputMaybe<Scalars['Int']>;
  expectedCompletionDate: InputMaybe<MonthYearInput>;
  highlights: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  institute: OntologyStructuredDataInput;
  level2: InputMaybe<Scalars['String']>;
  name: OntologyStructuredDataInput;
};

export type UpdateQualificationPayload = {
  /**
   * qualification does not have translation support due to it being deprecated
   * @deprecated Use `viewer.qualification`
   */
  qualification: Maybe<Qualification>;
  viewer: Maybe<Candidate>;
};

export type UpdateRightToWorkInput = {
  /** Country associated with the right to work */
  countryCode: Scalars['CountryCodeIso2'];
  /** Unique ID that identifies a specific right to work */
  id: Scalars['UUID'];
  /** Candidate's right to work for a specific country */
  type2: InputMaybe<RightToWorkType2Input>;
};

export type UpdateRightsToWorkInput = {
  /** List of rights to work to update */
  rightsToWork: Array<UpdateRightToWorkInput>;
};

export type UpdateRightsToWorkPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateRoleInput = {
  achievements: InputMaybe<Scalars['String']>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  /** Required for JobsDB only */
  function: InputMaybe<RoleFunctionInput>;
  id: Scalars['UUID'];
  /** Required for JobsDB only */
  industry: InputMaybe<RoleIndustryInput>;
  seniority: InputMaybe<OntologyStructuredDataInput>;
  title: OntologyStructuredDataInput;
  to: InputMaybe<MonthYearInput>;
};

export type UpdateRolePayload = {
  /** @deprecated Use viewer.roles */
  role: Maybe<Role>;
  viewer: Maybe<Candidate>;
};

export type UpdateSalaryPreferencesInput = {
  /** List of salary preferences to update */
  salaryPreferences: Array<SalaryPreference2Input>;
};

export type UpdateSalaryPreferencesPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateSeekMaxMyThreadsLastViewedError = {
  message: Scalars['String'];
};


export type UpdateSeekMaxMyThreadsLastViewedErrorMessageArgs = {
  locale: Scalars['Locale'];
};

export type UpdateSeekMaxMyThreadsLastViewedFailure = {
  errors: Array<UpdateSeekMaxMyThreadsLastViewedError>;
};

export type UpdateSeekMaxMyThreadsLastViewedInput = {
  zone: Scalars['Zone'];
};

export type UpdateSeekMaxMyThreadsLastViewedPayload = UpdateSeekMaxMyThreadsLastViewedFailure | UpdateSeekMaxMyThreadsLastViewedSuccess;

export type UpdateSeekMaxMyThreadsLastViewedSuccess = {
  success: Scalars['Boolean'];
};

export type UpdateShareableProfileSettingsError = {
  message: Scalars['String'];
};


export type UpdateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UpdateShareableProfileSettingsFailure = {
  error: UpdateShareableProfileSettingsError;
};

export type UpdateShareableProfileSettingsInput = {
  active: Scalars['Boolean'];
  privacy: InputMaybe<PrivacyInput>;
};

export type UpdateShareableProfileSettingsPayload = UpdateShareableProfileSettingsFailure | UpdateShareableProfileSettingsSuccess;

export type UpdateShareableProfileSettingsSuccess = {
  viewer: Maybe<Candidate>;
};

export type UpdateShareableProfileViewsError = {
  message: Scalars['String'];
};


export type UpdateShareableProfileViewsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type UpdateShareableProfileViewsFailure = {
  error: UpdateShareableProfileViewsError;
};

export type UpdateShareableProfileViewsInput = {
  profileSlug: Scalars['String'];
};

export type UpdateShareableProfileViewsPayload = UpdateShareableProfileViewsFailure | UpdateShareableProfileViewsSuccess;

export type UpdateShareableProfileViewsSuccess = {
  ref: Scalars['UUID'];
};

export type UpdateSkillsInput = {
  skills: Array<SkillInput>;
};

export type UpdateSkillsPayload = {
  /** @deprecated Use `viewer.skills` instead */
  skills: Maybe<Array<Skill>>;
  viewer: Maybe<Candidate>;
};

export type UpdateVerifiedLicenceInput = {
  description: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type UpdateVerifiedLicencePayload = {
  description: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type UpdateVerifiedQualificationInput = {
  highlights: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type UpdateVerifiedQualificationPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateWorkTypesPayload = {
  /** @deprecated Use viewer.workTypes */
  ref: Maybe<Scalars['UUID']>;
  viewer: Maybe<Candidate>;
};

export type UpdateYearsOfExperienceInput = {
  id: InputMaybe<Scalars['ID']>;
  newToWorkforce: Scalars['Boolean'];
};

export type UpdateYearsOfExperiencePayload = {
  viewer: Maybe<Candidate>;
};

export type Upvotes = {
  count: Scalars['Int'];
  description: Scalars['String'];
  userIds: Maybe<Array<Scalars['String']>>;
};


export type UpvotesDescriptionArgs = {
  locale?: Scalars['Locale'];
};

export type UserCookie = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type VerifiableCredential = {
  label: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type VerifiableCredentialCategory = {
  credentials: Maybe<Array<BaseVerifiableCredential>>;
  label: Scalars['String'];
  pendingCount: Maybe<Scalars['Int']>;
};

export type VerifiableCredentialGroup = {
  credentials: Array<VerifiableCredential>;
  label: Scalars['String'];
};

export type VerifiableCredentialNudge = {
  credential: VerifiableCredential;
};

export type VerifiableCredentialNudge2 = {
  credential: BaseVerifiableCredential;
};

export type VerificationNudge = {
  ctaLabel: Scalars['String'];
  ctaUrl: Scalars['String'];
  description: Scalars['String'];
  rank: Scalars['Int'];
  uri: Scalars['String'];
  verificationType: Array<Scalars['String']>;
};

export type Verifications = {
  nudge: Maybe<VerificationsNudge>;
  pending: Maybe<Array<PendingCredentialGroup>>;
  verifiable: Array<VerifiableCredentialGroup>;
  verified: Array<VerifiedCredentialGroup>;
};

export type VerificationsNudge = VerifiableCredentialNudge | VerificationsOpenDetailsNudge;

export type VerificationsNudge2 = VerifiableCredentialNudge2 | VerificationsOpenDetailsNudge;

export type VerificationsOpenDetailsNudge = {
  ref: Scalars['UUID'];
};

export enum VerificationsTestVariant {
  Identity = 'IDENTITY',
  Opendetails = 'OPENDETAILS',
  Verifiedworkemail = 'VERIFIEDWORKEMAIL'
}

export type VerifiedCredential = {
  credentialInfo: Array<CredentialInfo>;
  label: Scalars['String'];
};

export type VerifiedCredential2 = {
  credentialInfo: Array<CredentialInfo>;
  /** String to indicate the type of credential used for frontend tracking, e.g. identity, workplace */
  credentialType: Scalars['String'];
  label: Scalars['String'];
};

export type VerifiedCredentialCategory = {
  credentials: Maybe<Array<VerifiedCredential2>>;
  label: Scalars['String'];
};

export type VerifiedCredentialGroup = {
  credentials: Array<VerifiedCredential>;
  label: Scalars['String'];
};

export type VerifiedIdentity = {
  isMatchingProfileName: Maybe<Scalars['Boolean']>;
  /** @deprecated use name */
  label: Maybe<Scalars['String']>;
  manageVerificationUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  verificationUrl: Maybe<Scalars['String']>;
};

export type VideoProduct = {
  position: VideoProductPosition;
  url: Scalars['String'];
};

export enum VideoProductPosition {
  Bottom = 'BOTTOM',
  Top = 'TOP'
}

export enum VirusScanStatus {
  HasVirus = 'HasVirus',
  Ok = 'OK',
  Pending = 'Pending',
  Unknown = 'Unknown'
}

export enum VisibilityLevel {
  Hidden = 'Hidden',
  Limited = 'Limited',
  Standard = 'Standard'
}

export type VisitorContextInput = {
  /** visitorId from client */
  key: Scalars['UUID'];
};

export type Website = {
  displayName: Scalars['String'];
  url: Scalars['String'];
};

export type WorkArrangementOption = {
  id: Scalars['String'];
  label: Scalars['String'];
};


export type WorkArrangementOptionLabelArgs = {
  locale: Scalars['Locale'];
};

export type WorkType = {
  description: Scalars['String'];
  id: Scalars['Int'];
};

export type WorkTypeTaxonomyOption = {
  /** Human readable string used when the user is selecting a work type option. */
  description: Scalars['String'];
  /** Unique ID used to identify a specific work type option */
  id: Scalars['Int'];
};

export type WorkplaceVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String'];
  url: Scalars['String'];
};

export type WrongPasswordError = I18nAccountError & {
  code: Scalars['String'];
  message: Scalars['String'];
  reason: Scalars['String'];
};


export type WrongPasswordErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']>;
};

export type Year = {
  year: Scalars['Int'];
};

export type YearsOfExperience = {
  /** Whether or not the candidate is new to the workforce */
  newToWorkforce: Scalars['Boolean'];
  /** The years of experience option chosen by the candidate */
  option: Maybe<YearsOfExperienceOption>;
};

export type YearsOfExperienceOption = {
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type GetDocumentUploadDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetDocumentUploadDataQuery = { viewer: { documentUploadFormData: { link: string, key: string, formFields: Array<{ key: string, value: string }> } | null } | null };

export type HasResumeBeenParsedQueryVariables = Exact<{
  contextId: Scalars['String'];
  contextType: UnconfirmedContextType;
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type HasResumeBeenParsedQuery = { viewer: { unconfirmedDataForContext: { completed: boolean, roles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }>, qualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | { completed: boolean } } | null };

export type GetYearsOfExperienceQueryVariables = Exact<{
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
}>;


export type GetYearsOfExperienceQuery = { viewer: { _id: string, yearsOfExperience: { newToWorkforce: boolean, option: { id: string, description: string } | null } | null } | null };

export type UpdateYearsOfExperienceMutationVariables = Exact<{
  id: InputMaybe<Scalars['ID']>;
  newToWorkforce: Scalars['Boolean'];
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
}>;


export type UpdateYearsOfExperienceMutation = { updateYearsOfExperience: { viewer: { _id: string, yearsOfExperience: { newToWorkforce: boolean, option: { id: string, description: string } | null } | null } | null } };

export type GetConfirmedRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfirmedRolesQuery = { viewer: { _id: string, confirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null };

export type GetUnconfirmedRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnconfirmedRolesQuery = { viewer: { _id: string, unconfirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null };

export type UpdateRoleMutationVariables = Exact<{
  role: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { updateRole: { viewer: { _id: string, confirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } | null };

export type DeleteRoleMutationVariables = Exact<{
  input: DeleteRoleInput;
}>;


export type DeleteRoleMutation = { deleteRole: { viewer: { _id: string, confirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } | null };

export type ConfirmRoleMutationVariables = Exact<{
  role: ConfirmRoleInput;
}>;


export type ConfirmRoleMutation = { confirmRole: { viewer: { _id: string, confirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }>, unconfirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } | null };

export type RejectRoleMutationVariables = Exact<{
  role: RejectUnconfirmedDataInput;
}>;


export type RejectRoleMutation = { rejectUnconfirmedData: { viewer: { _id: string, unconfirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } };

export type GenerateResumeFromProfileMutationVariables = Exact<{
  zone: Scalars['Zone'];
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GenerateResumeFromProfileMutation = { generateResumeFromProfile: { resume: { id: string, isDefault: boolean, createdDateUtc: any, fileMetadata: { name: string, size: string, status: FileMetadataStatus, uri: string }, origin: { type: ResumeOriginType | null } } | null, viewer: { _id: string, resumes: Array<{ id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } }> } | null } | null };

export type GetUnconfirmedQualificationsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type GetUnconfirmedQualificationsQuery = { viewer: { _id: string, unconfirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null };

export type GetConfirmedQualificationsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type GetConfirmedQualificationsQuery = { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null };

export type GetJobsDbConfirmedQualificationsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type GetJobsDbConfirmedQualificationsQuery = { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, level2: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null };

export type UpdateQualificationMutationVariables = Exact<{
  qualification: UpdateQualificationInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type UpdateQualificationMutation = { updateQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } | null };

export type UpdateQualificationJobsDbMutationVariables = Exact<{
  qualification: UpdateQualificationInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type UpdateQualificationJobsDbMutation = { updateQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, level2: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } | null };

export type DeleteQualificationMutationVariables = Exact<{
  qualificationId: DeleteQualificationInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type DeleteQualificationMutation = { deleteQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } | null };

export type DeleteQualificationJobsDbMutationVariables = Exact<{
  qualificationId: DeleteQualificationInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type DeleteQualificationJobsDbMutation = { deleteQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, level2: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } | null };

export type ConfirmQualificationMutationVariables = Exact<{
  qualification: ConfirmQualificationInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type ConfirmQualificationMutation = { confirmQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }>, unconfirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } };

export type ConfirmQualificationJobsDbMutationVariables = Exact<{
  qualification: ConfirmQualificationInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type ConfirmQualificationJobsDbMutation = { confirmQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, level2: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }>, unconfirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, level2: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } };

export type RejectQualificationMutationVariables = Exact<{
  qualification: RejectUnconfirmedDataInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type RejectQualificationMutation = { rejectUnconfirmedData: { viewer: { _id: string, unconfirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } };

export type UpdateVerifiedQualificationMutationVariables = Exact<{
  verifiedQualificationData: UpdateVerifiedQualificationInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type UpdateVerifiedQualificationMutation = { updateVerifiedQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } };

export type GetLanguageProficienciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguageProficienciesQuery = { viewer: { _id: string, languageProficiencies: Array<{ id: string, name: { text: string, ontologyId: string | null } }> } | null };

export type UpdateLanguageProficiencyMutationVariables = Exact<{
  updateLanguageProficiencyInput: UpdateLanguageProficiencyInput;
}>;


export type UpdateLanguageProficiencyMutation = { updateLanguageProficiency: { viewer: { languageProficiencies: Array<{ id: string, name: { text: string, ontologyId: string | null } }> } | null } };

export type DeleteLanguageProficiencyMutationVariables = Exact<{
  deleteLanguageProficiencyInput: DeleteLanguageProficiencyInput;
}>;


export type DeleteLanguageProficiencyMutation = { deleteLanguageProficiency: { viewer: { languageProficiencies: Array<{ id: string, name: { text: string, ontologyId: string | null } }> } | null } };

export type GetLicencesQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
}>;


export type GetLicencesQuery = { viewer: { _id: string, licences: Array<{ id: string, issuingOrganisation: string | null, noExpiryDate: boolean, description: string | null, status: LicenceStatus | null, formattedDate: string | null, verificationUrl: string | null, verificationMessage: string | null, credentialType: string | null, name: { text: string, ontologyId: string | null }, issueDate: { month: number, year: number } | null, expiryDate: { month: number, year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, expiryStatus: CredentialExpiryStatus | null, verification: { result: string }, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null };

export type DeleteLicenceMutationVariables = Exact<{
  deleteLicenceInput: DeleteLicenceInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
}>;


export type DeleteLicenceMutation = { deleteLicence: { viewer: { _id: string, licences: Array<{ id: string, issuingOrganisation: string | null, noExpiryDate: boolean, description: string | null, status: LicenceStatus | null, formattedDate: string | null, verificationUrl: string | null, verificationMessage: string | null, credentialType: string | null, name: { text: string, ontologyId: string | null }, issueDate: { month: number, year: number } | null, expiryDate: { month: number, year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, expiryStatus: CredentialExpiryStatus | null, verification: { result: string }, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } };

export type UpdateLicenceMutationVariables = Exact<{
  licenceData: UpdateLicenceInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
}>;


export type UpdateLicenceMutation = { updateLicence: { viewer: { _id: string, licences: Array<{ id: string, issuingOrganisation: string | null, noExpiryDate: boolean, description: string | null, status: LicenceStatus | null, formattedDate: string | null, verificationUrl: string | null, verificationMessage: string | null, credentialType: string | null, name: { text: string, ontologyId: string | null }, issueDate: { month: number, year: number } | null, expiryDate: { month: number, year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, expiryStatus: CredentialExpiryStatus | null, verification: { result: string }, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } };

export type UpdateVerifiedLicenceMutationVariables = Exact<{
  verifiedLicenceData: UpdateVerifiedLicenceInput;
}>;


export type UpdateVerifiedLicenceMutation = { updateVerifiedLicence: { id: string, description: string | null } };

export type GetApproachabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApproachabilityQuery = { viewer: { _id: string, approachability: { approachable: boolean } } | null };

export type UpdateApproachabilityMutationVariables = Exact<{
  approachability: UpdateApproachabilityInput;
}>;


export type UpdateApproachabilityMutation = { updateApproachability: { viewer: { _id: string, approachability: { approachable: boolean } } | null } };

export type GetAvailabilityQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetAvailabilityQuery = { viewer: { _id: string, availability: { id: number, description: string } | null } | null };

export type UpdateAvailabilityMutationVariables = Exact<{
  availability: UpdateAvailabilityInput;
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type UpdateAvailabilityMutation = { updateAvailability: { viewer: { _id: string, availability: { id: number, description: string } | null } | null } | null };

export type GetAvailabilityOptionsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetAvailabilityOptionsQuery = { availabilityOptions: Array<{ id: number, description: string }> };

export type GetPreferredClassificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreferredClassificationQuery = { viewer: { _id: string, preferredClassification: { id: number, subClassification: { id: number } } | null } | null };

export type UpdatePreferredClassificationMutationVariables = Exact<{
  input: UpdateClassificationInput;
}>;


export type UpdatePreferredClassificationMutation = { updatePreferredClassification: { viewer: { _id: string, preferredClassification: { id: number, subClassification: { id: number } } | null } | null } };

export type GetClassificationOptionsQueryVariables = Exact<{
  zone: Scalars['Zone'];
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetClassificationOptionsQuery = { preferredClassificationOptions: Array<{ id: number, description: string, subClassifications: Array<{ id: number, description: string }> }> };

export type GetPreferredLocations2QueryVariables = Exact<{
  zone: Scalars['Zone'];
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetPreferredLocations2Query = { viewer: { _id: string, preferredLocations2: Array<{ id: number, shortDescription: string, description: string, countryCode: string, kind: string, isDeprecated: boolean | null }> } | null };

export type UpdatePreferredLocations2MutationVariables = Exact<{
  input: UpdatePreferredLocations2Input;
  countryCode: Scalars['CountryCodeIso2'];
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type UpdatePreferredLocations2Mutation = { updatePreferredLocations2: { viewer: { _id: string, preferredLocations2: Array<{ id: number, shortDescription: string, description: string, countryCode: string, kind: string, isDeprecated: boolean | null }>, salaryPreferences2: Array<{ id: string, currencyCode: string, description: string | null, amount: any | null, salaryType: SalaryType2, country: { countryCode: string, name: string } }>, rightsToWork: Array<{ id: string, isDeprecated: boolean | null, verificationUrl: string | null, country: { countryCode: string, name: string }, type2: { id: string, formattedDescription: string } | null, credential: { expiryFormatted: string, status: CredentialStatus | null, manageVerificationUrl: string, verification: { result: string } } | null }> } | null } | {} };

export type GetSupportedCountriesQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetSupportedCountriesQuery = { supportedCountries: Array<{ countryCode: string, name: string }> };

export type GetRightsToWorkQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type GetRightsToWorkQuery = { viewer: { _id: string, rightsToWork: Array<{ id: string, isDeprecated: boolean | null, verificationUrl: string | null, country: { countryCode: string, name: string }, type2: { id: string, formattedDescription: string } | null, credential: { expiryFormatted: string, status: CredentialStatus | null, manageVerificationUrl: string, verification: { result: string } } | null }> } | null };

export type UpdateRightsToWorkMutationVariables = Exact<{
  input: UpdateRightsToWorkInput;
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type UpdateRightsToWorkMutation = { updateRightsToWork: { viewer: { _id: string, rightsToWork: Array<{ id: string, isDeprecated: boolean | null, verificationUrl: string | null, country: { countryCode: string, name: string }, type2: { id: string, formattedDescription: string } | null, credential: { expiryFormatted: string, status: CredentialStatus | null, manageVerificationUrl: string, verification: { result: string } } | null }> } | null } };

export type GetRightToWorkOptionsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnified: Scalars['Boolean'];
}>;


export type GetRightToWorkOptionsQuery = { rightToWorkOptions: Array<{ country: { countryCode: string, name: string }, options: Array<{ id: string, description: string }> }> };

export type GetSalaryPreferencesQueryVariables = Exact<{
  countryCode: Scalars['CountryCodeIso2'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
}>;


export type GetSalaryPreferencesQuery = { viewer: { _id: string, salaryPreferences2: Array<{ id: string, currencyCode: string, description: string | null, amount: any | null, salaryType: SalaryType2, country: { countryCode: string, name: string } }> } | null };

export type UpdateSalaryPreferencesMutationVariables = Exact<{
  input: UpdateSalaryPreferencesInput;
  countryCode: Scalars['CountryCodeIso2'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
}>;


export type UpdateSalaryPreferencesMutation = { updateSalaryPreferences: { viewer: { _id: string, salaryPreferences2: Array<{ id: string, currencyCode: string, description: string | null, amount: any | null, salaryType: SalaryType2, country: { countryCode: string, name: string } }> } | null } };

export type GetWorkTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkTypesQuery = { viewer: { _id: string, workTypes: Array<{ id: number }> } | null };

export type UpdatePreferredWorkTypesMutationVariables = Exact<{
  workTypesData: UpdatePreferredWorkTypesInput;
}>;


export type UpdatePreferredWorkTypesMutation = { updatePreferredWorkTypes: { viewer: { _id: string, workTypes: Array<{ id: number }> } | null } | null };

export type GetWorkTypeOptionsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetWorkTypeOptionsQuery = { workTypeOptions: Array<{ id: number, description: string }> };

export type GetPersonalDetailsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
  countryCode: Scalars['CountryCodeIso2'];
  zone: Scalars['Zone'];
}>;


export type GetPersonalDetailsQuery = { viewer: { _id: string, emailAddress: any, personalDetails: { firstName: string | null, lastName: string | null, phoneNumber: string | null, nationality: { id: string } | null, countryCallingCode: { id: string } | null, defaultCountryCallingCode: { id: string } }, currentLocation2: { id: number, description: string, shortDescription: string, kind: string, countryCode: string, isDeprecated: boolean | null } | null } | null };

export type UpdatePersonalDetailsMutationVariables = Exact<{
  personalDetailsData: UpdatePersonalDetailsInput;
  currentLocation2Data: UpdateCurrentLocation2Input;
  countryCode: Scalars['CountryCodeIso2'];
  zone: Scalars['Zone'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']>;
}>;


export type UpdatePersonalDetailsMutation = { updatePersonalDetails: { viewer: { _id: string, personalDetails: { firstName: string | null, lastName: string | null, phoneNumber: string | null, nationality: { id: string } | null, countryCallingCode: { id: string } | null, defaultCountryCallingCode: { id: string } } } | null } | null, updateCurrentLocation2: { viewer: { _id: string, currentLocation2: { id: number, description: string, shortDescription: string, kind: string, countryCode: string, isDeprecated: boolean | null } | null, salaryPreferences2: Array<{ id: string, currencyCode: string, description: string | null, amount: any | null, salaryType: SalaryType2, country: { countryCode: string, name: string } }>, rightsToWork: Array<{ id: string, isDeprecated: boolean | null, verificationUrl: string | null, country: { countryCode: string, name: string }, type2: { id: string, formattedDescription: string } | null, credential: { expiryFormatted: string, status: CredentialStatus | null, manageVerificationUrl: string, verification: { result: string } } | null }>, preferredLocations2: Array<{ id: number, shortDescription: string, description: string, countryCode: string, kind: string, isDeprecated: boolean | null }> } | null } | {} };

export type GetProfileInsightsQueryVariables = Exact<{
  zone: Scalars['Zone'];
  languageCode: Scalars['LanguageCodeIso'];
  timezone: InputMaybe<Scalars['Timezone']>;
}>;


export type GetProfileInsightsQuery = { viewer: { _id: string, profileInsights: { searchImpressionCount: number, viewCount: number, activities: Array<{ __typename: 'ProfileInsightsJobSentActivity', date: string, advertiser: { id: string, name: string }, job: { id: string, title: string, url: string } } | { __typename: 'ProfileInsightsMessageSentActivity', date: string, advertiser: { id: string, name: string } } | { __typename: 'ProfileInsightsResumeDownloadedActivity', date: string, advertiser: { id: string, name: string } }> } | null } | null };

export type GetProfileVisibilityQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetProfileVisibilityQuery = { viewer: { _id: string, profileVisibility: { level: VisibilityLevel } | null } | null };

export type UpdateProfileVisibilityMutationVariables = Exact<{
  profileVisibility: UpdateProfileVisibilityInput;
}>;


export type UpdateProfileVisibilityMutation = { updateProfileVisibility: { viewer: { _id: string, profileVisibility: { level: VisibilityLevel } | null } | null } };

export type GetShareableProfileSettingsQueryVariables = Exact<{
  zone: Scalars['Zone'];
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetShareableProfileSettingsQuery = { viewer: { _id: string, shareableProfileSettings: { profileSlug: string | null, active: boolean | null, views: number | null, url: string | null, displayUrl: string | null } } | null };

export type CreateShareableProfileSettingsMutationVariables = Exact<{
  zone: Scalars['Zone'];
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type CreateShareableProfileSettingsMutation = { createShareableProfileSettings: { error: { message: string } } | { viewer: { _id: string, shareableProfileSettings: { profileSlug: string | null, active: boolean | null, views: number | null, url: string | null, displayUrl: string | null } } | null } };

export type UpdateShareableProfileSettingsMutationVariables = Exact<{
  active: Scalars['Boolean'];
  zone: Scalars['Zone'];
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type UpdateShareableProfileSettingsMutation = { updateShareableProfileSettings: { error: { message: string } } | { viewer: { _id: string, shareableProfileSettings: { profileSlug: string | null, active: boolean | null, views: number | null, url: string | null, displayUrl: string | null } } | null } };

export type SetDefaultResumeMutationVariables = Exact<{
  resumeId: SetDefaultResumeInput;
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type SetDefaultResumeMutation = { setDefaultResume: { viewer: { _id: string, resumes: Array<{ id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } }> } | null } | null };

export type DeleteResumeMutationVariables = Exact<{
  resumeId: DeleteResumeInput;
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type DeleteResumeMutation = { deleteResume: { ref: string | null, viewer: { _id: string, resumes: Array<{ id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } }> } | null } | null };

export type ProcessUploadedResumeMutationVariables = Exact<{
  resumeData: ProcessUploadedResumeInput;
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type ProcessUploadedResumeMutation = { processUploadedResume: { resume: { id: string }, viewer: { _id: string, resumes: Array<{ id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } }> } | null } | null };

export type DocumentDownloadLinkQueryVariables = Exact<{
  resourceId: Scalars['ID'];
  resumeId: Scalars['UUID'];
}>;


export type DocumentDownloadLinkQuery = { viewer: { documentDownloadLink: { link: string } | null, resume: { id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } } | null } | null };

export type GetResumeByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetResumeByIdQuery = { viewer: { resume: { id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } } | null } | null };

export type GetResumesQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetResumesQuery = { viewer: { _id: string, resumes: Array<{ id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } }> } | null };

export type GetResumePrivacyDisclaimersQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
  isUnifiedSite: Scalars['Boolean'];
}>;


export type GetResumePrivacyDisclaimersQuery = { resumePrivacyDisclaimers: { shortParagraphs: Array<{ value: string, isEmphasized: boolean }>, longParagraphs: Array<{ value: string, isEmphasized: boolean }> } };

export type ReportProfileMutationVariables = Exact<{
  report: ReportProfileInput;
}>;


export type ReportProfileMutation = { reportProfile: { error: { message: string } } | { ref: string } };

export type GetShareableProfileQueryVariables = Exact<{
  slug: Scalars['String'];
  zone: Scalars['Zone'];
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetShareableProfileQuery = { shareableProfile: { id: string | null, active: boolean, summary: string | null, personalDetails: { firstName: string | null, lastName: string | null }, roles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }>, qualifications: Array<{ id: string, completed: boolean, isVerified: boolean, highlights: string | null, name: { text: string }, institute: { text: string }, completionDate: { month: number, year: number } | { year: number } | null }>, licences: Array<{ id: string, issuingOrganisation: string | null, noExpiryDate: boolean, description: string | null, formattedDate: string | null, isVerified: boolean, name: { text: string, ontologyId: string | null }, issueDate: { month: number, year: number } | null, expiryDate: { month: number, year: number } | null }>, skills: Array<{ keyword: { text: string } }>, languageProficiencies: Array<{ id: string, name: { text: string, ontologyId: string | null } }>, verifiedIdentity: { name: string | null, isMatchingProfileName: boolean | null } | null } };

export type UpdateShareableProfileViewsMutationVariables = Exact<{
  slug: Scalars['String'];
}>;


export type UpdateShareableProfileViewsMutation = { updateShareableProfileViews: { error: { message: string } } | { ref: string } };

export type GetSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkillsQuery = { viewer: { _id: string, skills: Array<{ keyword: { text: string, ontologyId: string | null } }> } | null };

export type GetSuggestedSkillsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso'];
  zone: Scalars['Zone'];
}>;


export type GetSuggestedSkillsQuery = { viewer: { _id: string, suggestedSkills: Array<{ keyword: { text: string, ontologyId: string | null } }> } | null };

export type UpdateSkillsMutationVariables = Exact<{
  skillsData: UpdateSkillsInput;
}>;


export type UpdateSkillsMutation = { updateSkills: { viewer: { _id: string, skills: Array<{ keyword: { text: string, ontologyId: string | null } }> } | null } | null };

export type GetSuggestionsQueryVariables = Exact<{
  zone: Scalars['Zone'];
  languageCode: Scalars['LanguageCodeIso'];
}>;


export type GetSuggestionsQuery = { viewer: { _id: string, profileSuggestions: Array<{ message: string, trackingNudgeType: string, action: { label: string, trackingCallToAction: string, context: { __typename: 'ProfileSuggestionAvailabilityActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionCareerHistoryActionContext', card: string | null, field: string | null, itemId: string | null, mode: string | null } | { __typename: 'ProfileSuggestionClassificationActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionEducationActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionLanguagesActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionLicencesActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionPersonalDetailsActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionPersonalSummaryActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionProfileVisibilityActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionResumeActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionRightToWorkActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionSalaryActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionSkillsActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionWorkTypeActionContext', card: string | null, field: string | null, mode: string | null } | null } | null }> | null } | null };

export type GetCareerObjectivesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCareerObjectivesQuery = { viewer: { _id: string, careerObjectives: { personalStatement: string } | null } | null };

export type UpdateCareerObjectivesMutationVariables = Exact<{
  careerObjectivesData: UpdateCareerObjectivesInput;
}>;


export type UpdateCareerObjectivesMutation = { updateCareerObjectives: { viewer: { _id: string, careerObjectives: { personalStatement: string } | null } | null } | null };

export type GetScoreQueryVariables = Exact<{
  zone: InputMaybe<Scalars['Zone']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']>;
  isUnifiedSite: InputMaybe<Scalars['Boolean']>;
}>;


export type GetScoreQuery = { viewer: { _id: string, score: { progress: number, tips: Array<{ label: string, description: string, score: number, action: { card: string, field: string | null, mode: string | null, item: string | null } }> } } | null };

export type GetVerificationsQueryVariables = Exact<{
  zone: Scalars['Zone'];
  locale: Scalars['Locale'];
}>;


export type GetVerificationsQuery = { viewer: { _id: string, profileVerifications: { verified: Array<{ label: string, credentials: Array<{ label: string, credentialType: string, credentialInfo: Array<{ name: string, values: Array<string> }> }> | null }> | null, verifiable: Array<{ label: string, pendingCount: number | null, credentials: Array<{ __typename: 'IdentityVerifiableCredential', label: string, url: string } | { __typename: 'LicenceVerifiableCredential', label: string, url: string, verificationMessage: string | null, trackingEntityName: string | null } | { __typename: 'WorkplaceVerifiableCredential', label: string, url: string }> | null }> | null, nudge: { __typename: 'VerifiableCredentialNudge2', credential: { __typename: 'IdentityVerifiableCredential', label: string, url: string } | { __typename: 'LicenceVerifiableCredential' } | { __typename: 'WorkplaceVerifiableCredential', label: string, url: string } } | { __typename: 'VerificationsOpenDetailsNudge', ref: string } | null } | null } | null };

export type GetIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdQuery = { viewer: { _id: string } | null };

export type GetUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDetailsQuery = { viewer: { _id: string, trackingId: string, externalId: string | null } | null };


export const GetDocumentUploadDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentUploadData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentUploadFormData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentUploadDataQuery, GetDocumentUploadDataQueryVariables>;
export const HasResumeBeenParsedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasResumeBeenParsed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contextId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contextType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnconfirmedContextType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unconfirmedDataForContext"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contextId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contextId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contextType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contextType"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnconfirmedDataPending"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnconfirmedDataCompleted"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<HasResumeBeenParsedQuery, HasResumeBeenParsedQueryVariables>;
export const GetYearsOfExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetYearsOfExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newToWorkforce"}}]}}]}}]}}]} as unknown as DocumentNode<GetYearsOfExperienceQuery, GetYearsOfExperienceQueryVariables>;
export const UpdateYearsOfExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateYearsOfExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newToWorkforce"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateYearsOfExperience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newToWorkforce"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newToWorkforce"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newToWorkforce"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateYearsOfExperienceMutation, UpdateYearsOfExperienceMutationVariables>;
export const GetConfirmedRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConfirmedRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetConfirmedRolesQuery, GetConfirmedRolesQueryVariables>;
export const GetUnconfirmedRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnconfirmedRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUnconfirmedRolesQuery, GetUnconfirmedRolesQueryVariables>;
export const UpdateRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const ConfirmRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmRoleMutation, ConfirmRoleMutationVariables>;
export const RejectRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RejectUnconfirmedDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectUnconfirmedData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RejectRoleMutation, RejectRoleMutationVariables>;
export const GenerateResumeFromProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateResumeFromProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateResumeFromProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GenerateResumeFromProfileMutation, GenerateResumeFromProfileMutationVariables>;
export const GetUnconfirmedQualificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnconfirmedQualifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUnconfirmedQualificationsQuery, GetUnconfirmedQualificationsQueryVariables>;
export const GetConfirmedQualificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConfirmedQualifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetConfirmedQualificationsQuery, GetConfirmedQualificationsQueryVariables>;
export const GetJobsDbConfirmedQualificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobsDbConfirmedQualifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"level2"}}]}}]}}]}}]} as unknown as DocumentNode<GetJobsDbConfirmedQualificationsQuery, GetJobsDbConfirmedQualificationsQueryVariables>;
export const UpdateQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateQualificationMutation, UpdateQualificationMutationVariables>;
export const UpdateQualificationJobsDbDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQualificationJobsDb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"level2"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateQualificationJobsDbMutation, UpdateQualificationJobsDbMutationVariables>;
export const DeleteQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualificationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteQualificationMutation, DeleteQualificationMutationVariables>;
export const DeleteQualificationJobsDbDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteQualificationJobsDb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualificationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"level2"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteQualificationJobsDbMutation, DeleteQualificationJobsDbMutationVariables>;
export const ConfirmQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmQualificationMutation, ConfirmQualificationMutationVariables>;
export const ConfirmQualificationJobsDbDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmQualificationJobsDb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"level2"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"level2"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmQualificationJobsDbMutation, ConfirmQualificationJobsDbMutationVariables>;
export const RejectQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RejectUnconfirmedDataInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectUnconfirmedData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RejectQualificationMutation, RejectQualificationMutationVariables>;
export const UpdateVerifiedQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVerifiedQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"verifiedQualificationData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateVerifiedQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVerifiedQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verifiedQualificationData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateVerifiedQualificationMutation, UpdateVerifiedQualificationMutationVariables>;
export const GetLanguageProficienciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLanguageProficiencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"languageProficiencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLanguageProficienciesQuery, GetLanguageProficienciesQueryVariables>;
export const UpdateLanguageProficiencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLanguageProficiency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateLanguageProficiencyInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLanguageProficiencyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLanguageProficiency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateLanguageProficiencyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageProficiencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLanguageProficiencyMutation, UpdateLanguageProficiencyMutationVariables>;
export const DeleteLanguageProficiencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLanguageProficiency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteLanguageProficiencyInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteLanguageProficiencyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLanguageProficiency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteLanguageProficiencyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageProficiencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteLanguageProficiencyMutation, DeleteLanguageProficiencyMutationVariables>;
export const GetLicencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLicences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"licences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issuingOrganisation"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDate"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMessage"}},{"kind":"Field","name":{"kind":"Name","value":"credentialType"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expiryStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLicencesQuery, GetLicencesQueryVariables>;
export const DeleteLicenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLicence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteLicenceInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteLicenceInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLicence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteLicenceInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"licences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issuingOrganisation"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDate"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMessage"}},{"kind":"Field","name":{"kind":"Name","value":"credentialType"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expiryStatus"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteLicenceMutation, DeleteLicenceMutationVariables>;
export const UpdateLicenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLicence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licenceData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLicenceInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLicence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licenceData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"licences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issuingOrganisation"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDate"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMessage"}},{"kind":"Field","name":{"kind":"Name","value":"credentialType"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expiryStatus"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLicenceMutation, UpdateLicenceMutationVariables>;
export const UpdateVerifiedLicenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVerifiedLicence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"verifiedLicenceData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateVerifiedLicenceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVerifiedLicence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verifiedLicenceData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UpdateVerifiedLicenceMutation, UpdateVerifiedLicenceMutationVariables>;
export const GetApproachabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApproachability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"approachability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approachable"}}]}}]}}]}}]} as unknown as DocumentNode<GetApproachabilityQuery, GetApproachabilityQueryVariables>;
export const UpdateApproachabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateApproachability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approachability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateApproachabilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateApproachability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approachability"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"approachability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approachable"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateApproachabilityMutation, UpdateApproachabilityMutationVariables>;
export const GetAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetAvailabilityQuery, GetAvailabilityQueryVariables>;
export const UpdateAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAvailabilityInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availability"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>;
export const GetAvailabilityOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailabilityOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availabilityOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetAvailabilityOptionsQuery, GetAvailabilityOptionsQueryVariables>;
export const GetPreferredClassificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPreferredClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPreferredClassificationQuery, GetPreferredClassificationQueryVariables>;
export const UpdatePreferredClassificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePreferredClassification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClassificationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreferredClassification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePreferredClassificationMutation, UpdatePreferredClassificationMutationVariables>;
export const GetClassificationOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClassificationOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferredClassificationOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subClassifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetClassificationOptionsQuery, GetClassificationOptionsQueryVariables>;
export const GetPreferredLocations2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPreferredLocations2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLocations2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}}]}}]}}]}}]} as unknown as DocumentNode<GetPreferredLocations2Query, GetPreferredLocations2QueryVariables>;
export const UpdatePreferredLocations2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePreferredLocations2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePreferredLocations2Input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCodeIso2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreferredLocations2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePreferredLocations2Success"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLocations2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salaryPreferences2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rightsToWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePreferredLocations2Mutation, UpdatePreferredLocations2MutationVariables>;
export const GetSupportedCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupportedCountries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportedCountries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSupportedCountriesQuery, GetSupportedCountriesQueryVariables>;
export const GetRightsToWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRightsToWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"rightsToWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRightsToWorkQuery, GetRightsToWorkQueryVariables>;
export const UpdateRightsToWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRightsToWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRightsToWorkInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRightsToWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"rightsToWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRightsToWorkMutation, UpdateRightsToWorkMutationVariables>;
export const GetRightToWorkOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRightToWorkOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnified"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rightToWorkOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnified"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnified"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetRightToWorkOptionsQuery, GetRightToWorkOptionsQueryVariables>;
export const GetSalaryPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSalaryPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCodeIso2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}},"defaultValue":{"kind":"StringValue","value":"en","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"salaryPreferences2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryType"}}]}}]}}]}}]} as unknown as DocumentNode<GetSalaryPreferencesQuery, GetSalaryPreferencesQueryVariables>;
export const UpdateSalaryPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSalaryPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSalaryPreferencesInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCodeIso2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}},"defaultValue":{"kind":"StringValue","value":"en","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSalaryPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"salaryPreferences2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSalaryPreferencesMutation, UpdateSalaryPreferencesMutationVariables>;
export const GetWorkTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"workTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkTypesQuery, GetWorkTypesQueryVariables>;
export const UpdatePreferredWorkTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePreferredWorkTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workTypesData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePreferredWorkTypesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreferredWorkTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workTypesData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"workTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePreferredWorkTypesMutation, UpdatePreferredWorkTypesMutationVariables>;
export const GetWorkTypeOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkTypeOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workTypeOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetWorkTypeOptionsQuery, GetWorkTypeOptionsQueryVariables>;
export const GetPersonalDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPersonalDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCodeIso2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"personalDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"nationality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCallingCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultCountryCallingCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentLocation2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonalDetailsQuery, GetPersonalDetailsQueryVariables>;
export const UpdatePersonalDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePersonalDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personalDetailsData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePersonalDetailsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentLocation2Data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCurrentLocation2Input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCodeIso2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}},"defaultValue":{"kind":"StringValue","value":"en","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersonalDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personalDetailsData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"personalDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"nationality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCallingCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultCountryCallingCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateCurrentLocation2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentLocation2Data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCurrentLocation2Success"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"currentLocation2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salaryPreferences2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rightsToWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredLocations2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePersonalDetailsMutation, UpdatePersonalDetailsMutationVariables>;
export const GetProfileInsightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfileInsights"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Timezone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileInsights"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchImpressionCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewCount"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}}]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileInsightsJobSentActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}]}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileInsightsMessageSentActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileInsightsResumeDownloadedActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProfileInsightsQuery, GetProfileInsightsQueryVariables>;
export const GetProfileVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfileVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileVisibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}}]}}]} as unknown as DocumentNode<GetProfileVisibilityQuery, GetProfileVisibilityQueryVariables>;
export const UpdateProfileVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfileVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileVisibility"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProfileVisibilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfileVisibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileVisibility"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileVisibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProfileVisibilityMutation, UpdateProfileVisibilityMutationVariables>;
export const GetShareableProfileSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShareableProfileSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"shareableProfileSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileSlug"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"views"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetShareableProfileSettingsQuery, GetShareableProfileSettingsQueryVariables>;
export const CreateShareableProfileSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShareableProfileSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShareableProfileSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateShareableProfileSettingsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"shareableProfileSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileSlug"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"views"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateShareableProfileSettingsFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateShareableProfileSettingsMutation, CreateShareableProfileSettingsMutationVariables>;
export const UpdateShareableProfileSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShareableProfileSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShareableProfileSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShareableProfileSettingsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"shareableProfileSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileSlug"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"views"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShareableProfileSettingsFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateShareableProfileSettingsMutation, UpdateShareableProfileSettingsMutationVariables>;
export const SetDefaultResumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetDefaultResume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetDefaultResumeInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setDefaultResume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetDefaultResumeMutation, SetDefaultResumeMutationVariables>;
export const DeleteResumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteResume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteResumeInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteResume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteResumeMutation, DeleteResumeMutationVariables>;
export const ProcessUploadedResumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProcessUploadedResume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessUploadedResumeInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processUploadedResume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProcessUploadedResumeMutation, ProcessUploadedResumeMutationVariables>;
export const DocumentDownloadLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentDownloadLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentDownloadLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"resourceType"},"value":{"kind":"EnumValue","value":"Resume"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentDownloadLinkQuery, DocumentDownloadLinkQueryVariables>;
export const GetResumeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResumeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetResumeByIdQuery, GetResumeByIdQueryVariables>;
export const GetResumesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResumes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetResumesQuery, GetResumesQueryVariables>;
export const GetResumePrivacyDisclaimersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResumePrivacyDisclaimers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resumePrivacyDisclaimers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortParagraphs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"isEmphasized"}}]}},{"kind":"Field","name":{"kind":"Name","value":"longParagraphs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"isEmphasized"}}]}}]}}]}}]} as unknown as DocumentNode<GetResumePrivacyDisclaimersQuery, GetResumePrivacyDisclaimersQueryVariables>;
export const ReportProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReportProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"report"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"report"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportProfileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportProfileFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReportProfileMutation, ReportProfileMutationVariables>;
export const GetShareableProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getShareableProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareableProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profileSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"personalDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}}]}},{"kind":"Field","name":{"kind":"Name","value":"licences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issuingOrganisation"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDate"}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"languageProficiencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"verifiedIdentity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isMatchingProfileName"}}]}}]}}]}}]} as unknown as DocumentNode<GetShareableProfileQuery, GetShareableProfileQueryVariables>;
export const UpdateShareableProfileViewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShareableProfileViews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShareableProfileViews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profileSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShareableProfileViewsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShareableProfileViewsFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateShareableProfileViewsMutation, UpdateShareableProfileViewsMutationVariables>;
export const GetSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSkills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSkillsQuery, GetSkillsQueryVariables>;
export const GetSuggestedSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSuggestedSkills"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedSkills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSuggestedSkillsQuery, GetSuggestedSkillsQueryVariables>;
export const UpdateSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSkills"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skillsData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSkillsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSkills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skillsData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSkillsMutation, UpdateSkillsMutationVariables>;
export const GetSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionPersonalDetailsActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionCareerHistoryActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"itemId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionProfileVisibilityActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionResumeActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionEducationActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionSalaryActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionRightToWorkActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionSkillsActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionLicencesActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionLanguagesActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionPersonalSummaryActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionAvailabilityActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionClassificationActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionWorkTypeActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingCallToAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingNudgeType"}}]}}]}}]}}]} as unknown as DocumentNode<GetSuggestionsQuery, GetSuggestionsQueryVariables>;
export const GetCareerObjectivesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCareerObjectives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"careerObjectives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personalStatement"}}]}}]}}]}}]} as unknown as DocumentNode<GetCareerObjectivesQuery, GetCareerObjectivesQueryVariables>;
export const UpdateCareerObjectivesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCareerObjectives"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careerObjectivesData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCareerObjectivesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCareerObjectives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careerObjectivesData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"careerObjectives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personalStatement"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCareerObjectivesMutation, UpdateCareerObjectivesMutationVariables>;
export const GetScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"tips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"item"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetScoreQuery, GetScoreQueryVariables>;
export const GetVerificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVerifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locale"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileVerifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"credentialType"}},{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"verifiable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdentityVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkplaceVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LicenceVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMessage"}},{"kind":"Field","name":{"kind":"Name","value":"trackingEntityName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nudge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifiableCredentialNudge2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdentityVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkplaceVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerificationsOpenDetailsNudge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVerificationsQuery, GetVerificationsQueryVariables>;
export const GetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetIdQuery, GetIdQueryVariables>;
export const GetUserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}}]}}]} as unknown as DocumentNode<GetUserDetailsQuery, GetUserDetailsQueryVariables>;